import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import React from 'react';
import { getAttributes } from '@carbon/icon-helpers';
import PropTypes from 'prop-types';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var defaultStyle = {
  willChange: 'transform'
};
var Icon = React.forwardRef(function Icon(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      tabIndex = _ref.tabIndex,
      rest = _objectWithoutProperties(_ref, ["className", "children", "style", "tabIndex"]);

  var _getAttributes = getAttributes(_objectSpread2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes.tabindex,
      props = _objectWithoutProperties(_getAttributes, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (ref) {
    props.ref = ref;
  }

  props.style = _objectSpread2({}, defaultStyle, {}, style);
  return React.createElement('svg', props, children);
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  'aria-hidden': PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Icon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ActiveServer =
/*#__PURE__*/
React.forwardRef(function ActiveServer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.443 20.635l-1.932-.518M11 24H9M11.443 27.364l-1.932.518M36.557 27.364l1.932.518M37 24h2M36.557 20.635l1.932-.518M32 39H16V9h16V39zM20 13h8M20 16h8M20 19h8"
  }), props.children);
});
var Advocate =
/*#__PURE__*/
React.forwardRef(function Advocate(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,39 c0-6.871,5.229-12.624,11.636-14.143c-2.9-1.291-4.924-4.192-4.924-7.57C15.712,12.71,19.423,9,24,9s8.288,3.71,8.288,8.287 c0,3.379-2.025,6.28-4.924,7.57C33.77,26.376,39,32.129,39,39 M23.999,38.001l3.962-3.962c0.451-0.451,0.681-1.038,0.692-1.629 c0.011-0.619-0.22-1.242-0.692-1.714c-0.462-0.462-1.067-0.692-1.672-0.692c-0.605,0-1.21,0.231-1.672,0.692l-0.619,0.619 l-0.619-0.619c-0.463-0.463-1.07-0.694-1.676-0.692c-0.604,0.001-1.207,0.232-1.667,0.692c-0.464,0.464-0.695,1.074-0.692,1.682 c0.003,0.602,0.233,1.202,0.692,1.661L23.999,38.001z"
  }), props.children);
});
var Agriculture =
/*#__PURE__*/
React.forwardRef(function Agriculture(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21.186,17.796 c0.659,0.659,0.779,1.623,0.497,2.39c-0.766,0.283-1.73,0.163-2.39-0.497c-0.659-0.659-0.779-1.623-0.497-2.39 C19.563,17.017,20.527,17.137,21.186,17.796z M23.319,33.72c-0.283,0.766-0.163,1.73,0.497,2.39 c0.659,0.659,1.623,0.779,2.39,0.497c0.283-0.766,0.163-1.73-0.497-2.39C25.049,33.557,24.086,33.437,23.319,33.72z M24.906,29.397c0.766,0.283,1.73,0.163,2.39-0.497c0.659-0.659,0.779-1.623,0.497-2.39c-0.766-0.283-1.73-0.163-2.39,0.497 C24.743,27.667,24.623,28.631,24.906,29.397z M19.733,28.055c-0.626,0.524-1.002,1.42-0.759,2.32s1.02,1.484,1.825,1.621 c0.626-0.524,1.002-1.42,0.759-2.32S20.538,28.191,19.733,28.055z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24.059,16.347h10.497 c0.793-0.005,1.443,0.644,1.443,1.437v0c0,0.793-0.649,1.443-1.443,1.443H24.059 M24.059,22.112h8.71 c0.793,0,1.443-0.649,1.443-1.443v0c0-0.793-0.649-1.443-1.443-1.443h-8.71 M24.059,16.347h8.71 c0.793-0.005,1.443-0.654,1.443-1.448v0c0-0.793-0.649-1.443-1.443-1.443l-13.751,0l2.531-1.69c0.664-0.466,0.92-0.839,0.92-1.39 c0-0.668-0.461-1.378-1.374-1.378c-0.446,0-0.826,0.119-1.327,0.401l-3.577,2.033c-3.328,1.918-5.193,4.041-5.193,7.666 c0,3.699,2.794,5.879,5.708,5.879v0.02h14.926c0.793,0,1.443-0.649,1.443-1.443v0c0-0.793-0.649-1.443-1.443-1.443h-7.572 M9,31 h6.999c0,4.418,3.582,8,8,8s8-3.582,8-8H39"
  }), props.children);
});
var AirConditioner =
/*#__PURE__*/
React.forwardRef(function AirConditioner(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.676,39c0-1.501-1.352-1.501-1.352-3.003c0-1.501,1.352-1.501,1.352-3.003c0-1.499-1.352-1.499-1.352-2.998 c0-1.499,1.352-1.499,1.352-2.997 M21.676,27c0,1.499-1.352,1.499-1.352,2.997c0,1.499,1.352,1.499,1.352,2.998 c0,1.501-1.352,1.501-1.352,3.003c0,1.501,1.352,1.501,1.352,3.003 M28.676,27c0,1.499-1.352,1.499-1.352,2.997 c0,1.499,1.352,1.499,1.352,2.998c0,1.501-1.352,1.501-1.352,3.003c0,1.501,1.352,1.501,1.352,3.003 M35.676,27 c0,1.499-1.352,1.499-1.352,2.997c0,1.499,1.352,1.499,1.352,2.998c0,1.501-1.352,1.501-1.352,3.003 c0,1.501,1.352,1.501,1.352,3.003 M39,23V9H9v14c0,1.105,0.895,2,2,2h26C38.105,25,39,24.105,39,23z M12,22h24 M12,19h24 M12,16h24 M32,13h4"
  }), props.children);
});
var Airplane =
/*#__PURE__*/
React.forwardRef(function Airplane(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22,13.169C22,11.762,22.592,9,24,9s2,2.762,2,4.169v5.342L37,27v4.5l-10.995-6.22L26,33.5l4,3.5v2l-6-2l-6,2v-2l4-3.5V13.169z M29,20.923V18 M32,23.335V20 M19,18v2.873L11,27v4.5l9-5.195 M16,23.175V20"
  }), props.children);
});
var Alarm =
/*#__PURE__*/
React.forwardRef(function Alarm(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.929,16.929C15.119,18.739,14,21.239,14,24c0,2.761,1.119,5.261,2.929,7.071 M13.393,13.393C10.679,16.108,9,19.858,9,24 c0,4.142,1.679,7.892,4.393,10.607 M20.453,27.547C19.544,26.639,19,25.386,19,24c0-1.385,0.544-2.641,1.451-3.549 M31.071,31.071 C32.881,29.261,34,26.761,34,24c0-2.761-1.119-5.261-2.929-7.071 M34.607,34.607C37.321,31.892,39,28.142,39,24 c0-4.142-1.679-7.892-4.393-10.607 M27.547,20.453C28.456,21.361,29,22.614,29,24c0,1.385-0.544,2.641-1.451,3.549"
  }), props.children);
});
var AlchemyDataNews =
/*#__PURE__*/
React.forwardRef(function AlchemyDataNews(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H26V23h13V39z M28,31h9 M28,27h9 M28,35h9 M16.921,18.561l-3.953,6.787c1.119,0.535,2.041,0.649,3.364,0.652l2.409-4.251 h4.967c0.62-1.07,0.963-1.889,1.07-3.188H16.921z M11.279,10.617C10.208,11.346,9.65,12.124,9,13.25l2.487,4.241l-2.47,4.258 c0.64,1.102,1.173,1.858,2.216,2.579l3.982-6.828L11.279,10.617z M24.779,16.438c-0.104-1.307-0.456-2.112-1.077-3.189h-4.972 L16.323,9h-0.002c-1.305,0-2.224,0.121-3.332,0.64l3.923,6.797L24.779,16.438z"
  }), props.children);
});
var AlchemyLanguageAlphabetAExpanded =
/*#__PURE__*/
React.forwardRef(function AlchemyLanguageAlphabetAExpanded(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25,18.561 c-0.107,1.299-0.451,2.117-1.07,3.188h-4.967L16.553,26c-1.323-0.002-2.245-0.117-3.364-0.652l3.953-6.787H25z M11.5,10.617 c-1.07,0.729-1.629,1.507-2.279,2.633l2.487,4.241l-2.47,4.258c0.64,1.102,1.173,1.858,2.216,2.579l3.982-6.828L11.5,10.617z M25,16.438c-0.104-1.307-0.456-2.112-1.077-3.189H18.95L16.543,9h-0.002c-1.305,0-2.224,0.121-3.332,0.64l3.923,6.797L25,16.438z"
  }), React.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "8",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    d: "M34.274,35h0.781l-3.711-8.859l-0.664,0L26.945,35h0.781l0.796-1.888h4.961L34.274,35z M28.826,32.392l2.185-5.183 l2.171,5.183H28.826z"
  }), props.children);
});
var AlchemyLanguage =
/*#__PURE__*/
React.forwardRef(function AlchemyLanguage(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25,18.561 c-0.107,1.299-0.451,2.117-1.07,3.188h-4.967L16.553,26c-1.323-0.002-2.245-0.117-3.364-0.652l3.953-6.787H25z M11.5,10.617 c-1.07,0.729-1.629,1.507-2.279,2.633l2.487,4.241l-2.47,4.258c0.64,1.102,1.173,1.858,2.216,2.579l3.982-6.828L11.5,10.617z M25,16.438c-0.104-1.307-0.456-2.112-1.077-3.189H18.95L16.543,9h-0.002c-1.305,0-2.224,0.121-3.332,0.64l3.923,6.797L25,16.438z"
  }), React.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "8",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.336 34.999L31.012 26.28 34.664 34.999"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.457 32.752L33.543 32.752"
  }), props.children);
});
var AlchemyVision =
/*#__PURE__*/
React.forwardRef(function AlchemyVision(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,17.999c-0.101,1.223-0.424,1.993-1.007,3h-4.675L16.05,25c-1.245-0.002-2.113-0.11-3.166-0.613l3.721-6.387H24z M11.294,10.522 C10.287,11.208,9.761,11.941,9.149,13l2.34,3.992L9.164,21c0.602,1.037,1.104,1.749,2.086,2.428l3.748-6.426L11.294,10.522z M24,16.001c-0.098-1.23-0.429-1.988-1.014-3.002h-4.68L16.041,9h-0.002c-1.228,0-2.093,0.114-3.136,0.602l3.693,6.397L24,16.001z M39,24H24v15h15V24z M33.5,26c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S34.328,26,33.5,26z M39,36.06 l-3.996-4.056l-1.957,2.047l-5.05-5.05l-3.996,3.996"
  }), props.children);
});
var Americas =
/*#__PURE__*/
React.forwardRef(function Americas(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24.096,9l2.404,4L21,19l7,12l-8.177,7.411 M16.489,36.987L19,32.5L17,28l3.608-3L18,20h-5.675l-1.667-2.862 M35.878,14.839 l-3.226,5.62L36,26h2.868 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var AmsterdamCanal =
/*#__PURE__*/
React.forwardRef(function AmsterdamCanal(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "14",
    cy: "10.5",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 34c2.761 0 5 2.239 5 5M34 39c0-2.761 2.239-5 5-5M19 39c0-2.761 2.239-5 5-5s5 2.239 5 5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 15.062H29V32H19z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 17L39 17 39 32 9 32 9 19 19 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 27H16V32H12zM14 32L14 27M11 21H13V25H11zM15 21H17V25H15zM21 27H23V30H21zM25 27H27V32H25zM25 21H27V25H25zM21 21H23V25H21zM31 25H33V30H31zM33 19H35V21H33z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 19L37 21"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 13L34 15"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 19L31 21"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 25H37V32H35zM29 23L39 23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 12L37 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 17H27V19H25zM21 17H23V19H21z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,15v-1 c0-0.552,0.448-1,1-1s1,0.448,1,1v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 19L15 14M13 14L10 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 14L13 12 15 12 15 14"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,19v-1c0-0.552,0.448-1,1-1s1,0.448,1,1 v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 12c0 0 0 3-2 5M36 12c0 0 0 3 2 5M36 12c0-1.105-.895-2-2-2s-2 .895-2 2M28 15L28 13 27 13 27 11 25.111 11 25.111 8.945 22.889 8.945 22.889 11 21 11 21 13 20 13 20 15"
  }), props.children);
});
var AmsterdamFarm =
/*#__PURE__*/
React.forwardRef(function AmsterdamFarm(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 34L28 39M37 34L37 39M16 34L16 39M23 37L23 39M13 37L13 39M10 37L10 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 36L20 38M20 31L20 33M20 26L20 28M24 31L24 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 37L25 39M33 37L33 39M35 37L35 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39L39 39M9 37L16 37"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 34L37 34M23 37c0-.552.448-1 1-1s1 .448 1 1M33 37c0-.552.448-1 1-1s1 .448 1 1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 34L33 28 29.003 28"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.353 17.355C18.126 17.857 18 18.414 18 19v2h8M25.647 17.354C25.019 15.966 23.622 15 22 15c-.587 0-1.144.126-1.646.353"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19L24 23M24 19L20 23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.813,25.25 C17.588,28.137,17.093,31.815,16,34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.742,29.744C27.032,31.351,27.437,32.874,28,34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,21 c0,0,0,1.852,0.187,4.25"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.587 8.343H18.417V19.664H15.587z",
    transform: "rotate(-45.001 17.002 14.003)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.343 14.583H34.664V17.413H23.343z",
    transform: "rotate(-45.001 29.003 15.999)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.337 24.587H20.658V27.417H9.337z",
    transform: "rotate(-45.001 14.997 26.002)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.587 22.343H28.417V33.664H25.587z",
    transform: "rotate(-45.001 27.002 28.004)"
  }), props.children);
});
var AmsterdamWindmill =
/*#__PURE__*/
React.forwardRef(function AmsterdamWindmill(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 39L33 39M21.985 33L21.985 31M21.985 38L21.985 36M26.985 30.937L26.985 33M22.027 26L22.027 28M30 34L30 39M18 34L18 39M26.985 39v-2c0-.552-.448-1-1-1s-1 .448-1 1v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.994 23.009L21.991 19.006M25.994 19.006L21.991 23.009"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.337 14.589H36.658V17.419H25.337z",
    transform: "rotate(-45.001 30.997 16.005)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.328 24.595H22.649V27.424999999999997H11.328z",
    transform: "rotate(-45.001 16.988 26.01)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.581 22.351H30.411V33.672H27.581z",
    transform: "rotate(-45.001 28.995 28.012)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.574 8.343H20.404000000000003V19.664H17.574z",
    transform: "rotate(-45.001 18.99 14.003)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.986 23.009L21.984 19.006M25.986 19.006L21.984 23.009"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.988 21.007L25.986 19.006 33.991 11.001 35.993 13.002M31.985 12.999L33.986 15M29.985 14.999L31.986 17M27.985 16.999L29.986 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.986 21L25.985 18.999"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.983 21.007L21.984 23.009 13.979 31.014 11.978 29.012M13.988 27.002L15.989 29.004M15.998 24.993L17.999 26.994M18.007 22.983L20.009 24.984M23.985 25.01L25.986 23.009 33.991 31.014 31.99 33.015M33.991 31.014L31.99 33.015M31.982 29.004L29.981 31.006M29.973 26.995L27.971 28.996M27.963 24.986L25.962 26.987M23.985 17.005L21.984 19.006 13.979 11.001 15.98 9M23.985 17.005L21.984 19.006M21.983 15.003L19.982 17.004M19.981 13.001L17.98 15.002M17.98 10.999L15.978 13.001"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.813,25.25C19.588,28.137,19.093,31.815,18,34h12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.353 17.355C20.126 17.857 20 18.414 20 19v2h8M27.647 17.354C27.019 15.966 25.622 15 24 15c-.587 0-1.144.126-1.646.353"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.742,29.744C29.032,31.351,29.437,32.874,30,34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,21 c0,0,0,1.852,0.187,4.25"
  }), props.children);
});
var Analyze =
/*#__PURE__*/
React.forwardRef(function Analyze(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,29 v10H14l-5-5V19l4.997-0.004 M24,9c-5.52,0-10,4.48-10,10s4.48,10,10,10c2.76,0,5.26-1.12,7.07-2.93S34,21.76,34,19 C34,13.48,29.52,9,24,9z M39,34l-7.933-7.933 M14,39v-5H9 M17.267,21.726l2.733-4.73l1.227,3.77l2.77-4.77l2.23,4.77l3.773-6.27"
  }), props.children);
});
var AnalyzesData =
/*#__PURE__*/
React.forwardRef(function AnalyzesData(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.12,33.894L21,27.015 M16,13l5.037,0 M24,21.015l0-5 M36,32.516l0-6.501 M27.999,35.515h5 M27,21.015h-6v6h6V21.015z M14.195,20.016l-5.196,3l3,5.196l5.196-3L14.195,20.016z M9,11.016v4l3.464,2l3.464-2v-4l-3.464-2L9,11.016z M25.999,32.051h-4 l-2,3.464l2,3.464h4l2-3.464L25.999,32.051z M35.499,10.016l-3.464,6l6.928,0L35.499,10.016z M24,10.016c-1.657,0-3,1.343-3,3 s1.343,3,3,3s3-1.343,3-3S25.656,10.016,24,10.016z M35.999,32.516c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3 C38.999,33.859,37.656,32.516,35.999,32.516z M12.002,32.549c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S13.659,32.549,12.002,32.549z M36,22.014c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2c1.105,0,2-0.895,2-2 C38,22.909,37.104,22.014,36,22.014z"
  }), props.children);
});
var Apartment =
/*#__PURE__*/
React.forwardRef(function Apartment(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22,39h-4v-8h4V39z M22,9v12H10v18h28V9H22z M26,15v-2 M26,21v-2 M14,27v-2 M34,15v-2 M34,21v-2 M22,27v-2 M30,15v-2 M30,21v-2 M34,27v-2 M34,33v-2 M30,27v-2 M30,33v-2 M18,27v-2 M14,33v-2 M26,27v-2 M26,33v-2"
  }), props.children);
});
var Api =
/*#__PURE__*/
React.forwardRef(function Api(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(14 23.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M39,9H9v23h30 V9z"
  }), props.children);
});
var AppDeveloper =
/*#__PURE__*/
React.forwardRef(function AppDeveloper(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 14L12.518 15.519 11 17M36.245 23.758L34.505 25.499 34.499 28"
  }), React.createElement("path", {
    d: "M11.5,10.5c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5S10.724,10,11,10S11.5,10.224,11.5,10.5z M13,10 c-0.276,0-0.5,0.224-0.5,0.5S12.724,11,13,11s0.5-0.224,0.5-0.5S13.276,10,13,10z M15,10c-0.276,0-0.5,0.224-0.5,0.5 S14.724,11,15,11s0.5-0.224,0.5-0.5S15.276,10,15,10z M26,14c-0.276,0-0.5,0.224-0.5,0.5S25.724,15,26,15s0.5-0.224,0.5-0.5 S26.276,14,26,14z M28,14c-0.276,0-0.5,0.224-0.5,0.5S27.724,15,28,15s0.5-0.224,0.5-0.5S28.276,14,28,14z M30,14 c-0.276,0-0.5,0.224-0.5,0.5S29.724,15,30,15s0.5-0.224,0.5-0.5S30.276,14,30,14z M13,32c-0.276,0-0.5,0.224-0.5,0.5 S12.724,33,13,33s0.5-0.224,0.5-0.5S13.276,32,13,32z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,22V9h12v13H9z M21,12H9 M13.001,18h3.008 M11.5,27h3 M11.5,29h3 M27.489,30H39V13H24v10.998 M24,16h15 M9.998,31.017h6 M15.999,25.584 c0-0.323-0.262-0.584-0.584-0.584h-4.832c-0.323,0-0.584,0.262-0.584,0.584v7.832c0,0.323,0.262,0.584,0.584,0.584h4.832 c0.323,0,0.584-0.262,0.584-0.584V25.584z M34.505,23c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5c1.381,0,2.5-1.119,2.5-2.5 S35.885,23,34.505,23z M26,18h4 M33,18h4 M26,20h4 M26,22h4 M33,20h4 M31,39l-0.002-0.522c0-3.3-2.287-6.06-5.36-6.799 c1.4-0.628,2.378-2.028,2.378-3.662C28.017,25.797,26.219,24,24,24s-4.02,1.797-4.02,4.017c0,1.634,0.979,3.033,2.379,3.662 c-3.073,0.739-5.36,3.499-5.36,6.799L17,39"
  }), props.children);
});
var Apple =
/*#__PURE__*/
React.forwardRef(function Apple(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.014,21.016c0,0,2.214,0.926,1,8 M32.283,32.298l0.37-1.282 M22.016,18.016c-1.596-0.152-3.35-1-5.002-1c-4.641,0-6,4.056-6,8 c0,8.646,4.001,14,7.989,14c1.674,0,3.561-1,5.013-1h-0.004c1.454,0,3.336,1,5.012,1c3.991-0.001,7.99-5.393,7.99-14 c0-3.926-1.355-8-6-8c-2.26,0-4.473,0.97-6.745,0.999l-0.255,0.001v-2.745c0,0,6.73,0.468,8-5c0,0-5.21-1.555-8.003,3 M20.513,10.516c-1.656-1.656-4.497-1.499-4.497-1.499s-0.157,2.842,1.499,4.497s4.497,1.499,4.497,1.499 S22.169,12.172,20.513,10.516z"
  }), props.children);
});
var Application =
/*#__PURE__*/
React.forwardRef(function Application(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M37,11.5c0,0.276-0.224,0.5-0.5,0.5S36,11.776,36,11.5s0.224-0.5,0.5-0.5S37,11.224,37,11.5z M34.5,11 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.776,11,34.5,11z M32.5,11c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S32.776,11,32.5,11z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,38H9V10h30V38z M9,13h30 M17,13v25"
  }), props.children);
});
var Archive =
/*#__PURE__*/
React.forwardRef(function Archive(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M40,18H10v-8h30V18z M12,18v21c0,0.552,0.448,1,1,1h24c0.552,0,1-0.448,1-1V18 M30,23L30,23c0-1.1-0.9-2-2-2h-6c-1.1,0-2,0.9-2,2v0 c0,1.1,0.9,2,2,2h6C29.1,25,30,24.1,30,23z"
  }), props.children);
});
var AsiaAustralia =
/*#__PURE__*/
React.forwardRef(function AsiaAustralia(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39.008,24.008c0,8.284-6.716,15-15,15s-15-6.716-15-15s6.716-15,15-15S39.008,15.724,39.008,24.008z M9.309,27.014l1.692-1l1-4 l2-1l2,5l5,2l1-3l-3-2l2-2h5l3-7l-3-4.874 M24.002,30.014h-2l1,2h3l1-4.073l-1-0.927L24.002,30.014z M35.966,32.981l-1.964-1.966 l-5,1.011l-1,1.989l-3,3l-0.994,1.994"
  }), props.children);
});
var AugmentedReality =
/*#__PURE__*/
React.forwardRef(function AugmentedReality(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,16l7-4l7,4v8l-7,4 l-7-4V16z M23,16l7,4l7-4 M30,20v8 M30,12V9H12v30h18V28 M12,32h18"
  }), React.createElement("circle", {
    cx: "21",
    cy: "35.5",
    r: "1"
  }), props.children);
});
var Austin =
/*#__PURE__*/
React.forwardRef(function Austin(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 22L39 22M9 26L39 26M9 28L39 28M16 32c0-2.209 1.791-4 4-4s4 1.791 4 4M24 32c0-2.209 1.791-4 4-4s4 1.791 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,32c0-2.209,1.791-4,4-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,28c2.209,0,4,1.791,4,4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 34L26 34M18 38L22 38M26 38L30 38M30 34L36 34M12 34L18 34M14 36L34 36M16 32L16 34M24 32L24 34M32 32L32 34M12 22L12 26M16 22L16 26M20 22L20 26M24 22L24 26M28 22L28 26M32 22L32 26M36 22L36 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 30c-.123.123-.229.263-.317.415-.087.15-.154.311-.199.482-.044.165-.07.338-.07.517-.174 0-.348.024-.517.07-.167.045-.329.111-.482.2C26.267 31.769 26.127 31.873 26 32M29 19c-.123.123-.229.263-.317.415-.087.15-.154.311-.199.482-.044.165-.07.338-.07.517-.174 0-.348.024-.517.07-.167.045-.329.111-.482.2C27.267 20.769 27.127 20.873 27 21M24 14c-.123.123-.229.263-.317.415-.087.15-.154.311-.199.482-.044.165-.07.338-.07.517-.174 0-.348.024-.517.07-.167.045-.329.111-.482.2C22.267 15.769 22.127 15.873 22 16M25 17c-.123.123-.229.263-.317.415-.087.15-.154.311-.199.482-.044.165-.07.338-.07.517-.174 0-.348.024-.517.07-.167.045-.329.111-.482.2C23.267 18.769 23.127 18.873 23 19M30 9c.123.123.229.263.317.415.087.15.154.311.199.482.044.165.07.338.07.517.174 0 .348.024.517.07.167.045.329.111.482.2C31.733 10.769 31.873 10.873 32 11M24 11c.123.123.229.263.317.415.087.15.154.311.199.482.044.165.07.338.07.517.174 0 .348.024.517.07.167.045.329.111.482.2C25.733 12.769 25.873 12.873 26 13M19 12c.123.123.229.263.317.415.087.15.154.311.199.482.044.165.07.338.07.517.174 0 .348.024.517.07.167.045.329.111.482.2C20.733 13.769 20.873 13.873 21 14M20 16c.123.123.229.263.317.415.087.15.154.311.199.482.044.165.07.338.07.517.174 0 .348.024.517.07.167.045.329.111.482.2C21.733 17.769 21.873 17.873 22 18"
  }), props.children);
});
var AutomateModularManagement =
/*#__PURE__*/
React.forwardRef(function AutomateModularManagement(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.999 27.659c-4.782 2.761-10.897 1.122-13.658-3.66s-1.122-10.897 3.66-13.658 10.897-1.122 13.658 3.66S28.781 24.898 23.999 27.659zM26.5 25.623v-8M21.558 11.816l6.928 4M20.986 9.193l-6.928 4M11.5 12.377v8M9.514 22.184l6.928 4M17.014 28.807l6.928-4M16.5 31v4M26.5 29v6M36.5 35V19.981L31.337 17M16.5 39c-1.104 0-2-.896-2-2 0-1.104.896-2 2-2 1.105 0 2 .896 2 2C18.5 38.104 17.605 39 16.5 39zM28.5 37c0-1.104-.895-2-2-2-1.104 0-2 .896-2 2 0 1.104.896 2 2 2C27.605 39 28.5 38.104 28.5 37zM38.5 37c0-1.104-.895-2-2-2-1.104 0-2 .896-2 2 0 1.104.896 2 2 2C37.605 39 38.5 38.104 38.5 37z"
  }), props.children);
});
var Automobile =
/*#__PURE__*/
React.forwardRef(function Automobile(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36,34H12c-1.105,0-2-0.895-2-2v-8c0-1.105,0.895-2,2-2h24c1.105,0,2,0.895,2,2v8C38,33.105,37.105,34,36,34z M11,34v4h3v-4 M34,34v4h3v-4 M15,25c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S16.105,25,15,25z M33,25c-1.105,0-2,0.895-2,2s0.895,2,2,2 c1.105,0,2-0.895,2-2S34.105,25,33,25z M36,22l-2.786-9.287C33.087,12.29,32.698,12,32.256,12H15.744 c-0.442,0-0.831,0.29-0.958,0.713L12,22 M14.5,14h19 M30,20l-3-3.964 M31,18.18l-2-2.68"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,26h10 M19,28h10 M10,32h28 M11,20v-3 M37,20v-3"
  }), props.children);
});
var Bag =
/*#__PURE__*/
React.forwardRef(function Bag(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,39H11c-1.105,0-2-0.895-2-2V19h30v18C39,38.105,38.105,39,37,39z M30,15c0-3.314-2.686-6-6-6s-6,2.686-6,6 M18,15v4 M30,15v4 M9,31h30"
  }), props.children);
});
var Bangalore =
/*#__PURE__*/
React.forwardRef(function Bangalore(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "14",
    cy: "18",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34",
    cy: "18",
    r: ".5"
  }), React.createElement("circle", {
    cx: "14",
    cy: "30",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34",
    cy: "30",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "26.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "10",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 20L20 20M25 20v-3c0-.552-.448-1-1-1s-1 .448-1 1v3M25 14v-1c0-.552-.448-1-1-1s-1 .448-1 1v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 36L36 36M16 38L32 38M38 34L10 34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 28L18 36M16 28L16 36M22 36L22 28 22 26 24 24 26 26 26 28 26 36M30 28L30 36M28 28L28 36M20 28L20 36M32 28L32 36M36 26L36 34M12 26L12 34M28 22L20 22 18 20 30 20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 26L38 26 36 24 30 24 34 28 14 28 18 24 12 24 10 26 22 26M28 20v-2c0-2.209-1.791-4-4-4s-4 1.791-4 4v2M36 24v-2c0-1.105-.895-2-2-2s-2 .895-2 2v2M16 24v-2c0-1.105-.895-2-2-2s-2 .895-2 2v2M20 22L20 26M28 26L28 22"
  }), props.children);
});
var Bee =
/*#__PURE__*/
React.forwardRef(function Bee(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.868,23.007c-1.773-0.996-2.393-3.222-1.385-4.974c0.739-1.283,2.149-1.953,3.547-1.828l8.345,0.794l-6.148,5.493 c-0.021,0.02-0.043,0.038-0.065,0.057l-0.004,0.004l0,0C14.009,23.571,12.285,23.804,10.868,23.007z M33.542,35.456 c1.792,0.961,4.036,0.306,5.009-1.464c0.715-1.297,0.547-2.833-0.298-3.94l-5.086-6.581l-1.482,8.055 c-0.006,0.029-0.011,0.057-0.016,0.085l-0.001,0.005l0,0C31.4,33.119,32.11,34.687,33.542,35.456z M22.048,19.991l-1.144,2.031 l8.19,4.497l1.144-2.031L22.048,19.991z M28.538,17.986L28.538,17.986c-1.609-0.883-3.516-0.73-4.937,0.235l7.34,4.03 C31.022,20.55,30.147,18.869,28.538,17.986z M18.632,26.056l8.19,4.496l1.144-2.031l-8.19-4.496L18.632,26.056z M20.332,32.558 L20.332,32.558c1.609,0.883,3.516,0.731,4.937-0.235l-7.34-4.03C17.848,29.994,18.723,31.675,20.332,32.558z M28.808,14.513 c0.441-0.784,0.155-1.772-0.638-2.208c-0.794-0.436-1.794-0.153-2.236,0.63c-0.441,0.784-0.156,1.773,0.638,2.208 C27.366,15.579,28.367,15.297,28.808,14.513z M34.256,17.504c0.441-0.784,0.155-1.772-0.638-2.208 c-0.794-0.436-1.794-0.153-2.236,0.63c-0.441,0.784-0.156,1.773,0.638,2.208C32.814,18.57,33.815,18.288,34.256,17.504z"
  }), props.children);
});
var BeijingMunicipal =
/*#__PURE__*/
React.forwardRef(function BeijingMunicipal(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 26L11 23M13 26L13 23M24 26L24 24M19 26L19 24M29 26L29 24M27 26L27 23M15 26L15 23M17 26L17 23M21 26L21 23M31 26L31 23M33 26L33 23M35 26L35 23M37 26L37 23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 18h26v-1c-2 0-5-2-6-4H17c-1 2-4 4-6 4V18zM34 20L34 18M14.042 20L14.042 18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 30L25 30M25 32L27 32M27 32L25 32M25 34L28 34M28 34L25 34M25 36L29 36M29 36L25 36M25 38L30 38M32 30L28 30M29 32L33 32M30 34L35 34M31 36L37 36M32 38L39 38M22 30L25 30M23 32L21 32M21 32L25 32M23 34L20 34M20 34L25 34M23 36L19 36M19 36L25 36M25 38L18 38M16 30L20 30M19 32L15 32M18 34L13 34M17 36L11 36M16 38L9 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 13L17 11M31 13L31 11M39 28L9 28M39 26L9 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,22v1h30v-1c-2,0-4-1-5-2H14C13,21,11,22,9,22z"
  }), props.children);
});
var BeijingTower =
/*#__PURE__*/
React.forwardRef(function BeijingTower(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19L24 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 39L20.032 19 30.032 19 35 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9L16 11 9 39 39 39 33 15z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.25 19L19 32 29 32 29.032 32 25.782 19"
  }), props.children);
});
var BerlinBrandenburg =
/*#__PURE__*/
React.forwardRef(function BerlinBrandenburg(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 36L39 36M9 18L39 18M20 16L28 16M11 14L37 14M9 20L39 20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 22L21 36M19 22L19 36M17 22L17 36M15 22L15 36M13 22L13 36M11 22L11 36M37 22L37 36M13 14L13 18M35 14L35 18M35 22L35 36M33 22L33 36M31 22L31 36M29 22L29 36M27 22L27 36"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 22L39 22M20 10c2.209 0 4 1.791 4 4M28 10c-2.209 0-4 1.791-4 4M28 12c-1.105 0-2 .895-2 2M20 12c1.105 0 2 .895 2 2"
  }), props.children);
});
var BerlinCathedral =
/*#__PURE__*/
React.forwardRef(function BerlinCathedral(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 39V18c0-3.314 2.686-6 6-6s6 2.686 6 6v21M10 36V18c0-1.657 1.343-3 3-3s3 1.343 3 3v18M32 36V18c0-1.657 1.343-3 3-3s3 1.343 3 3v18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 18L16 18M32 18L38 18M10 24L38 24M18 18L30 18M20 32L28 32"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,39v-7c0-2.209,1.791-4,4-4s4,1.791,4,4v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 31L13 28 16 31M32 31L35 28 38 31M22 14c0-1.105.895-2 2-2s2 .895 2 2M22 14L22 18M26 14L26 18M24 9L24 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 36L12 32 14 32 14 36M34 36L34 32 36 32 36 36M23 39L23 34 25 34 25 39"
  }), React.createElement("circle", {
    cx: "24",
    cy: "27",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 24L23 21 24 20 25 21 25 24"
  }), React.createElement("circle", {
    cx: "13",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.5",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "27.5",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "35",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "35",
    cy: "13",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13",
    cy: "13",
    r: ".5"
  }), props.children);
});
var BerlinTower =
/*#__PURE__*/
React.forwardRef(function BerlinTower(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 16H25V18H23z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 12L25 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 28H25V30H23z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 30H26V32H22z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 32H25V34H23z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 34H26V36H22zM22 14H26V16H22z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 24L28 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9L24 14M24 36L24 39M26 36L26 39M22 36L22 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 18c0-1.105.895-2 2-2s2 .895 2 2M10 20c-.552 0-1-.448-1-1s.448-1 1-1M14 18c0-.552.448-1 1-1s1 .448 1 1M17 18c.552 0 1 .448 1 1s-.448 1-1 1M17 18L16 18M17 20L10 20M31 28c0-1.105.895-2 2-2 1.105 0 2 .895 2 2M31 30c-.552 0-1-.448-1-1s.448-1 1-1M35 28c0-.552.448-1 1-1s1 .448 1 1M38 28c.552 0 1 .448 1 1s-.448 1-1 1M38 28L37 28M38 30L31 30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,20.555V18h-4v2.555 c-1.191,0.693-2,1.968-2,3.445c0,2.209,1.791,4,4,4s4-1.791,4-4C28,22.523,27.191,21.248,26,20.555z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,20.555 C25.41,20.211,24.732,20,24,20s-1.41,0.211-2,0.555"
  }), props.children);
});
var Bicycle =
/*#__PURE__*/
React.forwardRef(function Bicycle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,29c0,2.761-2.239,5-5,5s-5-2.239-5-5s2.239-5,5-5S19,26.239,19,29z M24,27c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2 S25.105,27,24,27z M34,24c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S36.761,24,34,24z M14,29h8 M19,20.339h10 M14,29l5-8.66 M34,29l-8.083-14 M15.917,15L23,27.268 M25,27.268l4-6.928 M14,15h4 M25.918,15H31"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,19 c1.105,0,2-0.895,2-2s-0.895-2-2-2"
  }), props.children);
});
var Blockchain =
/*#__PURE__*/
React.forwardRef(function Blockchain(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,16h-6v-6h6V16z M38,10h-6v6h6V10z M27,10h-6v6h6V10z M16,32h-6v6h6V32z M38,32h-6v6h6V32z M27,32h-6v6h6V32z M16,21h-6v6h6V21z M38,21h-6v6h6V21z M27,21h-6v6h6V21z M16,13h5 M16,24h5 M16,35h5 M27,13h5 M27,24h5 M27,35h5 M13,32v-5 M24,32v-5 M35,32v-5 M13,21v-5 M24,21v-5 M35,21v-5"
  }), props.children);
});
var Build =
/*#__PURE__*/
React.forwardRef(function Build(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.002,23.995 c0,1.657-1.343,3-3,3s-3-1.343-3-3c0-1.657,1.343-3,3-3S27.002,22.338,27.002,23.995z M23.998,9C23.169,9,22.5,9.667,22.5,10.495 S23.169,12,23.998,12s1.502-0.676,1.502-1.505S24.826,9,23.998,9z M17.002,31c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4 S19.211,31,17.002,31z M29.407,17.495v3l2.598,1.5l2.598-1.5v-3l-2.598-1.5L29.407,17.495z M33.005,28.995L39,32.5v-7 L33.005,28.995z M11.126,23.874L9,26l2.126,2.117l2.121-2.121L11.126,23.874z M24.005,14.995v6 M19.149,31.622l2.308-3.627 M10.251,29.996c0.385,0.881,0.852,1.717,1.391,2.5 M21.505,38.788c0.812,0.136,1.647,0.207,2.498,0.207 c4.907,0,9.264-2.356,12.001-6 M39,22.995c-0.448-6.807-5.467-12.373-11.995-13.699 M22.006,16.246 c-3.453,0.887-6.004,4.02-6.004,7.749c0,1.457,0.39,2.823,1.07,4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.02,2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.035 22.997c.447-6.8 5.425-12.363 11.944-13.697M32.002 23.995c0 4.418-3.582 8-8 8-.69 0-1.359-.087-1.998-.251"
  }), props.children);
});
var Building =
/*#__PURE__*/
React.forwardRef(function Building(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,9 h30 M27,39v-8h-6v8 M11,11v28 M37,11v28 M9,39h30 M14,13v2 M14,19v2 M14,25v2 M19,13v2 M19,19v2 M19,25v2 M24,13v2 M24,19v2 M24,25 v2 M29,13v2 M29,19v2 M29,25v2 M34,13v2 M34,19v2 M34,25v2"
  }), props.children);
});
var Bulldozer =
/*#__PURE__*/
React.forwardRef(function Bulldozer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.5,9c0,0.992,0.819,1.258,1.617,1.258h0.013c0.993,0,1.37,0.943,1.37,1.742v1.75c0,0.992,0.702,1.25,1.5,1.25 M25,12.002 v-1.495C25,9.71,24.493,9,23.5,9 M20.505,12v0.75c0,0.798,0.502,1.495,1.495,1.495"
  }), React.createElement("path", {
    d: "M13,36c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S13,35.448,13,36z M16.5,35c-0.552,0-1,0.448-1,1s0.448,1,1,1 c0.552,0,1-0.448,1-1S17.052,35,16.5,35z M21,35c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S21.552,35,21,35z M25.5,35 c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S26.052,35,25.5,35z M30,35c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1 S30.552,35,30,35z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,33v-2H9V19 M13,25 v-6 M19,19v6 M28,25v-9.998L26,15 M39,23c-3.382,3.382-3.382,8.618,0,12 M36.905,26.21h-2.794c-1.542,1.542-1.542,4.038,0,5.58 h2.792 M30,29h3 M21,17H9v2h12V17z M33,36L33,36c0-1.65-1.35-3-3-3H12c-1.65,0-3,1.35-3,3v0c0,1.65,1.35,3,3,3h18 C31.65,39,33,37.65,33,36z M30,33v-6.308C30,25.759,29.249,25,28.316,25H9 M17,27h2"
  }), props.children);
});
var Bus =
/*#__PURE__*/
React.forwardRef(function Bus(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,35H13 c-1.105,0-2-0.895-2-2V11c0-1.105,0.895-2,2-2h22c1.105,0,2,0.895,2,2v22C37,34.105,36.105,35,35,35z M12,35v4h3v-4 M33,35v4h3v-4 M15,28c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S16.105,28,15,28z M33,28c-1.105,0-2,0.895-2,2s0.895,2,2,2 c1.105,0,2-0.895,2-2S34.105,28,33,28z M19,29h10 M19,31h10 M30,21.464l-4-6.928 M31,18.732l-2-3.464 M9,19v-6 M39,19v-6 M11,12h26 M11,24h26"
  }), props.children);
});
var Cafe =
/*#__PURE__*/
React.forwardRef(function Cafe(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,34h-6 c-2.209,0-4-1.791-4-4v-8h14v8C31,32.209,29.209,34,27,34z M31,30h2c1.105,0,2-0.895,2-2v-2c0-1.105-0.895-2-2-2h-2 M20,20v-1.283 c0-0.472,0.11-0.937,0.321-1.359v0c0.428-0.855,0.428-1.862,0-2.717v0C20.11,14.22,20,13.754,20,13.283V13 M28,20v-1.283 c0-0.472,0.11-0.937,0.321-1.359v0c0.428-0.855,0.428-1.862,0-2.717v0C28.11,14.22,28,13.754,28,13.283V13 M24,19v-1.283 c0-0.472,0.11-0.937,0.321-1.359v0c0.428-0.855,0.428-1.862,0-2.717v0C24.11,13.22,24,12.754,24,12.283V12 M14,36h20"
  }), props.children);
});
var CalendarDate =
/*#__PURE__*/
React.forwardRef(function CalendarDate(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "16",
    transform: "translate(15.432 31.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38,39H10V12h28V39z M16,15V9 M32,15V9"
  }), props.children);
});
var CalendarEvent =
/*#__PURE__*/
React.forwardRef(function CalendarEvent(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,12h8 M14,12h-4v27h28V12h-4 M22,20h-8v4h8V20z M32,14v-4c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h0 C31.553,15,32,14.552,32,14z M18,14v-4c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h0 C17.552,15,18,14.552,18,14z M22,29h-8v4h8V29z M34,20h-8v4h8V20z M34,29h-8v4h8V29z"
  }), props.children);
});
var Calendar =
/*#__PURE__*/
React.forwardRef(function Calendar(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38,39 H10V12h28V39z M16,15V9 M24,15V9 M32,15V9 M25,19h-2v2h2V19z M25,26h-2v2h2V26z M25,33h-2v2h2V33z M17,19h-2v2h2V19z M17,26h-2v2h2 V26z M17,33h-2v2h2V33z M33,19h-2v2h2V19z M33,26h-2v2h2V26z M33,33h-2v2h2V33z"
  }), props.children);
});
var Camera =
/*#__PURE__*/
React.forwardRef(function Camera(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 V13h30V39z M24,13V9H12v4 M24,20c-3.866,0-7,3.134-7,7s3.134,7,7,7s7-3.134,7-7S27.866,20,24,20z M28,16h8"
  }), props.children);
});
var Capitol =
/*#__PURE__*/
React.forwardRef(function Capitol(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,38 v-3 M20,38v-3 M13,38v-3 M28,38v-3 M35,38v-3 M24,33v-3 M20,33v-3 M13,33v-3 M28,33v-3 M35,33v-3 M24,25v-2 M21,25v-2 M18,21h12 M27,25v-2 M9,39h30 M16,28h-6v11h6V28z M38,28h-6v11h6V28z M32,27H16v12h16V27z M24,12h3v-2h-3V12v3 M30,25v-4 c0-3.314-2.686-6-6-6s-6,2.686-6,6v4"
  }), props.children);
});
var Care =
/*#__PURE__*/
React.forwardRef(function Care(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M21.5,12c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5S21.5,11.724,21.5,12z M24,11.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S24.276,11.5,24,11.5z M27,11.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S27.276,11.5,27,11.5z M21,14.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S21.276,14.5,21,14.5z M24,14.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 S24.276,14.5,24,14.5z M27,14.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S27.276,14.5,27,14.5z M21,17.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S21.276,17.5,21,17.5z M24,17.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S24.276,17.5,24,17.5z M27,17.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S27.276,17.5,27,17.5z M11.5,21c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 C11.724,20.5,11.5,20.724,11.5,21z M14.5,21c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 C14.724,20.5,14.5,20.724,14.5,21z M14.5,24c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 C14.724,23.5,14.5,23.724,14.5,24z M11.5,24c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 C11.724,23.5,11.5,23.724,11.5,24z M11.5,27c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 C11.724,26.5,11.5,26.724,11.5,27z M14.5,27c0,0.276,0.224,0.5,0.5,0.5c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 C14.724,26.5,14.5,26.724,14.5,27z M32.5,21c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5S32.5,20.724,32.5,21 z M35.5,21c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5S35.5,20.724,35.5,21z M35.5,24 c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5S35.5,23.724,35.5,24z M32.5,24c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5S32.5,23.724,32.5,24z M32.5,27c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 s-0.224-0.5-0.5-0.5S32.5,26.724,32.5,27z M35.5,27c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5 S35.5,26.724,35.5,27z M21,29.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S21.276,29.5,21,29.5z M24,29.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S24.276,29.5,24,29.5z M27,29.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S27.276,29.5,27,29.5z M27,32.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S27.276,32.5,27,32.5z M24,32.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 S24.276,32.5,24,32.5z M21,32.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S21.276,32.5,21,32.5z M21,35.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S21.276,35.5,21,35.5z M24,35.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S24.276,35.5,24,35.5z M27,35.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S27.276,35.5,27,35.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,39h-8 c-1.1,0-2-0.9-2-2V11c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v26C30,38.1,29.1,39,28,39z M18,18h-7c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2 h7 M30,30h7c1.1,0,2-0.9,2-2v-8c0-1.1-0.9-2-2-2h-7 M21,21h6 M21,24h6 M21,27h6"
  }), props.children);
});
var Cell =
/*#__PURE__*/
React.forwardRef(function Cell(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24 c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M32.502,16.618c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1 s1-0.448,1-1C33.502,17.066,33.054,16.618,32.502,16.618z M21.985,23c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2 c1.105,0,2-0.895,2-2C23.985,23.895,23.089,23,21.985,23z M21.985,21c2.337,0,3.686-1,5-1.723 M29,22.733 c-1.143,0.862-2.546,1.915-3.331,3.83 M21.985,21c-2.209,0-4,1.791-4,4s1.791,4,4,4c1.657,0,3.078-1.007,3.686-2.443 M22.134,11.001L22.134,11.001c-0.275,0.476-0.11,1.091,0.366,1.366l2.598,1.5c0.476,0.275,1.091,0.11,1.366-0.366v0 c0.275-0.476,0.11-1.091-0.366-1.366l-2.598-1.5C23.023,10.36,22.409,10.525,22.134,11.001z M11.038,20.619L11.038,20.619 c-0.275,0.476-0.11,1.091,0.366,1.366l2.598,1.5c0.476,0.275,1.091,0.11,1.366-0.366l0,0c0.275-0.476,0.11-1.091-0.366-1.366 l-2.598-1.5C11.928,19.978,11.313,20.143,11.038,20.619z M31.537,27.001L31.537,27.001c-0.275,0.476-0.11,1.091,0.366,1.366 l2.598,1.5c0.476,0.275,1.091,0.11,1.366-0.366v0c0.275-0.476,0.11-1.091-0.366-1.366l-2.598-1.5 C32.427,26.36,31.812,26.525,31.537,27.001z M13.635,30.118L13.635,30.118c-0.275,0.476-0.11,1.091,0.366,1.366l2.598,1.5 c0.476,0.275,1.091,0.11,1.366-0.366h0c0.275-0.476,0.11-1.091-0.366-1.366l-2.598-1.5C14.525,29.477,13.91,29.641,13.635,30.118z M19.501,14.155L19.501,14.155c-0.476-0.275-1.091-0.11-1.366,0.366l-1.5,2.598c-0.275,0.476-0.11,1.091,0.366,1.366l0,0 c0.476,0.275,1.091,0.11,1.366-0.366l1.5-2.598C20.142,15.045,19.977,14.43,19.501,14.155z M36.001,19.752L36.001,19.752 c-0.476-0.275-1.091-0.11-1.366,0.366l-1.5,2.598c-0.275,0.476-0.11,1.091,0.366,1.366l0,0c0.476,0.275,1.091,0.11,1.366-0.366 l1.5-2.598C36.642,20.641,36.477,20.027,36.001,19.752z M29,32.133L29,32.133c-0.476-0.275-1.091-0.11-1.366,0.366l-1.5,2.598 c-0.275,0.476-0.11,1.091,0.366,1.366l0,0c0.476,0.275,1.091,0.11,1.366-0.366l1.5-2.598C29.641,33.023,29.476,32.408,29,32.133z M29,22.733c0.598-0.346,1-0.992,1-1.732c0-1.105-0.895-2-2-2c-0.371,0-0.718,0.101-1.015,0.277"
  }), props.children);
});
var ChartBar =
/*#__PURE__*/
React.forwardRef(function ChartBar(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39h-6V9h6V39z M15,33H9v6h6V33z M27,21h-6v18h6V21z"
  }), props.children);
});
var ChartBubbleLine =
/*#__PURE__*/
React.forwardRef(function ChartBubbleLine(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,26c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2S17.105,26,16,26z M18,24c0-1.105-0.895-2-2-2s-2,0.895-2,2s0.895,2,2,2 S18,25.105,18,24z M9,9v30h30.04 M35,16h4 M9,24h5 M22.62,30.551l-5.17-5.17 M32.21,17.831l-7.19,12.45 M26,32c0-1.105-0.895-2-2-2 s-2,0.895-2,2c0,1.105,0.895,2,2,2S26,33.105,26,32z M35,16c0-1.105-0.895-2-2-2c-1.105,0-2,0.895-2,2s0.895,2,2,2 C34.105,18,35,17.105,35,16z"
  }), props.children);
});
var ChartLine =
/*#__PURE__*/
React.forwardRef(function ChartLine(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9V9 M39,16.763l-6.426,11.13L26,16l-5.123,15.588L16,24L9,39"
  }), props.children);
});
var ChartScatterplot =
/*#__PURE__*/
React.forwardRef(function ChartScatterplot(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,9v30 M39,24L9,24"
  }), React.createElement("path", {
    d: "M32,11c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S32.552,11,32,11z M33,38c0-0.552-0.448-1-1-1s-1,0.448-1,1 s0.448,1,1,1S33,38.552,33,38z M33,19c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1S33,19.552,33,19z M33,31c0-0.552-0.448-1-1-1 s-1,0.448-1,1s0.448,1,1,1S33,31.552,33,31z M37,31c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1S37,31.552,37,31z M13,31 c0-0.552-0.448-1-1-1c-0.552,0-1,0.448-1,1s0.448,1,1,1C12.552,32,13,31.552,13,31z M13,19c0-0.552-0.448-1-1-1 c-0.552,0-1,0.448-1,1s0.448,1,1,1C12.552,20,13,19.552,13,19z M17,19c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1 S17,19.552,17,19z M17,10c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1S17,10.552,17,10z"
  }), props.children);
});
var Cherries =
/*#__PURE__*/
React.forwardRef(function Cherries(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,27.999c2.294,1,2.771,3.729,2,5.917 M18.5,26.499c2.5-4.5,4.5-7.5,6.5-14.5 M25,11.999c1,7,2.5,11,4.5,15.599 M24.396,28.597 M23.599,32.049c0,3.45,2.401,6.95,6.95,6.95c4.45,0,7.45-3,7.45-6.95c0-3.451-2-6.05-5.5-6.05c-1.205,0-2.326,0.508-3,1.599 c-0.587-0.34-1-0.599-2.023-0.599C25,26.999,23.599,29.499,23.599,32.049z M20,33.999c0.708-0.771,1-1.986,1-3c0-1-0.289-2.272-1-3 M17.5,9C15,9,12,9.999,10,11.999c2,2,5,3,7.5,3c3.5,0,5.5-1,7.5-3C23,9.999,21,9,17.5,9z M24.394,28.598 c-0.795-2.099-3.618-3.549-5.894-2.099c0,0-0.961-1.038-2.5-1.038c-3,0-5,2.038-5,6.038c0,4.501,2.5,7.5,7,7.5c3,0,5-1.499,6-4"
  }), props.children);
});
var ChipCircuit =
/*#__PURE__*/
React.forwardRef(function ChipCircuit(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".851",
    d: "M35,35H13V13h22V35z M29,19H19v10h10V19z M32,11V9 M28,11V9 M24,11V9 M16,11V9 M20,11V9 M32,39v-2 M28,39v-2 M24,39v-2 M16,39v-2 M20,39v-2 M11,16H9 M11,20H9 M11,24H9 M11,32H9 M11,28H9 M39,16h-2 M39,20h-2 M39,24h-2 M39,32h-2 M39,28h-2"
  }), props.children);
});
var ChipCredit =
/*#__PURE__*/
React.forwardRef(function ChipCredit(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,36H11c-1.1,0-2-0.9-2-2V14c0-1.1,0.9-2,2-2h26c1.1,0,2,0.9,2,2v20C39,35.1,38.1,36,37,36z M18,36V12 M9,24h9 M9,30h9 M9,18h9 M30,30h9 M30,36V18h9 M30,24h9"
  }), props.children);
});
var ChipDebit =
/*#__PURE__*/
React.forwardRef(function ChipDebit(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".851",
    d: "M36,38H12c-1.105,0-2-0.895-2-2V12c0-1.105,0.895-2,2-2h24c1.105,0,2,0.895,2,2v24C38,37.105,37.105,38,36,38z M29,19H19v10h10V19z M38,15h-5l-4,4 M29,24h9 M24,19v-9 M24,38v-9 M19,19l-4-4h-5 M10,24h9 M10,33h5l4-4 M29,29l4,4h5"
  }), props.children);
});
var CloudAnalytics =
/*#__PURE__*/
React.forwardRef(function CloudAnalytics(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,28v-5 M30,28v-8 M22,28v-8 M18,28v-3 M12,14.992v13 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9 z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,20.008v13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M24,9 C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var CloudAssets =
/*#__PURE__*/
React.forwardRef(function CloudAssets(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,14.992v13 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,33.008v-13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M26,19h-7v7h7V19z M22,26v3h7v-7 h-3"
  }), props.children);
});
var CloudBuilderProfessionalServices =
/*#__PURE__*/
React.forwardRef(function CloudBuilderProfessionalServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.937,28.317c-0.55-0.953-0.221-2.182,0.732-2.732l5.66-3.268c0.001-1.381,0.718-2.724,2.001-3.464 c1.614-0.932,3.608-0.611,4.855,0.661l-3.355,1.937c-0.476,0.275-0.641,0.89-0.366,1.366v0c0.275,0.476,0.89,0.641,1.366,0.366 l3.355-1.937c0.478,1.716-0.241,3.603-1.855,4.535c-1.282,0.74-2.804,0.69-4.001,0l-5.66,3.268 C18.716,29.599,17.487,29.269,16.937,28.317L16.937,28.317z M12,14.992v13 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15 s15-6.716,15-15S32.284,9,24,9z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,20.008v13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var CloudComputing =
/*#__PURE__*/
React.forwardRef(function CloudComputing(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,14.992v13 M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,20.008v13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M39,24c0,8.284-6.716,15-15,15 S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z"
  }), props.children);
});
var CloudDataServices =
/*#__PURE__*/
React.forwardRef(function CloudDataServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,21.5c0,0.828-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5C17.328,20,18,20.672,18,21.5z M16.5,28v-3 M21.5,28c0.828,0,1.5-0.672,1.5-1.5S22.328,25,21.5,25S20,25.672,20,26.5S20.672,28,21.5,28z M21.5,20v3 M26.5,20 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S27.328,20,26.5,20z M26.5,28v-3 M31.5,28 c0.828,0,1.5-0.672,1.5-1.5S32.328,25,31.5,25S30,25.672,30,26.5S30.672,28,31.5,28z M31.5,20v3 M12,14.992v13 M24,9 C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,20.008v13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15 S32.284,9,24,9z"
  }), props.children);
});
var CloudDownload =
/*#__PURE__*/
React.forwardRef(function CloudDownload(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.471,28.721C11.816,28.223,9,25.047,9,21.255c0-4.138,3.355-7.493,7.493-7.493c1.007,0,1.966,0.202,2.843,0.562 C20.531,11.772,23.114,10,26.118,10c4.005,0,7.267,3.145,7.473,7.099C36.625,17.307,39,19.826,39,22.912 c0,3.222-2.589,5.817-5.811,5.817c-0.044,0-0.086-0.006-0.13-0.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,32l-6,6l-6-6 M24,21v17"
  }), props.children);
});
var CloudEcosystem =
/*#__PURE__*/
React.forwardRef(function CloudEcosystem(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,14.992v13 M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M21.457,36.388l-11.258-6.5 M22.199,38.896l11.258-6.5 M36,33.008v-13 M26.543,11.612l11.258,6.5 M14.543,15.604l11.258-6.5 M39,24c0,8.284-6.716,15-15,15 S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M21,31L21,31c-2.475,0-4.5-2.025-4.5-4.5v0c0-2.475,2.025-4.5,4.5-4.5h0 c2.475,0,4.5,2.025,4.5,4.5v0C25.5,28.975,23.475,31,21,31z M28.5,21.5L28.5,21.5c0-2.475-2.025-4.5-4.5-4.5h0 c-2.475,0-4.5,2.025-4.5,4.5v0c0,2.475,2.025,4.5,4.5,4.5h0C26.475,26,28.5,23.975,28.5,21.5z M31.5,26.5L31.5,26.5 c0-2.475-2.025-4.5-4.5-4.5h0c-2.475,0-4.5,2.025-4.5,4.5v0c0,2.475,2.025,4.5,4.5,4.5h0C29.475,31,31.5,28.975,31.5,26.5z"
  }), props.children);
});
var CloudGuidelines =
/*#__PURE__*/
React.forwardRef(function CloudGuidelines(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.648,18.196l-6.5,11.258l-2.797,1.849l0.199-3.349l6.5-11.258L28.648,18.196z M12,14.992v13 M39,24c0,8.284-6.716,15-15,15 S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M21.457,36.388l-11.258-6.5 M33.457,32.396l-11.258,6.5 M36,20.008v13 M26.543,11.612l11.258,6.5 M14.543,15.604l11.258-6.5 M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24 z"
  }), props.children);
});
var CloudManagedServices =
/*#__PURE__*/
React.forwardRef(function CloudManagedServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.5,25.5H18v-3h4.5l0-4.5h3l0,4.5H30v3h-4.5l0,4.5h-3L22.5,25.5z M12,14.992v13 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15 s15-6.716,15-15S32.284,9,24,9z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,20.008v13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var CloudOracle =
/*#__PURE__*/
React.forwardRef(function CloudOracle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,16.295v6 M36,31L36,31c0-1.65-1.35-3-3-3h-4c-1.65,0-3,1.35-3,3v0c0,1.65,1.35,3,3,3h4C34.65,34,36,32.65,36,31z M39,23H23v16 h16V23z M17,9c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S21.418,9,17,9z M19.389,11.451l5.196,3 M18.585,9.157l-5.196,3 M11,11.705v6 M14.611,22.549l-5.196-3 M20.611,21.843l-5.196,3"
  }), props.children);
});
var CloudPartners =
/*#__PURE__*/
React.forwardRef(function CloudPartners(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.161,30.353c1.381,0,2.5,1.119,2.5,2.5c0,1.381-1.119,2.5-2.5,2.5s-2.5-1.119-2.5-2.5C12.661,31.473,13.78,30.353,15.161,30.353 z M22.232,38.268c0.976,0.976,2.559,0.976,3.536,0s0.976-2.559,0-3.536s-2.559-0.976-3.536,0S21.256,37.291,22.232,38.268z M32.839,35.353c1.381,0,2.5-1.119,2.5-2.5c0-1.381-1.119-2.5-2.5-2.5c-1.381,0-2.5,1.119-2.5,2.5 C30.339,34.234,31.458,35.353,32.839,35.353z M38.268,25.782c0.976-0.976,0.976-2.559,0-3.536s-2.559-0.976-3.536,0 s-0.976,2.559,0,3.536S37.291,26.759,38.268,25.782z M11.248,18.81v-6.749 M18,9c-4.971,0-9,4.029-9,9s4.029,9,9,9s9-4.029,9-9 S22.971,9,18,9z M9.481,20.878l5.844,3.374 M22.077,23.442l-5.844,3.374 M24.752,17.19v6.749 M26.519,15.122l-5.844-3.374 M19.767,9.183l-5.844,3.374 M32.5,17.5c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5c-1.381,0-2.5,1.119-2.5,2.5 S31.119,17.5,32.5,17.5z"
  }), props.children);
});
var CloudPlanning =
/*#__PURE__*/
React.forwardRef(function CloudPlanning(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.5,29h-11v-9h11V29z M21.5,19v2 M26.5,19v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,14.992v13 M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M10.199,29.888l11.258,6.5 M22.199,38.896l11.258-6.5 M36,20.008v13 M37.801,18.112l-11.258-6.5 M14.543,15.604l11.258-6.5 M39,24c0,8.284-6.716,15-15,15 S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z"
  }), props.children);
});
var CloudSap =
/*#__PURE__*/
React.forwardRef(function CloudSap(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,23.998h11L24,37.981H10v-14 M24,17.295v6 M26,18c0,4.418-3.582,8-8,8s-8-3.582-8-8s3.582-8,8-8S26,13.582,26,18z M25.585,15.451l-5.196-3 M19.585,10.157l-5.196,3 M12,12.705v6 M15.611,23.549l-5.196-3 M21.611,22.843l-5.196,3"
  }), props.children);
});
var CloudServicesPricing =
/*#__PURE__*/
React.forwardRef(function CloudServicesPricing(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,24.5v1.7 M30,34.5v2 M36.437,24.063c-3.417-3.417-8.957-3.417-12.374,0s-3.417,8.957,0,12.374s8.957,3.417,12.374,0 S39.854,27.48,36.437,24.063z M23.937,11.563c-3.417-3.417-8.957-3.417-12.374,0s-3.417,8.957,0,12.374s8.957,3.417,12.374,0 S27.354,14.98,23.937,11.563z M11.628,17.628v-6 M14.583,22.991l-5.196-3 M20.705,23.113l-5.196,3 M23.872,17.872v6 M20.917,12.509 l5.196,3 M14.795,12.387l5.196-3 M17.75,15.25v5 M20.25,17.75h-5 M33,26.5h-4c-1.105,0-2,0.895-2,2s0.895,2,2,2h2 c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2h-4"
  }), props.children);
});
var CloudServices =
/*#__PURE__*/
React.forwardRef(function CloudServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,34.385C39,36.934,36.999,39,34.384,39c-0.129,0-18.462,0-18.462,0C12.099,39,9,35.901,9,32.077S12.099,25,15.923,25 c0.402,0,0.796,0.036,1.179,0.102C18.683,22.287,21,20,25.154,20c5.346,0,9.231,4.902,9.231,10C36.999,30,39,31.836,39,34.385z M12,15H9v3h3V15z M32,15h-3v3h3V15z M20,9h-3v3h3V9z M20.5,36h-3v3h3V36z M20.5,29h-3v3h3V29z M26,29h-3v3h3V29z M32.5,36h-3v3h3 V36z M39,9h-3v3h3V9z M39,21h-3v3h3V21z"
  }), props.children);
});
var CloudStorage =
/*#__PURE__*/
React.forwardRef(function CloudStorage(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,14c0,1.657-1.343,3-3,3H18.5c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5c0.018,0,0.034,0.004,0.051,0.005 C18.518,13.842,18.5,13.673,18.5,13.5c0-1.381,1.119-2.5,2.5-2.5c0.397,0,0.768,0.101,1.101,0.266C22.43,9.966,23.598,9,25,9 c1.385,0,2.539,0.944,2.884,2.22C28.23,11.081,28.605,11,29,11C30.657,11,32,12.343,32,14z M10,34.4l0,4.4c0,0.11,0.09,0.2,0.2,0.2 l5.6,0c0.11,0,0.2-0.09,0.2-0.2l0-3.8c0-0.11-0.09-0.2-0.2-0.2h-3.3c-0.063,0-0.122-0.03-0.16-0.08l-0.28-0.44 c-0.038-0.05-0.097-0.08-0.16-0.08h-1.7C10.09,34.2,10,34.289,10,34.4z M21,34.4l0,4.4c0,0.11,0.09,0.2,0.2,0.2l5.6,0 c0.11,0,0.2-0.09,0.2-0.2l0-3.8c0-0.11-0.09-0.2-0.2-0.2h-3.3c-0.063,0-0.122-0.03-0.16-0.08l-0.28-0.44 c-0.038-0.05-0.097-0.08-0.16-0.08h-1.7C21.09,34.2,21,34.289,21,34.4z M32,34.4l0,4.4c0,0.11,0.09,0.2,0.2,0.2l5.6,0 c0.11,0,0.2-0.09,0.2-0.2l0-3.8c0-0.11-0.09-0.2-0.2-0.2h-3.3c-0.063,0-0.122-0.03-0.16-0.08l-0.28-0.44 c-0.038-0.05-0.097-0.08-0.16-0.08h-1.7C32.09,34.2,32,34.289,32,34.4z M32,21H17v4h15V21z M19,23h6 M28.083,23H30 M32,17H17v4h15 V17z M19,19h6 M28.083,19H30 M36,36h0.917 M25,36h0.917 M14,36h0.917 M25.5,28.5c0-0.828-0.672-1.5-1.5-1.5s-1.5,0.672-1.5,1.5 S23.172,30,24,30S25.5,29.328,25.5,28.5z M24,30v3 M24,27v-2 M13,33v-4.5h9.5 M25.5,28.5H35l0,4.5"
  }), props.children);
});
var CloudStrategy =
/*#__PURE__*/
React.forwardRef(function CloudStrategy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.46,28.722C11.805,28.223,9,25.047,9,21.255c0-4.138,3.343-7.493,7.482-7.493c1.007,0,1.966,0.202,2.843,0.562 C20.519,11.772,23.103,10,26.107,10c4.005,0,7.267,3.145,7.473,7.099c3.033,0.207,5.42,2.727,5.42,5.813 c0,3.222-2.6,5.817-5.822,5.817c-0.044,0-0.086-0.006-0.13-0.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 40.229v-19M29 40.229v-19M19 23.229L29 23.229M19 28.229L29 28.229M19 33.229L29 33.229M19 38.229L29 38.229"
  }), props.children);
});
var CloudTutorials =
/*#__PURE__*/
React.forwardRef(function CloudTutorials(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.961,28.08l-2.121-2.121l-1.414,1.414l-2.477-7.423l7.426,2.473l-1.414,1.414l2.121,2.121L25.961,28.08z M12,14.992v13 M24,9 C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z M21.457,36.388l-11.258-6.5 M33.457,32.396l-11.258,6.5 M36,20.008v13 M26.543,11.612l11.258,6.5 M25.801,9.104l-11.258,6.5 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15 S32.284,9,24,9z"
  }), props.children);
});
var CloudUpload =
/*#__PURE__*/
React.forwardRef(function CloudUpload(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.46,29.722C11.805,29.223,9,26.047,9,22.255c0-4.138,3.343-7.493,7.482-7.493c1.007,0,1.966,0.202,2.843,0.562 C20.519,12.772,23.103,11,26.107,11c4.005,0,7.267,3.145,7.473,7.099c3.033,0.207,5.42,2.727,5.42,5.813 c0,3.222-2.6,5.817-5.822,5.817c-0.044,0-0.086-0.006-0.13-0.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,26l6-6l6,6 M24,37V20"
  }), props.children);
});
var CloudVmware =
/*#__PURE__*/
React.forwardRef(function CloudVmware(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39h-8l8-8V39z M31,31l-8,8h8V31z M39,23l-8,8h8V23z M39,15l-8,8h8V15z M31,23l-8,8h8V23z M23,31l-8,8h8V31z M10.999,17.725v-6 M17,9c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S21.418,9,17,9z M14.627,22.559l-5.196-3 M20.628,21.834l-5.196,3 M23.001,16.275v6 M19.373,11.441l5.196,3 M13.372,12.166l5.196-3"
  }), props.children);
});
var CloudyDewy =
/*#__PURE__*/
React.forwardRef(function CloudyDewy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.999,17.5l2.598,3.501l0,0c0.255,0.441,0.403,0.953,0.403,1.5c0,1.656-1.345,2.999-3.001,2.999S20,24.157,20,22.501 c0-0.546,0.146-1.059,0.401-1.5l0,0L22.999,17.5z M22.402,34.001L22.402,34.001C22.146,34.442,22,34.955,22,35.501 c0,1.656,1.343,2.999,2.999,2.999S28,37.157,28,35.501c0-0.546-0.148-1.059-0.403-1.5l0,0L24.999,30.5L22.402,34.001z M31.402,26.001L31.402,26.001C31.146,26.442,31,26.955,31,27.501c0,1.656,1.343,2.999,2.999,2.999 c1.656,0,3.001-1.343,3.001-2.999c0-0.546-0.148-1.059-0.403-1.5l0,0L33.999,22.5L31.402,26.001z M39,20.074 c0-3.078-2.495-5.574-5.574-5.574c-0.627,0-1.458,0.108-2.02,0.299C30.24,11.804,27.335,9.5,23.927,9.5 c-4.177,0-7.606,3.537-7.992,7.613c-0.68-0.388-1.465-0.613-2.303-0.613C11.058,16.5,9,18.586,9,21.158 c0,2.573,2.058,4.309,4.631,4.342H17"
  }), props.children);
});
var CloudyHazy =
/*#__PURE__*/
React.forwardRef(function CloudyHazy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 28h15M22 24h14M22 32h14M20 36h12M9 32h7M13.631 28C11.058 27.967 9 26.231 9 23.658 9 21.086 11.058 19 13.631 19c.839 0 1.624.225 2.303.613C16.32 15.537 19.75 12 23.927 12c3.408 0 6.313 2.304 7.479 5.299C31.969 17.108 32.799 17 33.426 17 36.504 17 39 19.495 39 22.574"
  }), props.children);
});
var CloudyHumid =
/*#__PURE__*/
React.forwardRef(function CloudyHumid(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38.5,31.5c-0.951,0-1.357-0.474-2.031-1s-1.049-1-2-1s-1.326,0.474-2,1s-1.017,1-1.969,1s-1.357-0.474-2.031-1s-1.049-1-2-1 c-0.951,0-1.326,0.474-2,1s-1.017,1-1.969,1s-1.357-0.474-2.031-1s-1.049-1-2-1c-0.951,0-1.326,0.474-2,1s-1.017,1-1.969,1 s-1.357-0.474-2.031-1s-1.049-1-2-1 M10.469,35.5c0.951,0,1.326,0.474,2,1s1.08,1,2.031,1s1.294-0.474,1.969-1s1.049-1,2-1 c0.951,0,1.326,0.474,2,1s1.08,1,2.031,1s1.294-0.474,1.969-1s1.049-1,2-1c0.951,0,1.326,0.474,2,1s1.08,1,2.031,1 s1.294-0.474,1.969-1s1.049-1,2-1s1.326,0.474,2,1s1.08,1,2.031,1 M39.5,21.074c0,3.078-2.495,5.393-5.574,5.426H14.131 C11.558,26.467,9.5,24.731,9.5,22.158c0-2.573,2.058-4.658,4.631-4.658c0.839,0,1.624,0.225,2.303,0.613 c0.386-4.076,3.815-7.613,7.992-7.613c3.408,0,6.313,2.304,7.479,5.299c0.563-0.191,1.393-0.299,2.02-0.299 C37.004,15.5,39.5,17.995,39.5,21.074z"
  }), props.children);
});
var CloudyPartial =
/*#__PURE__*/
React.forwardRef(function CloudyPartial(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12.421,21.671c0-2.899,2.35-5.25,5.25-5.25c0.657,0,1.171,0.029,1.75,0.25 M17.671,14.545V13 M14.108,15.5l-0.773-1.338 M11.5,18.108l-1.338-0.773 M21.233,15.5l0.773-1.338 M10.545,21.671H9 M33.758,21.516c-0.59,0-1.155,0.102-1.684,0.282 C30.977,18.98,28.244,17,25.039,17c-3.928,0-7.154,2.98-7.517,6.813c-0.639-0.365-1.378-0.576-2.166-0.576 c-2.42,0-4.356,1.962-4.356,4.381C11,30.038,12.936,32,15.356,32h18.402C36.653,32,39,29.653,39,26.758 S36.653,21.516,33.758,21.516z"
  }), props.children);
});
var CloudyWindy =
/*#__PURE__*/
React.forwardRef(function CloudyWindy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 25.5c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3 0 1.657-1.343 3-3 3H18M32 35.5c0 1.657 1.343 3 3 3 1.657 0 3-1.343 3-3 0-1.657-1.343-3-3-3H13M17 25.5h-3.369C11.058 25.467 9 23.731 9 21.158c0-2.573 2.058-4.658 4.631-4.658.839 0 1.624.225 2.303.613C16.32 13.037 19.75 9.5 23.927 9.5c3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299 3.078 0 5.574 2.495 5.574 5.574"
  }), props.children);
});
var Cloudy =
/*#__PURE__*/
React.forwardRef(function Cloudy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,29.758C39,32.653,36.654,35,33.759,35H15.357C12.937,35,11,33.038,11,30.618c0-2.42,1.937-4.381,4.357-4.381 c0.789,0,1.527,0.211,2.166,0.576C17.886,22.979,21.112,20,25.04,20c3.205,0,5.938,1.98,7.034,4.797 c0.529-0.18,1.094-0.282,1.684-0.282C36.654,24.515,39,26.862,39,29.758z M37,22.758c0-2.895-2.346-5.242-5.241-5.242 c-0.59,0-1.155,0.102-1.684,0.282C28.978,14.98,26.246,13,23.04,13c-3.928,0-7.154,2.98-7.517,6.813 c-0.639-0.365-1.378-0.576-2.166-0.576c-2.42,0-4.357,1.962-4.357,4.381C9,24.497,9.255,25.314,9.696,26"
  }), props.children);
});
var CoatHanger =
/*#__PURE__*/
React.forwardRef(function CoatHanger(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 33.019L38 33.019C38 34.113 37.113 35 36.019 35H11.981C10.887 35 10 34.113 10 33.019v0c0-.64.309-1.24.829-1.612L24 22l13.171 9.408C37.691 31.779 38 32.38 38 33.019zM21 16c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3v3"
  }), props.children);
});
var CognosAnalytics =
/*#__PURE__*/
React.forwardRef(function CognosAnalytics(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,12 c0,1.105-0.895,2-2,2c-1.105,0-2-0.895-2-2s0.895-2,2-2C34.105,10,35,10.895,35,12z M16,16c-1.105,0-2,0.895-2,2s0.895,2,2,2 s2-0.895,2-2S17.105,16,16,16z M24,22c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S25.105,22,24,22z M16,28c-1.105,0-2,0.895-2,2 s0.895,2,2,2s2-0.895,2-2S17.105,28,16,28z M33,34c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2S34.105,34,33,34z M20,12 h9 M20,18h9 M11,24h9 M20,30h9 M20,36h9"
  }), props.children);
});
var College =
/*#__PURE__*/
React.forwardRef(function College(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,23 l0,8 M39,36H9v3h30V36z M24,9L9,21h30L24,9z M37,33H11v3h26V33z M18,21h-6v12h6V21z M33,23l0,8 M36,21h-6v12h6V21z M24,13.5 c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S25.381,13.5,24,13.5z"
  }), props.children);
});
var ConceptExpansion =
/*#__PURE__*/
React.forwardRef(function ConceptExpansion(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.999,23.998h10.005 M14,19c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S16.761,19,14,19z M39,22H29v4h10V22z M39,35H29v4h10 V35z M39,9H29v4h10V9z M29,10.998L24,11l0,26h5"
  }), props.children);
});
var ConceptInsights =
/*#__PURE__*/
React.forwardRef(function ConceptInsights(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.297,19.3l-2.714-4.75 M32.269,28.695l-2.709,4.742 M29,24.002H15.033 M34,19.003c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5 S36.761,19.003,34,19.003z M28.003,9c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S29.659,9,28.003,9z M12,21.001 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,21.001,12,21.001z M12,33c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S13.657,33,12,33z M28.003,33c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S29.659,33,28.003,33z M14.618,34.531 l14.792-8.54"
  }), props.children);
});
var Connect =
/*#__PURE__*/
React.forwardRef(function Connect(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,16 H9V9h7V16z M39,20.5h-7v7h7V20.5z M27.5,32h-7v7h7V32z M22,9v7l6-3.536L22,9z M24,20.5c-1.933,0-3.5,1.567-3.5,3.5 s1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5S25.933,20.5,24,20.5z M35.5,9c-1.933,0-3.5,1.567-3.5,3.5s1.567,3.5,3.5,3.5 s3.5-1.567,3.5-3.5S37.433,9,35.5,9z M12.5,32C10.567,32,9,33.567,9,35.5s1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5S14.433,32,12.5,32z M35.5,16v4.493 M27.5,24H32 M24,27.5V32 M16,12.5h6 M14.975,33.025l6.551-6.551 M27.493,36.5H31.5c2.209,0,4-1.791,4-4v-5.007 M12.5,16v4c0,2.209,1.791,4,4,4h4"
  }), props.children);
});
var ConsoleWireless =
/*#__PURE__*/
React.forwardRef(function ConsoleWireless(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.202,13.195 C16.048,10.591,19.839,9,24,9c4.163,0,7.955,1.592,10.801,4.198 M31.969,16.03C29.85,14.146,27.058,13,23.999,13 c-3.057,0-5.847,1.144-7.966,3.026 M29.133,18.866C27.744,17.702,25.954,17,24,17c-1.952,0-3.741,0.701-5.13,1.863"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.321,38.373C36.7,38.771,35.961,39,35.168,39c0,0-0.136,0-0.338,0c-1.062,0.001-2.084-0.42-2.834-1.17L29,34.997H19 l-3.029,2.843C15.222,38.584,14.208,39,13.153,39h-0.321c-0.793,0-1.532-0.229-2.153-0.627c-1.477-0.946-2.02-2.853-1.465-4.517 l3.162-9.487C12.647,23.552,13.411,23,14.272,23h19.455c0.861,0,1.625,0.552,1.897,1.369l3.163,9.487 C39.342,35.519,38.799,37.427,37.321,38.373z M13.998,29.5h6 M16.998,26.502v6"
  }), React.createElement("path", {
    d: "M32,27.002c0,0.552-0.448,1-1,1s-1-0.448-1-1c0-0.552,0.448-1,1-1S32,26.449,32,27.002z M31,31.001c-0.552,0-1,0.448-1,1 s0.448,1,1,1s1-0.448,1-1S31.552,31.001,31,31.001z M28.5,28.502c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1 C29.5,28.949,29.052,28.502,28.5,28.502z M33.5,28.502c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1s1-0.448,1-1 C34.5,28.949,34.053,28.502,33.5,28.502z"
  }), props.children);
});
var Console =
/*#__PURE__*/
React.forwardRef(function Console(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.321,38.371C36.7,38.769,35.961,39,35.168,39c0,0-0.136,0-0.338,0c-1.062,0.001-2.084-0.421-2.834-1.172L29,34.996H19 l-3.029,2.843C15.222,38.583,14.208,39,13.153,39h-0.321c-0.793,0-1.532-0.231-2.153-0.629c-1.477-0.946-2.02-2.853-1.465-4.517 l3.162-9.487C12.647,23.551,13.411,23,14.272,23h19.455c0.861,0,1.625,0.551,1.897,1.367l3.163,9.487 C39.342,35.518,38.799,37.426,37.321,38.371z M14,29.5h6 M17,26.5v6"
  }), React.createElement("path", {
    d: "M32,27c0,0.552-0.448,1-1,1s-1-0.448-1-1c0-0.552,0.448-1,1-1S32,26.448,32,27z M31,31c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S31.552,31,31,31z M28.5,28.5c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1 C29.5,28.948,29.052,28.5,28.5,28.5z M33.5,28.5c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1s1-0.448,1-1 C34.5,28.948,34.053,28.5,33.5,28.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,23V13 c0-2.209,1.791-4,4-4s4,1.791,4,4s-1.791,4-4,4H15"
  }), props.children);
});
var Construct =
/*#__PURE__*/
React.forwardRef(function Construct(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38,14h-4v-4h4V14z M38,16h-4v4h4V16z M32,10h-4v4h4V10z M32,16h-4v4h4V16z M26,16h-4v4h4V16z M14,16h-4v4h4V16z M26,22h-4v4h4V22z M26,34h-4v4h4V34z M14,34h-4v4h4V34z M20,22h-4v4h4V22z M20,10h-4v4h4V10z M20,28h-4v4h4V28z M38,22h-4v4h4V22z M38,28h-4v4h4V28z M38,34h-4v4h4V34z M32,28h-4v4h4V28z M32,34h-4v4h4V34z"
  }), props.children);
});
var Conversation =
/*#__PURE__*/
React.forwardRef(function Conversation(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M19.5,25.998c0,0.552-0.448,1-1,1s-1-0.448-1-1c0-0.552,0.448-1,1-1S19.5,25.446,19.5,25.998z M22.5,24.998 c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1s1-0.448,1-1C23.5,25.446,23.052,24.998,22.5,24.998z M14.5,24.998 c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1s1-0.448,1-1C15.5,25.446,15.052,24.998,14.5,24.998z M31,14c-0.552,0-1,0.448-1,1 s0.448,1,1,1s1-0.448,1-1S31.552,14,31,14z M35,14c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S35.552,14,35,14z M27,14 c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S27.552,14,27,14z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,39l-4-5.999h-4 c-1.1,0-2-0.9-2-2V21c0-1.1,0.9-2,2-2h15c1.1,0,2,0.9,2,2v10.001c0,1.1-0.9,2-2,2h-7 M32,25l2-4h3c1.1,0,2-0.9,2-2v-8 c0-1.1-0.9-2-2-2H25c-1.1,0-2,0.9-2,2v7.999 M31,21h-3.009"
  }), props.children);
});
var CopenhagenPlanetarium =
/*#__PURE__*/
React.forwardRef(function CopenhagenPlanetarium(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M34 26L36 26M18 28L16 28 14 30 12 30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M22 30L20 30 18 32 16 32 14 34 12 34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M14 26L12 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M22 34L20 34 18 36 16 36 14 38 12 38 12 18M26 34L28 34 30 36 32 36 34 38 36 38 36 18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M26 30L28 30 30 32 32 32 34 34 36 34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M30 28L32 28 34 30 36 30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 18L24 26 36 18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.068 14.712c.601-.886 1.428-1.69 2.446-2.369M13.068 14.712C12.388 15.716 12 16.827 12 18c0 4.418 5.373 8 12 8s12-3.582 12-8c0-1.173-.388-2.284-1.068-3.288M34.932 14.712c-.601-.886-1.428-1.69-2.446-2.369M32.485 12.343c-1.018-.679-2.224-1.23-3.554-1.631M19.069 10.712C20.574 10.259 22.24 10 24 10s3.426.259 4.931.712M19.069 10.712c-1.33.401-2.535.952-3.554 1.631"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.932 14.712L24 22 13.068 14.712"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.485 12.343L24 18 15.515 12.343"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.069 10.712L24 14 28.931 10.712"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M24 10L24 38"
  }), props.children);
});
var CopenhagenSnekkja =
/*#__PURE__*/
React.forwardRef(function CopenhagenSnekkja(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,11 c3.314,0,6,2.686,6,6s-2.686,6-6,6h10c3.314,0,6-2.686,6-6s-2.686-6-6-6H16z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9L24 11M24 23L24 27"
  }), React.createElement("circle", {
    cx: "18",
    cy: "30",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18",
    cy: "30",
    r: "3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "30",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "30",
    cy: "30",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 26L37 24 39 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 26v6c0 2.209 1.791 4 4 4h18c2.209 0 4-1.791 4-4v-6c0 2.209-1.791 4-4 4M11 26c0 2.209 1.791 4 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.879 32.121L21 39M27.879 32.121C28.422 32.664 29.172 33 30 33s1.578-.336 2.121-.879C32.664 31.578 33 30.828 33 30s-.336-1.578-.879-2.121S30.828 27 30 27s-1.578.336-2.121.879C27.336 28.422 27 29.172 27 30S27.336 31.578 27.879 32.121zM21.879 32.121L15 39M21.879 32.121C22.422 32.664 23.172 33 24 33s1.578-.336 2.121-.879C26.664 31.578 27 30.828 27 30s-.336-1.578-.879-2.121S24.828 27 24 27s-1.578.336-2.121.879C21.336 28.422 21 29.172 21 30S21.336 31.578 21.879 32.121z"
  }), props.children);
});
var CreditCard =
/*#__PURE__*/
React.forwardRef(function CreditCard(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,34H11c-1.1,0-2-0.9-2-2V16c0-1.1,0.9-2,2-2h26c1.1,0,2,0.9,2,2v16C39,33.1,38.1,34,37,34z M9,18h30 M9,21h30"
  }), props.children);
});
var Crop =
/*#__PURE__*/
React.forwardRef(function Crop(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36,15V9 M33,12h6 M12,39v-6 M9,36h6 M30,12H14c-1.1,0-2,0.9-2,2v16 M18,36h16c1.1,0,2-0.9,2-2V18"
  }), props.children);
});
var CustomerService =
/*#__PURE__*/
React.forwardRef(function CustomerService(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.149,25H14v-6 c0-5.523,4.477-10,10-10s10,4.477,10,10v6l-5.149,0 M39.001,39C39,31,33.77,27.376,27.364,25.857 c2.899-1.291,4.924-4.192,4.924-7.57v-0.4l0,0.001c-2.811-0.37-5.34-1.638-7.287-3.507l0,0C22.664,16.622,19.493,18,16,18 c-0.096,0-0.192-0.001-0.288-0.003l0,0v0.29c0,3.379,2.024,6.28,4.924,7.57C14.23,27.376,9,31,9,39 M24,22c-0.552,0-1,0.448-1,1 s0.448,1,1,1s1-0.448,1-1S24.553,22,24,22z M25,23c3,0,7.288-1.477,7.288-5.113"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.159 27.151L24 38 30.841 27.151M30 36L36 36"
  }), props.children);
});
var DataBackup =
/*#__PURE__*/
React.forwardRef(function DataBackup(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 12H34V18H14zM15 15L21.5 15"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "15",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 21H34V27H14zM15 24L21.5 24"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "24",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 30H34V36H14zM15 33L21.5 33"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "33",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 15L38 15 38 24 34 24M14 33L10 33 10 24 14 24"
  }), props.children);
});
var DataInsights =
/*#__PURE__*/
React.forwardRef(function DataInsights(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,39h-6v-6h6V39z M31,25h-6v6h6V25z M12,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,9,12,9z M12,33 c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3C15,34.343,13.657,33,12,33z M28,33c-1.657,0-3,1.343-3,3 c0,1.657,1.343,3,3,3s3-1.343,3-3C31,34.343,29.657,33,28,33z M36,33c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3 C39,34.343,37.657,33,36,33z M20,25c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3C23,26.343,21.657,25,20,25z M36,25 l-3.464,6l6.928,0L36,25z M12,25v-7 M9.172,22.171L12,25l2.828-2.828"
  }), props.children);
});
var DataProcessing =
/*#__PURE__*/
React.forwardRef(function DataProcessing(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 10H24V15H10zM12 12L18 12M10 17H24V22H10zM12 19L18 19"
  }), React.createElement("circle", {
    cx: "21.5",
    cy: "12",
    r: ".5"
  }), React.createElement("circle", {
    cx: "21.5",
    cy: "19",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 26H38V31H24zM26 28L32 28M24 33H38V38H24zM26 35L32 35"
  }), React.createElement("circle", {
    cx: "35.5",
    cy: "28",
    r: ".5"
  }), React.createElement("circle", {
    cx: "35.5",
    cy: "35",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 16L36 16 36 24M22 32L12 32 12 24"
  }), props.children);
});
var DataStorage =
/*#__PURE__*/
React.forwardRef(function DataStorage(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".671",
    d: "M39,34v5H9v-5 M9,26v5h30v-5 M9,18v5h30v-5 M9,10v5h30v-5"
  }), props.children);
});
var Delete =
/*#__PURE__*/
React.forwardRef(function Delete(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.811,24l7.99,7.99c1.598,1.598,1.598,4.213,0,5.811l0,0c-1.598,1.598-4.213,1.598-5.811,0L24,29.811l-7.99,7.99 c-1.598,1.598-4.213,1.598-5.811,0l0,0c-1.598-1.598-1.598-4.213,0-5.811l7.99-7.99l-0.005-0.005l-7.985-7.985 c-1.598-1.598-1.598-4.213,0-5.811l0,0c1.598-1.598,4.213-1.598,5.811,0l7.99,7.99l7.99-7.99c1.598-1.598,4.213-1.598,5.811,0l0,0 c1.598,1.598,1.598,4.213,0,5.811L29.811,24L29.811,24z"
  }), props.children);
});
var DeliverInsights =
/*#__PURE__*/
React.forwardRef(function DeliverInsights(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.927,29.991H8.999l3.464-6L15.927,29.991z M23.993,38.991l3.114-3.114c0.354-0.354,0.536-0.816,0.544-1.28 c0.009-0.487-0.173-0.976-0.544-1.347c-0.363-0.363-0.838-0.544-1.314-0.544s-0.951,0.181-1.314,0.544l-0.486,0.486l-0.486-0.486 c-0.364-0.364-0.841-0.545-1.317-0.544c-0.474,0.001-0.948,0.182-1.31,0.544c-0.365,0.365-0.546,0.844-0.544,1.322 c0.002,0.473,0.183,0.945,0.544,1.306L23.993,38.991z M15.993,12.981h-6v6h6V12.981z M32.035,13.991v4l3.464,2l3.464-2v-4l-3.464-2 L32.035,13.991z M35.993,24.996c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S37.65,24.996,35.993,24.996z M23.993,8.981 c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S25.65,8.981,23.993,8.981z M34,39c0-4.625-3.145-8.506-7.409-9.649 c1.731-0.926,2.91-2.751,2.91-4.852c0-3.038-2.463-5.501-5.501-5.501s-5.501,2.463-5.501,5.501c0,2.101,1.179,3.925,2.91,4.852 C17.156,30.425,14,34.375,14,39"
  }), props.children);
});
var DeliveryTruck =
/*#__PURE__*/
React.forwardRef(function DeliveryTruck(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,33h-1c-1.105,0-2-0.895-2-2v-7h12 M37,15H23 M37,18H25 M37,21H27 M37,24h-8 M37,33h2V12H21v21h10 M18,17v7 M15,30 c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3C18,31.343,16.657,30,15,30z M34,30c-1.657,0-3,1.343-3,3 c0,1.657,1.343,3,3,3s3-1.343,3-3C37,31.343,35.657,30,34,30z M9,24l4.041-7H21v16h-3 M17,26h2"
  }), props.children);
});
var DesignAndDevelopment_01 =
/*#__PURE__*/
React.forwardRef(function DesignAndDevelopment_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,30H9V9h30V30z M9,33h30 M9,12h30 M9,36h30 M9,39h30"
  }), React.createElement("path", {
    d: "M37,10.5c0,0.276-0.224,0.5-0.5,0.5S36,10.776,36,10.5s0.224-0.5,0.5-0.5S37,10.224,37,10.5z M34.5,10 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.776,10,34.5,10z M32.5,10c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S32.776,10,32.5,10z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,16h6 M12,19h6 M12,22h6"
  }), props.children);
});
var DesignAndDevelopment_02 =
/*#__PURE__*/
React.forwardRef(function DesignAndDevelopment_02(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M37,10.5c0,0.276-0.224,0.5-0.5,0.5S36,10.776,36,10.5s0.224-0.5,0.5-0.5S37,10.224,37,10.5z M34.5,10 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.776,10,34.5,10z M32.5,10c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S32.776,10,32.5,10z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 16h10M12 19h10M12 22h6M39 30H9V9h30V30zM9 33h30M9 12h30M9 36h30M9 39h30M32 15c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4S34.209 15 32 15zM32 19l3.457-2.013M32 19l-3.457-2.013M32 19l-2.007 3.461"
  }), props.children);
});
var Desktop =
/*#__PURE__*/
React.forwardRef(function Desktop(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,32 H11c-1.1,0-2-0.9-2-2V13c0-1.1,0.9-2,2-2h26c1.1,0,2,0.9,2,2v17C39,31.1,38.1,32,37,32z M17,37h14 M24,32v5 M9,27h30"
  }), props.children);
});
var Devops =
/*#__PURE__*/
React.forwardRef(function Devops(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,9l2,3.464l-2,3.464l-4,0l-2-3.464L22,9L26,9z M22,15.928l-3,5.196 M10.01,18.232l2,3.464l4,0l2-3.464l-2-3.464l-4,0 L10.01,18.232z M19.01,26.892l-3-5.196 M12.01,33.232h4l2-3.464l-2-3.464l-4,0l-2,3.464L12.01,33.232z M24.01,29.768l-6,0 M26,39 l2-3.464l-2-3.464h-4l-2,3.464L22,39H26z M26,32.072l3-5.196 M37.99,29.768l-2-3.464l-4,0l-2,3.464l2,3.464h4L37.99,29.768z M28.99,21.108l3,5.196 M35.99,14.768l-4,0l-2,3.464l2,3.464l4,0l2-3.464L35.99,14.768z M29.99,18.232l-6,0"
  }), props.children);
});
var Dialogue =
/*#__PURE__*/
React.forwardRef(function Dialogue(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,31H13 c-2.2,0-4-1.8-4-4V13c0-2.2,1.8-4,4-4h22c2.2,0,4,1.8,4,4v14c0,2.2-1.8,4-4,4h-7l-4,8"
  }), React.createElement("path", {
    d: "M26,20c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S26,18.895,26,20z M32,18c-1.105,0-2,0.895-2,2s0.895,2,2,2 c1.105,0,2-0.895,2-2S33.105,18,32,18z M16,18c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S17.105,18,16,18z"
  }), props.children);
});
var Digital =
/*#__PURE__*/
React.forwardRef(function Digital(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14,11.5c0,1.381-1.119,2.5-2.5,2.5S9,12.881,9,11.5S10.119,9,11.5,9S14,10.119,14,11.5z M11.5,21.5v-4 M11.5,26 C10.119,26,9,27.119,9,28.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S12.881,26,11.5,26z M11.5,38.5v-4 M28,9 c-1.381,0-2.5,1.119-2.5,2.5S26.619,14,28,14s2.5-1.119,2.5-2.5S29.381,9,28,9z M28,21.5v-4 M28,26c-1.381,0-2.5,1.119-2.5,2.5 S26.619,31,28,31s2.5-1.119,2.5-2.5S29.381,26,28,26z M28,38.5v-4 M36.5,39c1.381,0,2.5-1.119,2.5-2.5S37.881,34,36.5,34 S34,35.119,34,36.5S35.119,39,36.5,39z M36.5,26.5v4 M36.5,22c1.381,0,2.5-1.119,2.5-2.5S37.881,17,36.5,17S34,18.119,34,19.5 S35.119,22,36.5,22z M36.5,9.5v4 M20,39c1.381,0,2.5-1.119,2.5-2.5S21.381,34,20,34s-2.5,1.119-2.5,2.5S18.619,39,20,39z M20,26.5 v4 M20,22c1.381,0,2.5-1.119,2.5-2.5S21.381,17,20,17s-2.5,1.119-2.5,2.5S18.619,22,20,22z M20,9.5v4"
  }), props.children);
});
var Dining =
/*#__PURE__*/
React.forwardRef(function Dining(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,9v10 c0,1.105-0.895,2-2,2h-1v18h-3V21h-1c-1.105,0-2-0.895-2-2V9 M31,39V24h2V12c0-1.657-1.343-3-3-3h-2v30L31,39z M17,9v8 M20,9v8"
  }), props.children);
});
var Dna =
/*#__PURE__*/
React.forwardRef(function Dna(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.997,10.055c0,6.94,14.005,7.078,14.005,14.019c0,3.019-2.207,4.587-5.252,6.122 M25.751,16.163 c2.83-1.512,5.252-3.222,5.252-6.108 M22.249,31.939c-2.83,1.512-5.252,3.222-5.252,6.108 M22.249,17.933 c-3.045,1.535-5.252,3.103-5.252,6.122c0,6.94,14.005,7.078,14.005,14.019 M17,24h14 M18.15,21h11.7 M17.413,12h13.173 M17.5,36h13 M18,27h12 M16.997,10.055V9 M31.003,10.055V9 M16.997,38.047V39 M31.003,38.074V39"
  }), props.children);
});
var DoNot =
/*#__PURE__*/
React.forwardRef(function DoNot(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M26.85,24l3.562-3.562 c0.784-0.784,0.784-2.066,0-2.85l0,0c-0.784-0.784-2.066-0.784-2.85,0L24,21.15l0,0l-3.562-3.562c-0.784-0.784-2.066-0.784-2.85,0 l0,0c-0.784,0.784-0.784,2.066,0,2.85L21.15,24l0,0l-3.562,3.562c-0.784,0.784-0.784,2.066,0,2.85l0,0 c0.784,0.784,2.066,0.784,2.85,0L24,26.85l0,0l3.562,3.562c0.784,0.784,2.066,0.784,2.85,0l0,0c0.784-0.784,0.784-2.066,0-2.85 L26.85,24L26.85,24z"
  }), props.children);
});
var Docker =
/*#__PURE__*/
React.forwardRef(function Docker(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "20",
    cy: "30",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.109,21.51c1.239,0.028,2.309,0.701,2.891,1.692c-0.595,1.013-1.698,1.696-2.97,1.696h-0.532C35.142,28.96,28.104,35,19.306,35 C13.614,35,9,30.509,9,24.899v-0.898l24.7,0.003c-0.683-0.62-1.112-1.51-1.112-2.498c0-1.272,0.71-2.378,1.76-2.959 c1.051,0.581,1.761,1.687,1.761,2.959V21.51 M11.965,32c2.398,0,4.545-0.271,5.98-0.698 M30,20h-4v4h4V20z M26,20h-4v4h4V20z M22,20h-4v4h4V20z M26,16h-4v4h4V16z M26,12h-4v4h4V12z M22,16h-4v4h4V16z M18,20h-4v4h4V20z"
  }), props.children);
});
var Doctor =
/*#__PURE__*/
React.forwardRef(function Doctor(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.823,14h4.787 M16.389,14h4.78 M39,39c0-6.871-5.23-12.624-11.637-14.143c2.899-1.291,4.924-4.192,4.924-7.57 C32.287,12.71,28.577,9,24,9s-8.288,3.71-8.288,8.287c0,3.379,2.024,6.28,4.924,7.57C14.229,26.376,9,32.129,9,39 M25,35h8 M29,30.997v8 M24,12c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S25.657,12,24,12z"
  }), props.children);
});
var DocumentConversion =
/*#__PURE__*/
React.forwardRef(function DocumentConversion(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,24.002h6 M27,11.001H15.004v6 M15,31.001v6h12 M21,17.001H9v14h12V17.001z M39,9H27v4h12V9z M39,22.001H27v4h12V22.001z M39,35 H27v4h12V35z M11.004,21.001h8 M11.004,24h8 M11.004,27.001h8"
  }), props.children);
});
var DoorHandle =
/*#__PURE__*/
React.forwardRef(function DoorHandle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "20",
    cy: "31",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,31v2.958 M20,15 c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S22.762,15,20,15z M31,25v14H9V9h22v6 M24.79,18.501H37.5c0.83,0,1.5,0.67,1.5,1.5 c0,0.82-0.67,1.5-1.5,1.5H24.77"
  }), props.children);
});
var DownloadAlt =
/*#__PURE__*/
React.forwardRef(function DownloadAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,20h8v19H9V20h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,27l-6,6l-6-6 M24,9v24"
  }), props.children);
});
var Download =
/*#__PURE__*/
React.forwardRef(function Download(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,31v8H9v-8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,25l-6,6l-6-6 M24,9v22"
  }), props.children);
});
var DubaiPalmIslands =
/*#__PURE__*/
React.forwardRef(function DubaiPalmIslands(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 12L24 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 34c0-2.209 1.791-4 4-4s4 1.791 4 4M24 20c0-2.209 1.791-4 4-4M20 16c2.209 0 4 1.791 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31.481,36.971c1.149-0.663,2.19-1.462,3.105-2.38c0.929-0.931,1.739-1.967,2.392-3.098c0.664-1.148,1.165-2.361,1.5-3.614 C38.817,26.609,39,25.306,39,24c0-1.306-0.183-2.609-0.522-3.879c-0.334-1.252-0.836-2.465-1.5-3.614 c-0.642-1.111-1.421-2.164-2.372-3.114s-2.003-1.73-3.114-2.372c-1.148-0.664-2.361-1.165-3.614-1.5C26.609,9.183,25.306,9,24,9 c-1.306,0-2.609,0.183-3.879,0.522c-1.252,0.334-2.465,0.836-3.614,1.5c-1.111,0.642-2.164,1.421-3.114,2.372 s-1.73,2.003-2.372,3.114c-0.664,1.148-1.165,2.361-1.5,3.614C9.183,21.391,9,22.694,9,24c0,1.306,0.183,2.609,0.522,3.879 c0.334,1.252,0.836,2.465,1.5,3.614c0.653,1.131,1.463,2.168,2.392,3.098c0.916,0.917,1.957,1.717,3.105,2.38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 26c0-3.314 2.686-6 6-6s6 2.686 6 6M24 26c0-3.314 2.686-6 6-6s6 2.686 6 6M16 30c0-2.209 1.791-4 4-4s4 1.791 4 4M24 30c0-2.209 1.791-4 4-4s4 1.791 4 4"
  }), props.children);
});
var DubaiSkyscraper =
/*#__PURE__*/
React.forwardRef(function DubaiSkyscraper(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 16L20 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 9L20 16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 39L18 16 20 16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 32L22 24 18 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 39L16 32 22 32 22 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,16c-3.866,0-7-3.134-7-7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 34L16 34M22 34L39 34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 18L39 26M24.278 17.5L31.206 13.5M30.5 23.722L34.5 16.794M30 9L22 9"
  }), props.children);
});
var DublinBrewery =
/*#__PURE__*/
React.forwardRef(function DublinBrewery(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32L39 32M9 36L12 36 12 34 36 34 36 36 39 36"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 32L22 26M24 32L24 26M26 32L26 26M28 22L28 24M20 24L20 22M22 24L22 22M24 24L24 22M26 24L26 22M12 14L14 14"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 32L12 9 14 9 14 32M34 32L34 9 36 9 36 32"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 16L14 16M12 20L14 20M34 14L36 14M34 16L36 16M34 20L36 20M34 22L36 22M34 28L36 28M34 26L36 26M12 22L14 22M12 28L14 28M12 26L14 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 39L22 36 26 36 26 39M18 39L18 36 20 36 20 39M28 39L28 36 30 36 30 39M32 39L32 36 34 36 34 39M14 39L14 36 16 36 16 39M20 20L20 16 28 16 28 20M16 32L16 20 32 20 32 32"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32L20 26 28 26 28 32"
  }), props.children);
});
var DublinCastle =
/*#__PURE__*/
React.forwardRef(function DublinCastle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 33L35 33c0-.55.45-1 1-1l0 0c.55 0 1 .45 1 1l0 0M37 33L37 37 35 37 35 33M11 33L11 33c0-.55.45-1 1-1h0c.55 0 1 .45 1 1l0 0M13 33L13 37 11 37 11 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 15L33 15M23 15L23 13M21 15L21 13M19 15L19 13M17 15L17 13M31 15L31 13"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 39L33 15 35 13 35 9 33 9 33 11 31 11 31 9 29 9 29 11 27 11 27 9 25 9 25 11 23 11 23 9 21 9 21 11 19 11 19 9 17 9 17 11 15 11 15 9 13 9 13 13 15 15 15 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 15L29 13M27 15L27 13M25 15L25 13M23 15L23 13M21 33L21 31M19 33L19 31M17 33L17 31M31 33L31 31M29 33L29 31M27 33L27 31M25 33L25 31M23 33L23 31"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 24L21 20 27 20 27 24M23 24L23 20M25 24L25 20M17 35H19V37H17zM21 35H23V37H21zM25 35H27V37H25zM29 35H31V37H29z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 24L28 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 33L33 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39L39 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 28L9 28M39 28L33 28"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 30L9 30M39 30L33 30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 28L13 26M11 28L11 26M9 28L9 26M39 28L39 26M37 28L37 26M35 28L35 26"
  }), props.children);
});
var DuplicateFile =
/*#__PURE__*/
React.forwardRef(function DuplicateFile(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,39H9V17h19V39z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M20 17L20 15M20 11L20 9 22 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "3.5294,2.6471",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M24.647 9L35.676 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M37 9L39 9 39 11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "4.2353,3.1765",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 14.177L39 27.412"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 29L39 31 37 31"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "2.8,2.1",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M34.9 31L31.05 31"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M30 31L28 31"
  }), props.children);
});
var Education =
/*#__PURE__*/
React.forwardRef(function Education(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.57,17.99c-0.48,0.96-0.75,2.04-0.75,3.19c0,2.93,1.75,5.44,4.27,6.56C15.53,29.06,11,34.04,11,40 M30.43,17.99 c0.48,0.96,0.75,2.04,0.75,3.19c0,2.93-1.75,5.44-4.26,6.56C32.47,29.06,37,34.04,37,40 M16.2,30.03L19.65,36L24,33.49L28.35,36 l3.45-5.97 M30.43,17.99v-1.94C28.94,15.23,27.1,14,24.03,14c-3.08,0-4.97,1.23-6.46,2.05v1.94 M30.43,17.99L35,15.35L24,9 l-11,6.35l4.57,2.64C17.57,17.99,30.423,17.983,30.43,17.99z M13,24v-8.65"
  }), props.children);
});
var ElectricCharge =
/*#__PURE__*/
React.forwardRef(function ElectricCharge(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 18.804L14 24 18 24 15 29.196"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,39H9V11c0-1.105,0.895-2,2-2h10c1.105,0,2,0.895,2,2V39z M39,17v-5h-8v5c0,2.209,1.791,4,4,4h0C37.209,21,39,19.209,39,17z M31,14h8 M33,9v3 M37,9v3 M23,14c2.209,0,4,1.791,4,4v11c0,2.209,1.791,4,4,4s4-1.791,4-4v-8"
  }), props.children);
});
var Electric =
/*#__PURE__*/
React.forwardRef(function Electric(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,27c-3.314,0-6-2.686-6-6v-8h12v8C21,24.314,18.314,27,15,27z M12,13V9 M18,13V9 M9,17h12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,27v6 c0,3.314,2.686,6,6,6s6-2.686,6-6V23c0-3.314,2.686-6,6-6s6,2.686,6,6v10"
  }), props.children);
});
var Elevator =
/*#__PURE__*/
React.forwardRef(function Elevator(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,9v30 M39,9v30 M23,13l-3-3l-3,3 M25,10l3,3 l3-3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.5,20.5 c0,0.828-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.672-1.5-1.5S23.172,19,24,19C24.829,19,25.5,19.671,25.5,20.5z M34,16H14v23h20V16z M25.39,36.991v-5.352h0l0.346-0.141c0.753-0.306,1.245-1.038,1.246-1.851l0.002-2.261c0.001-1.616-1.208-3.065-2.822-3.15 c-1.721-0.091-3.145,1.278-3.145,2.979l-0.002,2.428c-0.001,0.815,0.494,1.549,1.25,1.855l0.31,0.126l0.036,0.018v5.35"
  }), props.children);
});
var Embed =
/*#__PURE__*/
React.forwardRef(function Embed(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,26h-9v-9 M24,11H11 c-1.105,0-2,0.895-2,2v24c0,1.105,0.895,2,2,2h24c1.105,0,2-0.895,2-2V24 M39,9L22,26"
  }), props.children);
});
var Engine =
/*#__PURE__*/
React.forwardRef(function Engine(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,12 h12 M16,27h16 M9,17.909v12.184 M9,24.001h3 M25,12v3 M27,36l-2-3H12V15h24v6h3v15H27z M24,19c-1.105,0-2,0.895-2,2s0.895,2,2,2 s2-0.895,2-2S25.105,19,24,19z M30,19c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S31.105,19,30,19z M18,19c-1.105,0-2,0.895-2,2 s0.895,2,2,2s2-0.895,2-2S19.105,19,18,19z"
  }), props.children);
});
var EnterpriseDesignThinkingAlt =
/*#__PURE__*/
React.forwardRef(function EnterpriseDesignThinkingAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,9 h30 M9,13h15 M9,39h30 M24,35h15 M26,21.999l2.375-2.375c2.189-2.189,6.374-2.206,8.803,0.197c2.429,2.404,2.429,5.949,0,8.353 c-2.429,2.403-6.616,2.388-8.764,0.239l0,0l-8.794-8.794c-2.176-2.176-6.369-2.199-8.798,0.205c-2.429,2.404-2.429,5.97,0,8.373 c2.43,2.403,6.612,2.366,8.796,0.182l2.381-2.381 M22,30v-4h-4"
  }), props.children);
});
var EnterpriseDesignThinking =
/*#__PURE__*/
React.forwardRef(function EnterpriseDesignThinking(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21.142,26.829 c-1.579,1.562-4.138,1.562-5.718,0c-1.579-1.562-1.579-4.094,0-5.657c1.579-1.562,4.139-1.562,5.718,0l5.718,5.657 c1.579,1.562,4.138,1.562,5.717,0c1.579-1.562,1.579-4.094,0-5.657c-1.579-1.562-4.138-1.562-5.717,0L21.142,26.829z M9,9h30 M9,39h30 M9,13h15 M24,17h15 M24,35h15 M9,31h12"
  }), React.createElement("path", {
    d: "M39,13c0,0.276-0.224,0.5-0.5,0.5S38,13.276,38,13s0.224-0.5,0.5-0.5S39,12.724,39,13z M36.5,12.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5S37,13.276,37,13S36.776,12.5,36.5,12.5z M11.5,27.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5S12,28.276,12,28S11.776,27.5,11.5,27.5z M23.5,30.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 S24,31.276,24,31S23.776,30.5,23.5,30.5z M9.5,34.5C9.224,34.5,9,34.724,9,35s0.224,0.5,0.5,0.5S10,35.276,10,35 S9.776,34.5,9.5,34.5z M38.5,30.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5S39,31.276,39,31S38.776,30.5,38.5,30.5z M9.5,27.5C9.224,27.5,9,27.724,9,28s0.224,0.5,0.5,0.5S10,28.276,10,28S9.776,27.5,9.5,27.5z M9.5,16.5C9.224,16.5,9,16.724,9,17 s0.224,0.5,0.5,0.5S10,17.276,10,17S9.776,16.5,9.5,16.5z M38.5,19.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 S39,20.276,39,20S38.776,19.5,38.5,19.5z"
  }), props.children);
});
var Envelope =
/*#__PURE__*/
React.forwardRef(function Envelope(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 35H9V13h30V35zM9 13l15 14 15-14M9 35L21 24M27 24L39 35"
  }), props.children);
});
var ErlenmeyerFlask =
/*#__PURE__*/
React.forwardRef(function ErlenmeyerFlask(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,12h3 M21,15h3 M21,18h3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,21l-8.788,15.106C11.548,37.435,12.514,39,14.001,39h19.997c1.487,0,2.454-1.565,1.789-2.894L27,21V9h-6V21z M19,9h10 M16.928,28h14.144"
  }), props.children);
});
var EscalatorDown =
/*#__PURE__*/
React.forwardRef(function EscalatorDown(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".717",
    d: "M32,12c1.105,0,2,0.895,2,2s-0.895,2-2,2 c-1.105,0-2-0.895-2-2S30.895,12,32,12z M11,37h6v-6 M17,37l-8-8 M35,26v-5c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.44,28.998L18.028,13.586C17.653,13.211,17.144,13,16.614,13H13c-2.209,0-4,1.791-4,4v0.004c0,2.208,1.79,3.997,3.997,3.997 h1.532l15.414,15.413C30.318,36.789,30.827,37,31.357,37h3.647C37.211,37,39,35.211,39,33.004V33c0-2.209-1.791-4.001-4.001-4.001 H33.44"
  }), props.children);
});
var EscalatorUp =
/*#__PURE__*/
React.forwardRef(function EscalatorUp(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.56,28.998l15.412-15.412C30.347,13.211,30.856,13,31.386,13H35c2.209,0,4,1.791,4,4v0.004c0,2.208-1.79,3.997-3.997,3.997 h-1.532L18.057,36.414C17.682,36.789,17.173,37,16.643,37H13c-2.209,0-4-1.791-4-4v0c0-2.209,1.791-4.001,4.001-4.001h1.559"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,14c0,1.105-0.895,2-2,2s-2-0.895-2-2 s0.895-2,2-2S18,12.895,18,14z M39,35v-6h-6 M39,29l-8,8 M18.992,21.012C18.992,19.355,17.657,18,16,18s-3,1.343-3,3v5"
  }), props.children);
});
var EuropeAfrica =
/*#__PURE__*/
React.forwardRef(function EuropeAfrica(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M19.239,9.771L19.5,11L15,14.5l0.585,2.5h1.591 c0.43,0,0.831-0.068,1.069-0.426v0C18.483,16.215,18.884,16,19.314,16h6.49l2.696,5l-0.946,2h-3.937L22,20h-6l-2.027,6.626 L16,31.001L21.999,32v5.501L25.034,39 M38.999,23.806c-0.193,0.076-3.148,0.806-4.433,1.134L31.5,21l-1.737,2.5l2.435,3.5h2.803 v7.202"
  }), props.children);
});
var ExpandHorz =
/*#__PURE__*/
React.forwardRef(function ExpandHorz(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 9L39 9.01"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.0198,1.9802",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 10.99L39 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 38.99L39 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,9v30 M12,24h24 M33,27l3-3l-3-3"
  }), props.children);
});
var ExpandUser =
/*#__PURE__*/
React.forwardRef(function ExpandUser(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.5,39v-7c1.109-0.4,2-1.268,2-2.4v-4.016C27.5,23.605,25.979,22,24,22s-3.5,1.614-3.5,3.593v4.016c0,1.132,0.891,1.99,2,2.391 v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,14V9 M26.121,11.121L24,9l-2.121,2.121 M15.34,19l-4.33-2.5 M13.907,15.724L11.01,16.5l0.776,2.898 M15.34,29l-4.33,2.5 M11.786,28.602L11.01,31.5l2.898,0.776 M32.66,29l4.33,2.5 M34.093,32.276L36.99,31.5l-0.776-2.898 M32.66,19l4.33-2.5 M36.214,19.398L36.99,16.5l-2.898-0.776 M24,16 c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S25.105,16,24,16z"
  }), props.children);
});
var ExpandVert =
/*#__PURE__*/
React.forwardRef(function ExpandVert(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M9 9L9.01 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.0198,1.9802",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M10.99 9L38 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M38.99 9L39 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,39h30 M24,36V12 M27,15l-3-3l-3,3"
  }), props.children);
});
var ExportAlt =
/*#__PURE__*/
React.forwardRef(function ExportAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,20h8v19H9V20h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,15l6-6l6,6 M24,9v24"
  }), props.children);
});
var Export =
/*#__PURE__*/
React.forwardRef(function Export(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,16l6-6l6,6 M24,32V10"
  }), props.children);
});
var Eye =
/*#__PURE__*/
React.forwardRef(function Eye(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,24c0,3.866-3.134,7-7,7s-7-3.134-7-7s3.134-7,7-7S31,20.134,31,24z M24,20.5c-1.933,0-3.5,1.567-3.5,3.5s1.567,3.5,3.5,3.5 s3.5-1.567,3.5-3.5S25.933,20.5,24,20.5z M10,24c0,0,3.71,9,14,9s14-9,14-9s-3.71-9-14-9S10,24,10,24z"
  }), props.children);
});
var FaceDissatisfied =
/*#__PURE__*/
React.forwardRef(function FaceDissatisfied(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75,21c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S18.75,20.586,18.75,21z M30,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.414,20.25,30,20.25z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,31c0,0,2-3,6-3s6,3,6,3 M24,9 C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var FaceNeutral =
/*#__PURE__*/
React.forwardRef(function FaceNeutral(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75,21c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S18.75,20.586,18.75,21z M30,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.414,20.25,30,20.25z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,29h12 M24,9C15.716,9,9,15.716,9,24 s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var FaceSatisfied =
/*#__PURE__*/
React.forwardRef(function FaceSatisfied(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75,21c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S18.75,20.586,18.75,21z M30,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.414,20.25,30,20.25z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,28c0,0-2,3-6,3s-6-3-6-3 M24,9 C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var FaceVeryDissatisfied =
/*#__PURE__*/
React.forwardRef(function FaceVeryDissatisfied(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75,21c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S18.75,20.586,18.75,21z M30,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.414,20.25,30,20.25z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,32c0-3.314,2.686-6,6-6s6,2.686,6,6 M24,9 C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var FaceVerySatisfied =
/*#__PURE__*/
React.forwardRef(function FaceVerySatisfied(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75,21c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S18.75,20.586,18.75,21z M30,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.414,20.25,30,20.25z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,26c0,3.314-2.686,6-6,6s-6-2.686-6-6 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var Factory =
/*#__PURE__*/
React.forwardRef(function Factory(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,39V21l-6.5,4v-4l-7,4v-4L14,25 M14,21h-4 M34,30c0,0,1.136,0,1.736,0c0.691,0,1.261,0.553,1.261,1.244V39 M34,28h1.834 c1.29,0,3.169,0.718,3.163,3.193V39 M12.07,12.917c0-1.054-0.593-1.958-1.536-1.958l0,0C9.479,10.958,9,10.311,9,9 M11.5,9 c1.5,0,2.497,1,2.497,2.5 M30,30v-2 M26,30v-2 M22,30v-2 M18,30v-2 M21.997,39v-6h4v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39L10 39 10 39 10 14 14 14 14 39"
  }), props.children);
});
var Farm =
/*#__PURE__*/
React.forwardRef(function Farm(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,32h8.186C25.343,32,30.178,34.77,34,39 M34,35c-3.821-4.229-8.656-7-16.814-7H9 M34,31c-3.821-4.229-8.656-7-16.814-7H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,17v7 M18,18v6 M12,13c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S13.104,13,12,13z M18,14c-1.105,0-2,0.895-2,2 s0.895,2,2,2c1.105,0,2-0.895,2-2S19.104,14,18,14z M32,13c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S33.657,13,32,13 z M32,9v2 M27.05,11.05l1.414,1.414 M25,16h2 M27.05,20.949l1.414-1.414 M32,23v-2 M36.949,20.949l-1.414-1.414 M39,16h-2 M36.949,11.05l-1.414,1.414"
  }), props.children);
});
var Faucet =
/*#__PURE__*/
React.forwardRef(function Faucet(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39V9 M27,18v-4 M39,18H22.661C15.147,18,9,24.487,9,32h7c0-4.254,3.135-8.002,7.389-8.002H39 M11.113,36.925 c-0.323,0.762,0.041,1.64,0.811,1.959c0.771,0.32,1.649-0.044,1.959-0.811c0.166-0.383,0.146-0.796,0.001-1.148l-1.385-3.344 L11.113,36.925z M32.563,10.002h-3.689C28.441,9.397,27.737,9,26.937,9c-0.8,0-1.505,0.397-1.938,1.002h-3.562 c-0.828,0-1.437,0.672-1.437,1.5s0.608,1.5,1.437,1.5h3.751c0.436,0.473,1.055,0.773,1.749,0.773s1.313-0.301,1.749-0.773h3.877 c0.828,0,1.437-0.672,1.437-1.5S33.392,10.002,32.563,10.002z"
  }), props.children);
});
var Feedback =
/*#__PURE__*/
React.forwardRef(function Feedback(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.652,27 C35.298,32.733,30.147,37,24,37c-7.18,0-13-5.82-13-13 M13,26l-2-2l-2,2 M37,24c0-7.18-5.817-13-12.997-13 c-6.147,0-11.298,4.267-12.652,10 M35,22l2,2l2-2 M24,29.505l5.455-5.455c0.621-0.621,0.938-1.43,0.953-2.243 c0.015-0.852-0.302-1.71-0.953-2.36c-0.636-0.636-1.468-0.953-2.301-0.953c-0.833,0-1.666,0.318-2.301,0.953L24,20.3l-0.852-0.852 c-0.637-0.637-1.473-0.955-2.307-0.953c-0.831,0.002-1.661,0.319-2.295,0.953c-0.639,0.639-0.957,1.478-0.953,2.316 c0.004,0.828,0.321,1.655,0.953,2.287L24,29.505z"
  }), props.children);
});
var FileBackup =
/*#__PURE__*/
React.forwardRef(function FileBackup(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,39H9V17h15V39z M24.015,35h7.5V13h-15v3.985 M31.515,31H39V9H24v4"
  }), props.children);
});
var FileTransfer =
/*#__PURE__*/
React.forwardRef(function FileTransfer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,9v12H9V9 M39,39v-6l-9-9H9v15 M30,24v9h9"
  }), props.children);
});
var FinancialConsultant =
/*#__PURE__*/
React.forwardRef(function FinancialConsultant(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,28.5V30 M32,34v1.5 M34,30h-3c-0.552,0-1,0.447-1,1c0,0.552,0.447,1,1,1h2c0.552,0,1,0.448,1,1c0,0.553-0.448,1-1,1h-3 M32,25 c-1.439,0-2.777,0.436-3.889,1.182c-0.988,0.654-1.797,1.564-2.333,2.621C25.28,29.76,25,30.849,25,32c0,3.866,3.134,7,7,7 s7-3.134,7-7C39,28.135,35.866,25,32,25z M27.76,26.4c-1.17-1.18-2.61-2.1-4.21-2.66c2.51-1.3,4.24-3.89,4.24-6.91 C27.79,12.5,24.32,9,20,9c-4.33,0-7.87,3.5-7.87,7.83c0,3.02,1.73,5.61,4.24,6.92C12.1,25.25,9,29.28,9,34.05V40"
  }), props.children);
});
var FinancialGain =
/*#__PURE__*/
React.forwardRef(function FinancialGain(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,25v2 M30,33v2 M33,27h-4.501C27.671,27,27,27.671,27,28.5c0,0.828,0.671,1.5,1.499,1.5H31.5c0.828,0,1.5,0.672,1.5,1.5 c0,0.829-0.672,1.5-1.5,1.5H27 M25,9l-0.001,13.52c1.43-0.96,3.15-1.52,5-1.52L30,9H25z M21.999,25.89L22,17h-5v13h4 M14,23H9v7h5 V23z M30,21c-1.85,0-3.57,0.56-5,1.52c-1.27,0.84-2.31,2.01-3,3.37c-0.64,1.23-1,2.63-1,4.11c0,4.97,4.03,9,9,9s9-4.03,9-9 C39,25.03,34.97,21,30,21z"
  }), props.children);
});
var FinancialNews =
/*#__PURE__*/
React.forwardRef(function FinancialNews(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,31H13c-2.2,0-4-1.8-4-4V13c0-2.2,1.8-4,4-4h22c2.2,0,4,1.8,4,4v14c0,2.2-1.8,4-4,4h-7l-4,8 M24,14v2 M24,24v2 M28,16h-6.001 C20.895,16,20,16.895,20,18c0,1.104,0.895,2,1.999,2H26c1.104,0,2,0.896,2,2c0,1.105-0.896,2-2,2h-6"
  }), props.children);
});
var FireAlarm =
/*#__PURE__*/
React.forwardRef(function FireAlarm(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,24c0,4.418-3.582,8-8,8s-8-3.582-8-8s3.582-8,8-8S32,19.582,32,24z M24,22.899c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1 S24.552,22.899,24,22.899z M14.1,14.101C11.567,16.634,10,20.134,10,24c0,3.866,1.567,7.366,4.101,9.9 M16.222,16.222 C14.231,18.212,13,20.962,13,24c0,3.038,1.231,5.788,3.222,7.778 M33.9,33.899C36.433,31.366,38,27.866,38,24 c0-3.866-1.567-7.366-4.101-9.9 M31.778,31.778C33.769,29.788,35,27.038,35,24c0-3.038-1.231-5.788-3.222-7.778"
  }), props.children);
});
var FireExtinguisher =
/*#__PURE__*/
React.forwardRef(function FireExtinguisher(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22,17.416v-4.051C22,13.164,22.164,13,22.365,13h3.27C25.836,13,26,13.164,26,13.365v4.051 M25,13V9.365 C25,9.164,24.836,9,24.635,9h-1.27C23.164,9,23,9.164,23,9.365V13 M29,22c0-2.761-2.239-5-5-5h0c-2.761,0-5,2.239-5,5v17h10V22z M23,11h-4l-6,6 M29,10v2l6,1V9L29,10z M29,11h-4 M19,32h10 M19,24h10"
  }), props.children);
});
var Firewall =
/*#__PURE__*/
React.forwardRef(function Firewall(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.828,13.172L9,16l2.828,2.828 M36.172,34.828L39,32l-2.828-2.828 M9,16h7.616 M25,16h14 M39,32H25 M16.616,32H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 9H31V39H19z"
  }), props.children);
});
var FlowChartDetail =
/*#__PURE__*/
React.forwardRef(function FlowChartDetail(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,19.999h-8 M39,22.999h-8.414 M39,13.999h-9.779 M39,16.999h-8.414 M20,9C13.925,9,9,13.925,9,20s4.925,11,11,11s11-4.925,11-11 S26.075,9,20,9z M38.984,39L27.769,27.784 M14,20h5 M26.32,11.001H24v3v3h6.58 M9.42,23.001H14v-3v-3H9.42 M30.58,23.001H24v3v3 h2.32 M24,14h-5v12h5"
  }), props.children);
});
var FlowChart =
/*#__PURE__*/
React.forwardRef(function FlowChart(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,37c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S13,35.895,13,37z M19,35c-1.105,0-2,0.895-2,2s0.895,2,2,2 c1.105,0,2-0.895,2-2S20.104,35,19,35z M29,35c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S30.105,35,29,35z M37,35 c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S38.105,35,37,35z M24,13v3.999 M15,25.999v5 M32.993,25.999v5 M33,22v-5H15v5 M19,35v-4h-8v4 M37,35v-4h-8v4 M39,9H9v4h30V9z M21,22H9v4h12V22z M39,22H27v4h12V22z"
  }), props.children);
});
var Fog =
/*#__PURE__*/
React.forwardRef(function Fog(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10,18h4 M34,18h4 M26,18h4 M18,18h4 M14,22h4 M30,22h4 M22,22h4 M14,14h4 M30,14h4 M22,14h4 M10,26h4 M34,26h4 M26,26h4 M18,26h4 M10,34h4 M34,34h4 M26,34h4 M18,34h4 M14,30h4 M30,30h4 M22,30h4"
  }), props.children);
});
var Folder =
/*#__PURE__*/
React.forwardRef(function Folder(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10,11h8.5c0.315,0,0.611,0.148,0.8,0.4l1.4,2.2c0.189,0.252,0.485,0.4,0.8,0.4H38c0.552,0,1,0.448,1,1l0,19.002 c0,0.552-0.448,1-1,1L10,35c-0.552,0-1-0.448-1-1l0-22C9,11.448,9.447,11,10,11z"
  }), props.children);
});
var Forklift =
/*#__PURE__*/
React.forwardRef(function Forklift(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.411 21.799L24.911 19.201"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17,31.764V16h3 M22,34 h9 M9,35h5V21 M21.749,27.479 M25,28v6 M33.749,24.979V13H24l-4,14.967 M21.331,23l4.33-2.5 M19,31c-1.657,0-3,1.343-3,3 c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3C22,32.343,20.656,31,19,31z M33.999,31c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3 c1.657,0,3-1.343,3-3C36.999,32.343,35.656,31,33.999,31z M36.999,34h2v-9H27l-2,3h-5v3.171"
  }), props.children);
});
var FreeTrial =
/*#__PURE__*/
React.forwardRef(function FreeTrial(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.982 19.721l-.114.209c-.587 1.009-1.886 1.355-2.903.773-1.017-.582-1.366-1.872-.78-2.881l4.203-7.26M31 21c0 1.105.895 2 2 2 1.105 0 2-.895 2-2v-6M27 21c0 1.105.895 2 2 2s2-.895 2-2v-6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 15v12c0 1.105-.895 2-2 2s-2-.895-2-2v-6.385V12.04C23 10.361 24.372 9 26.064 9h9.873C37.628 9 39 10.361 39 12.04V21c0 1.105-.895 2-2 2s-2-.895-2-2M16.5 27.17L11.5 27.17 9 31.5 11.5 35.83 16.5 35.83 19 31.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.75 30.201L18.25 24.139M10 38.428L11.5 35.83"
  }), props.children);
});
var Fuel =
/*#__PURE__*/
React.forwardRef(function Fuel(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,39H14c-1.1,0-2-0.9-2-2V14c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v23C36,38.1,35.1,39,34,39z M24,9H14v3h10V9z M31,32L17,18 M26,23l5-5 M17,32l5-5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 10L33 10"
  }), props.children);
});
var Gear =
/*#__PURE__*/
React.forwardRef(function Gear(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35.128,26.957l-1.176,2.812l2.746,2.746l-4.183,4.182l-2.738-2.738l-2.82,1.157V39h-5.915v-3.872l-2.812-1.176l-2.746,2.746 l-4.182-4.182l2.738-2.738l-1.157-2.82H9v-5.915h3.872l1.176-2.812l-2.746-2.746l4.182-4.182l2.738,2.738l2.82-1.157V9h5.915v3.872 l2.812,1.176l2.746-2.746l4.183,4.182l-2.738,2.738l1.157,2.82H39v5.915H35.128z M24,17c-3.866,0-7,3.134-7,7s3.134,7,7,7 s7-3.134,7-7S27.866,17,24,17z"
  }), props.children);
});
var GlobalBusinessServices =
/*#__PURE__*/
React.forwardRef(function GlobalBusinessServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.441,28.323l1.668-3.329h1.886l1.886-5.653l2.829,2.825l3.281-3.276 M16.5,16.5C12.358,16.5,9,19.858,9,24s3.358,7.5,7.5,7.5 S24,28.142,24,24S20.642,16.5,16.5,16.5z M17.572,31.424C19.769,34.211,23.176,36,27,36c6.627,0,12-5.373,12-12s-5.373-12-12-12 c-3.824,0-7.231,1.789-9.428,4.576 M27,36V12 M24,24h15 M21,18h16.394 M21,30h16.394 M21.653,29.449C22.646,33.338,24.667,36,27,36 c3.314,0,6-5.373,6-12s-2.686-12-6-12c-2.333,0-4.354,2.662-5.347,6.55"
  }), props.children);
});
var GlobalFinanceEuro =
/*#__PURE__*/
React.forwardRef(function GlobalFinanceEuro(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.154,25.368h3.691 M27.154,22L29,24.233L30.846,22 M29,27v-2.767 M24,39c8.284,0,15-6.716,15-15c0-8.284-6.716-15-15-15 C15.716,9,9,15.716,9,24C9,32.284,15.716,39,24,39z M24,9v30 M24,24L9,24 M39,24l-5,0 M16,16l-4.5,0 M16,32l-4.5,0 M14.358,24 c0,8.284,4.317,15,9.642,15s9.642-6.716,9.642-15S29.325,9,24,9S14.358,15.716,14.358,24z M36.5,16L24,16 M36.5,32L24,32 M20,14.5 V16 M20,20v1.5 M22,16h-3c-0.552,0-1,0.447-1,1c0,0.552,0.447,1,1,1h2c0.552,0,1,0.448,1,1c0,0.553-0.448,1-1,1h-3 M18,29.5h3 M22,27h-2c-1.105,0-2,0.895-2,2v1c0,1.105,0.895,2,2,2h2"
  }), props.children);
});
var GlobalFinanceSterling =
/*#__PURE__*/
React.forwardRef(function GlobalFinanceSterling(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.154,25.368h3.691 M27.154,22L29,24.233L30.846,22 M29,27v-2.767 M24,39c8.284,0,15-6.716,15-15c0-8.284-6.716-15-15-15 C15.716,9,9,15.716,9,24C9,32.284,15.716,39,24,39z M24,9v30 M24,24L9,24 M39,24l-5,0 M16,16l-4.5,0 M16,32l-4.5,0 M14.358,24 c0,8.284,4.317,15,9.642,15s9.642-6.716,9.642-15S29.325,9,24,9S14.358,15.716,14.358,24z M36.5,16L24,16 M36.5,32L24,32 M17.5,29.49h4.167 M22.084,27.827C21.667,27.411,21.024,27,20.417,27c-0.998,0-1.807,0.62-1.807,1.724 c0,0.837,0.736,0.778,0.736,1.609c0,0.749-0.579,1.181-1.429,1.667h4.167 M20,14.5V16 M20,20v1.5 M22,16h-3c-0.552,0-1,0.447-1,1 c0,0.552,0.447,1,1,1h2c0.552,0,1,0.448,1,1c0,0.553-0.448,1-1,1h-3"
  }), props.children);
});
var GlobalNetwork =
/*#__PURE__*/
React.forwardRef(function GlobalNetwork(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,31c-3.866,0-7-3.134-7-7s3.134-7,7-7s7,3.134,7,7S27.866,31,24,31z M21.839,30.66l3.553-3.352 c0.193-0.182,0.236-0.472,0.103-0.702l-2.687-4.667c-0.133-0.231-0.089-0.522,0.105-0.704l1.858-1.737 c0.195-0.182,0.238-0.474,0.105-0.704l-1.035-1.792 M20.498,30.062l1.236-2.137c0.102-0.177,0.103-0.395,0-0.573l-0.671-1.163 c-0.133-0.23-0.09-0.521,0.104-0.703l1.016-0.955c0.194-0.182,0.236-0.473,0.104-0.703l-0.758-1.313 c-0.102-0.177-0.291-0.286-0.496-0.286h-1.845c-0.204,0-0.393-0.109-0.495-0.285l-0.796-1.371 M29.432,19.634l-1.439,2.507 c-0.101,0.177-0.101,0.394,0,0.57l1.117,1.942c0.102,0.178,0.291,0.287,0.496,0.287h1.314 M28.43,35.7c3.34-1.27,6-3.93,7.26-7.27 M12.31,28.43c1.26,3.34,3.92,6,7.26,7.27 M35.69,19.57c-1.27-3.34-3.92-5.99-7.26-7.26 M19.57,12.31 c-3.34,1.27-5.99,3.92-7.26,7.26 M24,34c-1.381,0-2.5,1.119-2.5,2.5S22.619,39,24,39s2.5-1.119,2.5-2.5S25.381,34,24,34z M24,9 c-1.381,0-2.5,1.119-2.5,2.5S22.619,14,24,14s2.5-1.119,2.5-2.5S25.381,9,24,9z M11.5,21.5C10.119,21.5,9,22.619,9,24 s1.119,2.5,2.5,2.5S14,25.381,14,24S12.881,21.5,11.5,21.5z M36.5,21.5c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 S39,25.381,39,24S37.881,21.5,36.5,21.5z"
  }), props.children);
});
var GlobalTechnologyServices =
/*#__PURE__*/
React.forwardRef(function GlobalTechnologyServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.066,20.144c1.691,0.467,2.933,2.017,2.933,3.856c0,1.839-1.242,3.389-2.933,3.856 M22.934,20.143 C21.242,20.61,19.999,22.16,19.999,24s1.243,3.39,2.935,3.857 M16.5,28v-8 M16.5,16.5C12.358,16.5,9,19.858,9,24s3.358,7.5,7.5,7.5 S24,28.142,24,24S20.642,16.5,16.5,16.5z M17.572,31.424C19.769,34.211,23.176,36,27,36c6.627,0,12-5.373,12-12s-5.373-12-12-12 c-3.824,0-7.231,1.789-9.428,4.576 M27,36V12 M24,24h15 M21,18h16.394 M21,30h16.394 M21.653,29.449C22.646,33.338,24.667,36,27,36 c3.314,0,6-5.373,6-12s-2.686-12-6-12c-2.333,0-4.354,2.662-5.347,6.55"
  }), props.children);
});
var GlobeLocations =
/*#__PURE__*/
React.forwardRef(function GlobeLocations(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.5,23.861 c0,6.627-5.373,12-12,12s-12-5.373-12-12s5.373-12,12-12S34.5,17.234,34.5,23.861z M14.999,36.854 c2.207,1.277,4.769,2.007,7.501,2.007c8.284,0,15-6.716,15-15c0-5.552-3.016-10.399-7.499-12.993 M28.501,13.467L31,9.139 M14,38.584l2.499-4.328"
  }), React.createElement("path", {
    d: "M17.75,16c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75S17.75,15.586,17.75,16z M16,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S16.414,20.25,16,20.25z M30.5,20.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.914,20.25,30.5,20.25z M30.5,23.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S30.914,23.25,30.5,23.25z M22.5,22.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S22.914,22.25,22.5,22.25z M26.5,29.25 c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S26.914,29.25,26.5,29.25z"
  }), props.children);
});
var Globe =
/*#__PURE__*/
React.forwardRef(function Globe(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.484,9 c5.223,1.687,9.016,6.886,9.016,12.67c0,7.18-5.836,13-13.016,13c-3.08,0-5.911-1.071-8.138-2.862 M22.5,11 C16.701,11,12,15.701,12,21.5S16.701,32,22.5,32S33,27.299,33,21.5S28.299,11,22.5,11z M22.5,34.67V39 M16.484,39h12"
  }), props.children);
});
var Group =
/*#__PURE__*/
React.forwardRef(function Group(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,39 v-7.492c0-3.781,2.624-6.947,6.149-7.782c-1.596-0.71-2.709-2.306-2.709-4.166c0-2.519,2.042-4.56,4.56-4.56s4.56,2.042,4.56,4.56 c0,1.859-1.114,3.455-2.709,4.166C29.376,24.561,32,27.727,32,31.508V39 M38,33v-7.492c0-3.781-2.624-6.947-6.149-7.782 c1.595-0.71,2.709-2.306,2.709-4.166C34.56,11.042,32.519,9,30,9s-4.56,2.042-4.56,4.56c0,0.646,0.134,1.259,0.377,1.816 M22.184,15.376c0.242-0.556,0.377-1.17,0.377-1.816C22.56,11.042,20.519,9,18,9s-4.56,2.042-4.56,4.56 c0,1.859,1.114,3.455,2.709,4.166C12.624,18.561,10,21.727,10,25.508V33"
  }), props.children);
});
var HailHeavy =
/*#__PURE__*/
React.forwardRef(function HailHeavy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M15,33.98c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S15,33.427,15,33.98z M17.5,35.5c-0.552,0-1,0.448-1,1 s0.448,1,1,1s1-0.448,1-1S18.052,35.5,17.5,35.5z M27.5,35.5c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S28.052,35.5,27.5,35.5 z M24,32.98c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S24.552,32.98,24,32.98z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.25,31.598L16.75,29 M18.75,34.196l3-5.196 M25.25,31.598L26.75,29 M28.75,34.196l3-5.196 M33.426,15 c-0.627,0-1.458,0.108-2.02,0.299C30.24,12.304,27.335,10,23.927,10c-4.177,0-7.606,3.537-7.992,7.613 C15.254,17.225,14.469,17,13.631,17C11.058,17,9,19.086,9,21.658c0,2.573,2.058,4.309,4.631,4.342h19.795 C36.504,25.967,39,23.652,39,20.574S36.504,15,33.426,15z"
  }), props.children);
});
var HailMixed =
/*#__PURE__*/
React.forwardRef(function HailMixed(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M23.495,30c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S23.495,29.448,23.495,30z M15.995,32.5c-0.552,0-1,0.448-1,1 s0.448,1,1,1s1-0.448,1-1S16.548,32.5,15.995,32.5z M18.495,36c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S19.048,36,18.495,36 z M30.995,29c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S31.548,29,30.995,29z M24.495,32.5c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S25.048,32.5,24.495,32.5z M26.995,36c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S27.548,36,26.995,36z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.995,34.366l1-1.732 M17.495,30.866l1-1.732 M13.495,37.866l1-1.732 M28.495,34.366l1-1.732 M25.995,30.866l1-1.732 M21.995,37.866l1-1.732 M39,20.574c0,3.078-2.495,5.393-5.574,5.426H13.631C11.058,25.967,9,24.231,9,21.658 C9,19.086,11.058,17,13.631,17c0.839,0,1.624,0.225,2.303,0.613C16.32,13.537,19.75,10,23.927,10c3.408,0,6.313,2.304,7.479,5.299 C31.969,15.108,32.799,15,33.426,15C36.504,15,39,17.495,39,20.574z"
  }), props.children);
});
var Hail =
/*#__PURE__*/
React.forwardRef(function Hail(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18,31c0,0.552-0.448,1-1,1c-0.552,0-1-0.448-1-1s0.448-1,1-1C17.553,30,18,30.448,18,31z M20,35c-0.552,0-1,0.448-1,1 s0.448,1,1,1c0.552,0,1-0.448,1-1S20.553,35,20,35z M27,35c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S27.553,35,27,35 z M24,30c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S24.553,30,24,30z M31,30c-0.552,0-1,0.448-1,1s0.448,1,1,1 c0.552,0,1-0.448,1-1S31.553,30,31,30z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,21.574c0,3.078-2.495,5.393-5.574,5.426H13.631C11.058,26.967,9,25.231,9,22.658C9,20.086,11.058,18,13.631,18 c0.839,0,1.624,0.225,2.303,0.613C16.32,14.537,19.75,11,23.927,11c3.408,0,6.313,2.304,7.479,5.299 C31.969,16.108,32.799,16,33.426,16C36.504,16,39,18.495,39,21.574z"
  }), props.children);
});
var HandicapActive =
/*#__PURE__*/
React.forwardRef(function HandicapActive(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,11c-1.381,0-2.5,1.119-2.5,2.5S25.619,16,27,16s2.5-1.119,2.5-2.5S28.381,11,27,11z M35,34l-3,2l-3.712-6.478 c-0.178-0.31-0.508-0.502-0.866-0.503l-6.069-0.012c-1.498-0.003-2.461-1.591-1.771-2.921l3.421-6.595 C23.495,18.651,24.051,18,25,18c0.98,0,1.353,0.417,1.643,1.109L28.071,24h5 M17,22l2-4h6 M26,31c0,3.866-3.134,7-7,7s-7-3.134-7-7 s3.134-7,7-7"
  }), props.children);
});
var Handicap =
/*#__PURE__*/
React.forwardRef(function Handicap(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,11 c-1.381,0-2.5,1.119-2.5,2.5S21.619,16,23,16s2.5-1.119,2.5-2.5S24.381,11,23,11z M36,34l-3,2l-3.712-6.478 c-0.178-0.311-0.509-0.503-0.868-0.503l-5.42,0c-1.657,0-3-1.343-3-3L20,20c0-1.262,0.944-2,2-2c0.941,0,1.454,0.521,1.901,1.285 L26.02,23H31 M27,31c0,3.866-3.134,7-7,7s-7-3.134-7-7c0-3.171,2.109-5.85,5-6.71"
  }), props.children);
});
var HardDriveNetwork =
/*#__PURE__*/
React.forwardRef(function HardDriveNetwork(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M27.999,14c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C28.999,13.552,28.551,14,27.999,14z M29,24.001 c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S29,24.553,29,24.001z M29.001,35.002c0-0.552-0.448-1-1-1 c-0.552,0-1,0.448-1,1s0.448,1,1,1C28.553,36.002,29.001,35.554,29.001,35.002z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,17H9V9h23V17z M32,20H9v8h23V20z M32,31H9v8h23V31z M34,24h5 M34,35l5,0V13h-5"
  }), props.children);
});
var HardDrive =
/*#__PURE__*/
React.forwardRef(function HardDrive(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M34,14c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S34.552,14,34,14z M35,24c0-0.552-0.448-1-1-1c-0.552,0-1,0.448-1,1 s0.448,1,1,1C34.552,25,35,24.552,35,24z M35,35c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1S35,35.552,35,35z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,17H9V9h30V17z M39,20H9v8h30V20z M39,31H9v8h30V31z"
  }), props.children);
});
var HardIceCream =
/*#__PURE__*/
React.forwardRef(function HardIceCream(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,24l-5,15l-5-15 M19.249,18.215c-1.9,0-2.851,1.446-2.851,2.893c0,1.928,1.425,2.893,3.326,2.893h9.027 c1.425,0,2.851-1.143,2.851-2.893c0-1.446-0.95-2.893-2.851-2.893H24.95 M29.891,18.368c0.413-0.857,0.644-1.818,0.644-2.833 C30.535,11.926,27.609,9,24,9s-6.535,2.926-6.535,6.535c0,1.026,0.237,1.998,0.658,2.862"
  }), props.children);
});
var Hazy =
/*#__PURE__*/
React.forwardRef(function Hazy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,27h30 M11,31h5 M31.985,23h5 M20,31h10 M11,23h8 M9,19h7 M20,35h5 M24,24c2.761,0,5-2.239,5-5s-2.239-5-5-5s-5,2.239-5,5"
  }), props.children);
});
var Headphones =
/*#__PURE__*/
React.forwardRef(function Headphones(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,33v-9c0-8.284,6.716-15,15-15s15,6.716,15,15v9 M15,37v-8c0-1.105-0.895-2-2-2h0c-1.105,0-2,0.895-2,2v8c0,1.105,0.895,2,2,2h0 C14.105,39,15,38.105,15,37z M37,37v-8c0-1.105-0.895-2-2-2h0c-1.105,0-2,0.895-2,2v8c0,1.105,0.895,2,2,2h0 C36.105,39,37,38.105,37,37z"
  }), props.children);
});
var HeartHealth =
/*#__PURE__*/
React.forwardRef(function HeartHealth(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,40c0-6.871,5.229-12.624,11.636-14.143c-2.9-1.291-4.924-4.192-4.924-7.57C15.712,13.71,19.423,10,24,10s8.288,3.71,8.288,8.287 c0,3.379-2.025,6.28-4.924,7.57C33.77,27.376,39,33.129,39,40 M23.999,39.001l3.962-3.962c0.451-0.451,0.681-1.038,0.692-1.629 c0.011-0.619-0.22-1.242-0.692-1.714c-0.462-0.462-1.067-0.692-1.672-0.692c-0.605,0-1.21,0.231-1.672,0.692l-0.619,0.619 l-0.619-0.619c-0.463-0.463-1.07-0.694-1.676-0.692c-0.604,0.001-1.207,0.232-1.667,0.692c-0.464,0.464-0.695,1.074-0.692,1.682 c0.003,0.602,0.233,1.202,0.692,1.661L23.999,39.001z"
  }), props.children);
});
var Heart =
/*#__PURE__*/
React.forwardRef(function Heart(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.263,24.118c-1.484-1.484-2.231-3.429-2.231-5.374c0-1.954,0.741-3.909,2.231-5.4c1.487-1.487,3.435-2.231,5.384-2.231 c1.951-0.001,3.902,0.743,5.39,2.231l1.995,1.995l1.995-1.995c1.489-1.489,3.442-2.233,5.395-2.231 c1.947,0.002,3.894,0.746,5.38,2.231c1.488,1.488,2.231,3.437,2.231,5.387c0,1.95-0.744,3.899-2.231,5.387L24.032,36.887 L11.263,24.118z"
  }), props.children);
});
var HeatMap =
/*#__PURE__*/
React.forwardRef(function HeatMap(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38,38h-4v-4h4V38z M12,26h-2v2h2V26z M38,13h-2v2h2V13z M34,22h-2v2h2V22z M29,9h-2v2h2V9z M24,27h-2v2h2V27z M14,16h-2v2h2V16z M22,20h-2v2h2V20z M20,11h-4v4h4V11z M32,29h-4v4h4V29z M27,24h-3v3h3V24z M23,36h-3v3h3V36z M39,26h-3v3h3V26z M12,18H9v3h3V18z M36,15h-3v3h3V15z M15,21h-3v3h3V21z M28,14h-6v6h6V14z M18,28h-6v6h6V28z"
  }), props.children);
});
var HighFive =
/*#__PURE__*/
React.forwardRef(function HighFive(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.5,34v-8.619c0-2.836,1.968-5.21,4.612-5.837c-1.197-0.533-2.032-1.73-2.032-3.124c0-1.889,1.531-3.42,3.42-3.42 s3.42,1.531,3.42,3.42c0,1.394-0.836,2.592-2.032,3.124c3.701-1.268,4.944-2.725,6.206-4.061c1.262-1.336,2.008-0.849,2.405-0.483 c0.442,0.406,1,1.263-0.313,2.625c-1.312,1.362-4.687,4.784-4.687,4.784V34 M28.5,34V22.409c0,0-2.39-2.423-3.93-4.003 M39.5,34 v-8.619c0-2.836-1.968-5.21-4.612-5.837c1.197-0.533,2.032-1.73,2.032-3.124c0-1.889-1.531-3.42-3.42-3.42 c-1.889,0-3.42,1.531-3.42,3.42c0,1.394,0.836,2.592,2.032,3.124c-3.701-1.268-5.119-2.956-6.381-4.291"
  }), props.children);
});
var HomeFront =
/*#__PURE__*/
React.forwardRef(function HomeFront(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,24L24,9l0,0l15,15 M27,39V27h-6v12 M11,27v12 M37,27v12 M9,39h30 M37,22v-5 M21,24.003L27,24"
  }), props.children);
});
var HomeGarage =
/*#__PURE__*/
React.forwardRef(function HomeGarage(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,24L24,9l0,0l15,15 M37,22v-5 M32,39V27H16v12 M11,27v12 M37,27v12 M9,39h30 M16,24.003L32,24 M16,31.003L31.999,31 M16,35.003 L31.999,35"
  }), props.children);
});
var HomeProfile =
/*#__PURE__*/
React.forwardRef(function HomeProfile(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,39v-8h6v8 M11,26v13 M37,26v13 M9,39h30 M11.412,14L9,23h30l-2.412-9H11.412z M18,29v-3 M34,29v-3 M14,29v-3 M14,14V9 M30,29 v-3"
  }), props.children);
});
var Hospital =
/*#__PURE__*/
React.forwardRef(function Hospital(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33,12.5h4 M35,10.5v4 M24,32h-5.5v7H24V32z M39,9h-8l0,7H9v23h30V9z M13,21v-2 M18.5,21v-2 M24,21v-2 M29.5,21v-2 M35,21v-2 M13,25v-2 M18.5,25v-2 M24,25v-2 M29.5,25v-2 M35,25v-2 M13,29v-2 M18.5,29v-2 M24,29v-2 M29.5,29v-2 M35,29v-2 M13,33v-2 M29.5,33v-2 M35,33v-2"
  }), props.children);
});
var Humid =
/*#__PURE__*/
React.forwardRef(function Humid(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8.9,16 c0.739,0,1.351-0.54,1.875-1c0.524-0.46,1.136-1,1.875-1s1.351,0.54,1.875,1c0.524,0.46,1.136,1,1.875,1 c0.739,0,1.351-0.54,1.875-1c0.524-0.46,1.136-1,1.875-1c0.739,0,1.351,0.54,1.875,1c0.524,0.46,1.136,1,1.875,1 c0.739,0,1.351-0.54,1.875-1c0.524-0.46,1.136-1,1.875-1c0.739,0,1.351,0.54,1.875,1c0.524,0.46,1.136,1,1.875,1 s1.351-0.54,1.875-1s1.136-1,1.875-1c0.739,0,1.326,0.54,1.85,1s1.164,1,1.903,1 M38.903,22c-0.739,0-1.379-0.54-1.903-1 s-1.111-1-1.85-1c-0.739,0-1.351,0.54-1.875,1s-1.136,1-1.875,1s-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1 c-0.739,0-1.351,0.54-1.875,1c-0.524,0.46-1.136,1-1.875,1c-0.739,0-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1 c-0.739,0-1.351,0.54-1.875,1c-0.524,0.46-1.136,1-1.875,1c-0.739,0-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1 s-1.351,0.54-1.875,1c-0.524,0.46-1.136,1-1.875,1 M38.903,28c-0.739,0-1.379-0.54-1.903-1s-1.111-1-1.85-1 c-0.739,0-1.351,0.54-1.875,1s-1.136,1-1.875,1s-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1c-0.739,0-1.351,0.54-1.875,1 c-0.524,0.46-1.136,1-1.875,1c-0.739,0-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1c-0.739,0-1.351,0.54-1.875,1 c-0.524,0.46-1.136,1-1.875,1c-0.739,0-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1s-1.351,0.54-1.875,1 c-0.524,0.46-1.136,1-1.875,1 M38.903,34c-0.739,0-1.379-0.54-1.903-1s-1.111-1-1.85-1c-0.739,0-1.351,0.54-1.875,1 s-1.136,1-1.875,1s-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1c-0.739,0-1.351,0.54-1.875,1c-0.524,0.46-1.136,1-1.875,1 c-0.739,0-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1c-0.739,0-1.351,0.54-1.875,1c-0.524,0.46-1.136,1-1.875,1 c-0.739,0-1.351-0.54-1.875-1c-0.524-0.46-1.136-1-1.875-1s-1.351,0.54-1.875,1c-0.524,0.46-1.136,1-1.875,1"
  }), props.children);
});
var Hurricane =
/*#__PURE__*/
React.forwardRef(function Hurricane(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33,24c0,4.971-4.029,9-9,9s-9-4.029-9-9s4.029-9,9-9S33,19.029,33,24z M24,20c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4 S26.209,20,24,20z M34,9c-12.895,0-19,6-19,15 M14,39c12.895,0,19-6,19-15"
  }), props.children);
});
var HybridCloudServices =
/*#__PURE__*/
React.forwardRef(function HybridCloudServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.001,27c3,0,4.999-1.604,4.999-4.153S36.932,18,34.383,18c0-5.098-4.13-9-9.228-9c-3.458,0-6.573,2.287-8.154,5.102 C16.617,14.036,16.224,14,15.821,14C11.998,14,9,16.715,9,20.539S12.177,27,16.001,27 M32,25H18v-5h14V25z M20,22.5h2 M32,39H18v-5 h14V39z M20,36.5h2 M29,34v-2.5c0-1.105-0.895-2-2-2h-4c-1.105,0-2-0.895-2-2V25"
  }), props.children);
});
var HybridCloud =
/*#__PURE__*/
React.forwardRef(function HybridCloud(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24.003,10.142l-9.467,5.466 M24.003,37.855l9.462-5.463 M12,15v13 M10.206,29.892l11.258,6.5 M36,20v13 M37.794,18.108 l-11.258-6.5 M24,39v-9l-5.196-3l10.392-6L24,18V9 M24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15S32.284,9,24,9z"
  }), props.children);
});
var IbmIx =
/*#__PURE__*/
React.forwardRef(function IbmIx(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,24l-4.75,4.75L14.5,24l4.75-4.75L24,24z M14.5,14.5l-4.75,4.75L14.5,24l4.75-4.75L14.5,14.5z M19.25,28.75L24,33.5l4.75-4.75 l4.75,4.75l4.75-4.75L33.5,24l4.75-4.75L33.5,14.5l-4.75,4.75L24,14.5l-4.75,4.75L24,24L19.25,28.75z M14.5,24l-4.75,4.75 l4.75,4.75l4.75-4.75L14.5,24z"
  }), props.children);
});
var IbmZ =
/*#__PURE__*/
React.forwardRef(function IbmZ(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.5,39 l15-30 M16.5,9l17.143,8.571 M31.5,39l-17.143-8.571 M28.5,15L12,33v6h24v-6H19.5 M19.5,33L36,15V9H12v6h16.5"
  }), props.children);
});
var Idea =
/*#__PURE__*/
React.forwardRef(function Idea(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,9 c5.081,0,9,4.148,9,9.264c0,2.543-1.075,4.982-2.858,6.837C28.031,27.297,28,29.818,28,31.547V33h-8v-1.453 c0-1.729-0.031-4.25-2.142-6.446C16.075,23.246,15,20.807,15,18.264C15,13.148,18.919,9,24,9 M20,35h8 M20,37h8 M21,39h6"
  }), props.children);
});
var Ideate =
/*#__PURE__*/
React.forwardRef(function Ideate(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.652,27C35.298,32.733,30.147,37,24,37 c-7.18,0-13-5.82-13-13 M9,26l2-2l2,2 M11.351,21c1.354-5.733,6.505-10,12.652-10C31.183,11,37,16.82,37,24 M39,22l-2,2l-2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,15 c2.973,0,5.5,2.45,5.5,5.4c0,1.467-0.863,2.873-1.906,3.942c-1.235,1.266-1.529,2.392-1.529,3.389V28h-4.13v-0.268 c0-0.997-0.294-2.123-1.529-3.389c-1.044-1.07-1.906-2.476-1.906-3.942C18.5,17.449,21.027,15,24,15 M22,30h4 M23,32h2"
  }), props.children);
});
var Innovate =
/*#__PURE__*/
React.forwardRef(function Innovate(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,9c5.081,0,9,4.148,9,9.264c0,2.543-1.075,4.982-2.858,6.837C28.031,27.297,28,29.818,28,31.547V33h-8v-1.453 c0-1.729-0.031-4.25-2.142-6.446C16.075,23.246,15,20.807,15,18.264C15,13.148,18.919,9,24,9 M20,35h8 M20,37h8 M21,39h6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5,18.5 c0,1.381-1.119,2.5-2.5,2.5c-1.381,0-2.5-1.119-2.5-2.5S22.619,16,24,16C25.381,16,26.5,17.119,26.5,18.5z M30,19.683v-2.366 h-1.553l-0.463-1.128l1.095-1.095l-1.673-1.673l-1.098,1.098l-1.125-0.47V12.5h-2.366v1.553l-1.128,0.463l-1.095-1.095 l-1.673,1.673l1.098,1.099l-0.471,1.125H18v2.366h1.553l0.463,1.128l-1.095,1.095l1.673,1.673l1.098-1.098l1.125,0.47V24.5h2.366 v-1.553l1.128-0.463l1.095,1.095l1.673-1.673l-1.099-1.098l0.471-1.125H30z"
  }), props.children);
});
var Integration =
/*#__PURE__*/
React.forwardRef(function Integration(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,23.99L31.5,37h-15L9,23.99L16.5,11h15L39,23.99z M9,23.99h30 M16.5,37l15-26 M31.5,37l-15-26"
  }), props.children);
});
var Intelligence =
/*#__PURE__*/
React.forwardRef(function Intelligence(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 24.5c0-1.434-.865-2.663-2.099-3.204C34.961 21.039 35 20.775 35 20.5c0-1.434-.865-2.663-2.099-3.204C32.961 17.039 33 16.775 33 16.5c0-1.4-.828-2.94-2.016-3.5-.124-1.66-1.605-3-3.484-3-1.933 0-3.5 1.567-3.5 3.5v22c0 1.933 1.567 3.5 3.5 3.5 1.777 0 3.229-1.33 3.454-3.046C32.67 35.729 34 34.277 34 32.5c0-.22-.026-.434-.065-.643 1.476-.411 2.565-1.75 2.565-3.357 0-.597-.164-1.151-.428-1.643C36.643 26.234 37 25.411 37 24.5zM11 24.5c0-1.434.865-2.663 2.099-3.204C13.039 21.039 13 20.775 13 20.5c0-1.434.865-2.663 2.099-3.204C15.039 17.039 15 16.775 15 16.5c0-1.4.828-2.599 2.016-3.159C17.101 11.483 18.621 10 20.5 10c1.933 0 3.5 1.567 3.5 3.5v22c0 1.933-1.567 3.5-3.5 3.5-1.777 0-3.229-1.33-3.454-3.046C15.33 35.729 14 34.277 14 32.5c0-.22.026-.434.065-.643-1.476-.411-2.565-1.75-2.565-3.357 0-.597.164-1.151.428-1.643C11.357 26.234 11 25.411 11 24.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 13L30.984 13M24 14c0 2.026 1 3 3 3M24 20c0-2.026-1-3-3-3M32.901 17.296C31.802 18.217 31 19 31 20v3M19.099 34C20.198 34.921 21 35.704 21 36.704v2M31 20L28 20M33 27L36.072 27M28 28c0 1.482.56 2 1.935 2l1.009-.011c1.609-.016 2.431.48 2.991 1.869M19 29c.5 1.5 1.5 2 2.5 2l2.484-.011M30.001 33.263C30.597 33.824 31 34.607 31 35.954M27 33c-2 0-3 0-3 2M25 38L27 36M28 24c-2 0-1 .986-4 .986-2 0-1.5 1.514-4 1.014M18 14.164L17.016 13.341M15.099 17.296L17 19.71C17.725 20.59 18.175 21 19 21h2M16 23L18 21M15 27L11.928 27M16 31L14.065 31.857"
  }), props.children);
});
var Intercom =
/*#__PURE__*/
React.forwardRef(function Intercom(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M24.5,33.5c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5S23.724,33,24,33S24.5,33.224,24.5,33.5z M24,31 c-0.276,0-0.5,0.224-0.5,0.5S23.724,32,24,32s0.5-0.224,0.5-0.5S24.276,31,24,31z M24,35c-0.276,0-0.5,0.224-0.5,0.5 S23.724,36,24,36s0.5-0.224,0.5-0.5S24.276,35,24,35z M26,33c-0.276,0-0.5,0.224-0.5,0.5S25.724,34,26,34s0.5-0.224,0.5-0.5 S26.276,33,26,33z M22,33c-0.276,0-0.5,0.224-0.5,0.5S21.724,34,22,34s0.5-0.224,0.5-0.5S22.276,33,22,33z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,26.5 c0,0.828-0.672,1.5-1.5,1.5S31,27.328,31,26.5s0.672-1.5,1.5-1.5S34,25.672,34,26.5z M37,9H11v30h26V9z M34,12H14v10h20V12z M20,25h-6v3h6V25z"
  }), props.children);
});
var IotMunich =
/*#__PURE__*/
React.forwardRef(function IotMunich(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,39h30 M20,32h8 M20,35h8 M20,22h8 M20,13.001L14,9v30h6V13.001z M34,21l-6-4v22h6V21z M14,18h4 M18,16h2 M16,20h2 M14,26h2 M18,34h2 M14,36h4 M28,26h2 M30,24h4 M32,34h2 M30,36h2"
  }), props.children);
});
var Java =
/*#__PURE__*/
React.forwardRef(function Java(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(11.442 23.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M39,9H9v23h30 V9z"
  }), props.children);
});
var Javascript =
/*#__PURE__*/
React.forwardRef(function Javascript(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M38.999,9H9 L9,32H39L38.999,9z"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(17 23.998)"
  }), props.children);
});
var Justice =
/*#__PURE__*/
React.forwardRef(function Justice(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,19 c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S26,17.895,26,19z M24,36c-1.66,0-3,1.34-3,3h6C27,37.34,25.66,36,24,36z M13.5,15.649L9,23.524c0,2.485,2.015,4.5,4.5,4.5s4.5-2.015,4.5-4.5L13.5,15.649z M9,23.649h9 M34.5,10L30,17.875 c0,2.485,2.015,4.5,4.5,4.5s4.5-2.015,4.5-4.5L34.5,10z M30,18h9 M34,39h-7h-6h-7 M13.5,15.62l21-5.62 M24,36l0-15 M24,13l0,4"
  }), props.children);
});
var KeyUsers =
/*#__PURE__*/
React.forwardRef(function KeyUsers(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,39v-7.492c0-3.781,2.624-6.947,6.149-7.782c-1.596-0.71-2.709-2.306-2.709-4.166c0-2.519,2.042-4.56,4.56-4.56 s4.56,2.042,4.56,4.56c0,1.859-1.114,3.455-2.709,4.166C29.376,24.561,32,27.727,32,31.508V39 M38,33v-7.492 c0-3.781-2.624-6.947-6.149-7.782c1.595-0.71,2.709-2.306,2.709-4.166C34.56,11.042,32.519,9,30,9s-4.56,2.042-4.56,4.56 c0,0.646,0.134,1.259,0.377,1.816 M22.184,15.376c0.242-0.556,0.377-1.17,0.377-1.816C22.56,11.042,20.519,9,18,9 s-4.56,2.042-4.56,4.56c0,1.859,1.114,3.455,2.709,4.166C12.624,18.561,10,21.727,10,25.508V33 M22.883,31.435h-3.617l2.926,2.126 L21.074,37L24,34.874L26.926,37l-1.118-3.44l2.926-2.126h-3.617L24,27.995L22.883,31.435z"
  }), props.children);
});
var KnowsDarkData =
/*#__PURE__*/
React.forwardRef(function KnowsDarkData(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,11.598l-1.5,2.598h-3L9,11.598L10.5,9h3L15,11.598z M20.498,21.997c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c1.381,0,2.5-1.119,2.5-2.5S21.878,21.997,20.498,21.997z M11.5,34C10.119,34,9,35.119,9,36.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5 S12.881,34,11.5,34z M28.498,34c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5c1.381,0,2.5-1.119,2.5-2.5S29.878,34,28.498,34z M26.998,25.997c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2c1.105,0,2-0.895,2-2C28.998,26.892,28.102,25.997,26.998,25.997z M23.69,12.997l-6.692,1.793l4.899,4.899L23.69,12.997z M33.981,37.655L39,39l-1.345-5.019L33.981,37.655z M30.998,30.997l3,3 M24.338,21.656l5.657-5.657 M35.194,15.999l-5.196,3l3,5.196l5.196-3L35.194,15.999z M19.802,30.804l-3,5.196l5.196,3l3-5.196 L19.802,30.804z M11.995,24.998v-7 M9.167,22.169l2.828,2.828l2.828-2.828 M16.998,28.995l-3,3"
  }), props.children);
});
var Language_01 =
/*#__PURE__*/
React.forwardRef(function Language_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.533 24L14.533 24"
  }), React.createElement("defs", null), React.createElement("clipPath", {
    id: "b"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.033 27L12.533 19.5 16.033 27",
    clipPath: "url(#b)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.533,12.5 c0,0-2.533,0-3.033,0c-1,0-2-0.155-2-1.5c0-1,0.622-2,1.622-2S33,9.5,33,12c0,2.698-1.467,3-2.967,3l0,0c-1.5,0-3-0.5-3-2.5V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39c0-4.625-3.145-8.505-7.409-9.648 1.731-.926 2.91-2.751 2.91-4.852C29.501 21.463 27.038 19 24 19s-5.501 2.463-5.501 5.501c0 2.101 1.179 3.925 2.91 4.852C17.156 30.426 14 34.375 14 39M15.004 10h6M18.004 8.5V10M15.004 15c4.709 0 4.498-4 4.498-5M16.539 12c.348 1.219 1.826 3 4.466 3M32.033 20L39.533 20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.033 20L37.033 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.033,22.5h-2 c-1.139,0-2,0.5-2,1.5c0,0.94,0.731,1.683,1.5,2"
  }), props.children);
});
var Language_02 =
/*#__PURE__*/
React.forwardRef(function Language_02(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.5,12.5 c0,0-2.533,0-3.033,0c-1,0-2-0.155-2-1.5c0-1,0.622-2,1.622-2s1.878,0.5,1.878,3c0,2.698-1.467,3-2.967,3l0,0c-1.5,0-3-0.5-3-2.5 V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,39c0-4.625-3.145-8.505-7.409-9.648c1.731-0.926,2.91-2.751,2.91-4.852C29.501,21.463,27.038,19,24,19 s-5.501,2.463-5.501,5.501c0,2.101,1.179,3.925,2.91,4.852C17.156,30.426,14,34.375,14,39 M15.004,10h6 M18.004,8.5V10 M15.004,15 c4.709,0,4.498-4,4.498-5 M16.539,12c0.348,1.219,1.826,3,4.466,3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 20L36 23 33.5 23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33,20v3.25c0,1.795,1.343,2.75,3,2.75s3-0.955,3-2.75V20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.494 20L9.5 20 11.835 22.998 9.5 26 14.494 26"
  }), props.children);
});
var Language_03 =
/*#__PURE__*/
React.forwardRef(function Language_03(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 20L36 23 33.5 23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33,20v3.25c0,1.795,1.343,2.75,3,2.75s3-0.955,3-2.75V20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.5,12.5 c0,0-2.533,0-3.033,0c-1,0-2-0.155-2-1.5c0-1,0.622-2,1.622-2s1.878,0.5,1.878,3c0,2.698-1.467,3-2.967,3l0,0c-1.5,0-3-0.5-3-2.5 V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,39 c0-4.625-3.145-8.505-7.409-9.648c1.731-0.926,2.91-2.751,2.91-4.852C29.501,21.463,27.038,19,24,19s-5.501,2.463-5.501,5.501 c0,2.101,1.179,3.925,2.91,4.852C17.156,30.425,14,34.375,14,39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 21L15 21"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 19.5L12 21M9 26c4.709 0 4.498-4 4.498-5M10.534 23c.348 1.219 1.826 3 4.466 3M15 9L22.5 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 9L20 15"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,11.5h-2 c-1.139,0-2,0.5-2,1.5c0,0.94,0.731,1.683,1.5,2"
  }), props.children);
});
var Language_04 =
/*#__PURE__*/
React.forwardRef(function Language_04(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.5,12.5 c0,0-2.533,0-3.033,0c-1,0-2-0.155-2-1.5c0-1,0.622-2,1.622-2s1.878,0.5,1.878,3c0,2.698-1.467,3-2.967,3l0,0c-1.5,0-3-0.5-3-2.5 V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,39c0-4.625-3.145-8.505-7.409-9.648c1.731-0.926,2.91-2.751,2.91-4.852C29.501,21.463,27.038,19,24,19 s-5.501,2.463-5.501,5.501c0,2.101,1.179,3.925,2.91,4.852C17.156,30.426,14,34.375,14,39 M15,10h6 M18,8.5V10 M15,15 c4.709,0,4.498-4,4.498-5 M16.534,12c0.348,1.219,1.826,3,4.466,3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27L12.5 19.5 16 27M10.5 24L14.5 24"
  }), React.createElement("path", {
    d: "M8.5 26H17V28H8.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.86,26v-6H34.5v2c0,2-0.5,4-1.5,4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 27.5L33 26 38.5 26 38.5 27.5"
  }), props.children);
});
var LanguageTranslationAlphabetAExpanded =
/*#__PURE__*/
React.forwardRef(function LanguageTranslationAlphabetAExpanded(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M34.986,18l0.774-0.001l-2.437-6.133h-0.669L30.216,18h0.775l0.653-1.641h2.691L34.986,18z M31.929,15.639l1.06-2.666 l1.059,2.666H31.929z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27H21V39H9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,15c0,3.314-2.686,6-6,6s-6-2.686-6-6 s2.686-6,6-6S39,11.686,39,15z M24.5,15L17,15c-1.105,0-2,0.897-2,2.002V25 M21.67,12.173l2.828,2.828L21.67,17.83 M33,23.002v8 C33,32.107,32.105,33,31,33h-7.502 M26.327,35.83l-2.828-2.828l2.828-2.828 M12,31h6 M15,29.5V31 M16.349,31.002 c0,0,0.358,5-4.351,5 M17.998,36.002c-2.639,0-4.262-2.014-4.582-3.501"
  }), props.children);
});
var LanguageTranslation =
/*#__PURE__*/
React.forwardRef(function LanguageTranslation(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27H21V39H9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.613,18l2.385-6 l2.385,6 M31.352,16h3.271"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,15c0,3.314-2.686,6-6,6s-6-2.686-6-6 s2.686-6,6-6S39,11.686,39,15z M24.5,15L17,15c-1.105,0-2,0.897-2,2.002V25 M21.67,12.173l2.828,2.828L21.67,17.83 M33,23.002v8 C33,32.107,32.105,33,31,33h-7.502 M26.327,35.83l-2.828-2.828l2.828-2.828 M12,31h6 M15,29.5V31 M16.349,31.002 c0,0,0.358,5-4.351,5 M17.998,36.002c-2.639,0-4.262-2.014-4.582-3.501"
  }), props.children);
});
var Language =
/*#__PURE__*/
React.forwardRef(function Language(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.536,23.028c-0.341-0.342-0.519-0.788-0.519-1.235c0-0.452,0.168-0.922,0.519-1.273c0.34-0.34,0.782-0.513,1.227-0.519 c0.463-0.007,0.928,0.166,1.281,0.519l0.465,0.464l0.465-0.464c0.345-0.345,0.797-0.518,1.249-0.52 c0.456-0.001,0.912,0.172,1.259,0.52c0.35,0.35,0.519,0.817,0.519,1.269c0,0.449-0.177,0.897-0.519,1.239L35.508,26L32.536,23.028z M13.994,21.5V20H9l2.335,2.998L9,26h4.994v-1.5 M27.504,12h5 M33.004,9.992c-0.5-0.5-1.271-0.993-2-0.993 c-1.198,0-2.168,0.744-2.168,2.069c0,1.004,0.883,0.933,0.883,1.931c0,0.899-0.694,1.418-1.715,2h5 M34,39 c0-4.625-3.145-8.505-7.409-9.648c1.731-0.926,2.91-2.751,2.91-4.852C29.501,21.463,27.038,19,24,19s-5.501,2.463-5.501,5.501 c0,2.101,1.179,3.925,2.91,4.852C17.156,30.425,14,34.375,14,39 M15.004,10h6 M18.004,8.5V10 M15.004,15c4.709,0,4.498-4,4.498-5 M16.539,12c0.348,1.219,1.826,3,4.466,3"
  }), props.children);
});
var Launch =
/*#__PURE__*/
React.forwardRef(function Launch(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,9h9v9 M24,11H11 c-1.105,0-2,0.895-2,2v24c0,1.105,0.895,2,2,2h24c1.105,0,2-0.895,2-2V24 M39,9L22,26"
  }), props.children);
});
var Lightning =
/*#__PURE__*/
React.forwardRef(function Lightning(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,37 l4-7h-4l4-7 M27,27h6.426C36.504,26.967,39,24.652,39,21.574S36.504,16,33.426,16c-0.627,0-1.458,0.108-2.02,0.299 C30.24,13.304,27.335,11,23.927,11c-4.177,0-7.606,3.537-7.992,7.613C15.254,18.225,14.469,18,13.631,18 C11.058,18,9,20.086,9,22.658c0,2.573,2.058,4.309,4.631,4.342h3.357"
  }), props.children);
});
var ListBullet =
/*#__PURE__*/
React.forwardRef(function ListBullet(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,12c0,1.657-1.343,3-3,3s-3-1.343-3-3s1.343-3,3-3S15,10.343,15,12z M12,33c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S13.657,33,12,33z M12,21c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,21,12,21z M19,12h20 M19,24h20 M19,36h20"
  }), props.children);
});
var ListCheckbox =
/*#__PURE__*/
React.forwardRef(function ListCheckbox(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,12h20 M19,24h20 M19,36h20 M15,9H9v6h6V9z M15,21H9v6h6V21z M15,33H9v6h6V33z"
  }), props.children);
});
var Location =
/*#__PURE__*/
React.forwardRef(function Location(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,20c0,8-11,19-11,19S13,29,13,20c0-6,4.925-11,11-11S35,14,35,20z M24,16c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4 S26.209,16,24,16z"
  }), props.children);
});
var LockAlt =
/*#__PURE__*/
React.forwardRef(function LockAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "29.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,21v-7c0-2.761-2.239-5-5-5s-5,2.239-5,5v7 M24,29.5V33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".711",
    d: "M14 21H34V39H14z"
  }), props.children);
});
var Lock =
/*#__PURE__*/
React.forwardRef(function Lock(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "28.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,29c0,5.523-4.477,10-10,10s-10-4.477-10-10s4.477-10,10-10S34,23.477,34,29z M29,20.338V14c0-2.761-2.239-5-5-5s-5,2.239-5,5 v6.338 M24,28.5V32"
  }), props.children);
});
var LockedNetworkAlt =
/*#__PURE__*/
React.forwardRef(function LockedNetworkAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,35v-4H11v4 M37,35 c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S38.105,35,37,35z M24,27v8"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19L24 21"
  }), React.createElement("circle", {
    cx: "24",
    cy: "19",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5 15v-3.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5V15M19 15H29V25H19z"
  }), props.children);
});
var LockedNetwork =
/*#__PURE__*/
React.forwardRef(function LockedNetwork(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,20 c0,2.761-2.239,5-5,5s-5-2.239-5-5s2.239-5,5-5S29,17.239,29,20z M27,12c0-1.657-1.343-3-3-3s-3,1.343-3,3 M21,12v4 M27,12v4 M37,35v-4H11v4 M37,35c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S38.105,35,37,35z M24,27v8"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19L24 21"
  }), React.createElement("circle", {
    cx: "24",
    cy: "19",
    r: "1"
  }), props.children);
});
var LondonBigBen =
/*#__PURE__*/
React.forwardRef(function LondonBigBen(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.5,23v-3l2-2v-3l1.5-4l1.5,4v3l2,2v3 M24,9v2 M22.5,15h3 M22.5,18h3 M20.5,20h7 M28,23h-8v8h8V23z M27.5,31v8 M20.5,31v8 M24,32 v3 M22,32v3 M26,32v3 M24,36v3 M22,36v3 M26,36v3 M20.5,35h7 M24,23v-2 M24,18v-2 M26,23v-2 M22,23v-2 M16.315,12.453 c-0.19,0-0.371,0.033-0.541,0.091c-0.353-0.906-1.231-1.542-2.261-1.542c-1.263,0-2.299,0.958-2.416,2.19 c-0.206-0.117-0.443-0.185-0.696-0.185c-0.778,0-1.4,0.808-1.4,1.586C9,15.37,9.622,16,10.4,16h5.915 C17.246,16,18,15.246,18,14.315S17.246,12.453,16.315,12.453z M37.689,17.254c-0.148,0-0.289,0.025-0.421,0.07 c-0.274-0.704-0.957-1.199-1.759-1.199c-0.982,0-1.788,0.745-1.879,1.703c-0.16-0.091-0.344-0.144-0.542-0.144 c-0.605,0-1.089,0.615-1.089,1.22C32,19.51,32.484,20,33.089,20h4.601C38.413,20,39,19.413,39,18.689 C39,17.966,38.413,17.254,37.689,17.254z M24,24.25c-1.243,0-2.25,1.007-2.25,2.25s1.007,2.25,2.25,2.25s2.25-1.007,2.25-2.25 S25.243,24.25,24,24.25z M24.002,25L24,26.5h1.5"
  }), props.children);
});
var LondonExpandedBase =
/*#__PURE__*/
React.forwardRef(function LondonExpandedBase(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "11",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "13",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "9",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "39",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.118",
    cy: "9.511",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "39",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "27.882",
    cy: "9.511",
    r: ".5"
  }), React.createElement("path", {
    d: "M28.348,38.907l-4-15c-0.084-0.314-0.611-0.314-0.695,0l-4,15c-0.008,0.031-0.006,0.062-0.006,0.093h0.726L24,25.397 L27.628,39h0.726C28.353,38.969,28.356,38.938,28.348,38.907z"
  }), props.children);
});
var London =
/*#__PURE__*/
React.forwardRef(function London(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "11",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "13",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "9",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "39",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.118",
    cy: "9.511",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "39",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "27.882",
    cy: "9.511",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 39L24 24 28 39"
  }), props.children);
});
var Lungs =
/*#__PURE__*/
React.forwardRef(function Lungs(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22,9c0,0,0,4.08,0,5.504 s-0.612,2.866-2,2.866 M26,9c0,0,0,4.08,0,5.504s0.615,2.866,2.003,2.866"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.999,19.252c-1.461,0-2.938,0.511-3.997,1.023 M28.003,20.274c-1.059-0.511-2.542-1.023-4.003-1.023 M18.374,13.627 C14.845,13.627,9,20.823,9,27.653c0,0,0,6.635,0,8.535C9,38.306,9.84,39,11.812,39h7.499C21.357,39,22,38.306,22,36.188 c0,0,0-6.6,0-8.499c0-1.899-1.999-4.054-1.999-5.624v-6.562C20.001,14.151,19.799,13.627,18.374,13.627z M27.999,15.502v6.562 c0,1.571-1.999,3.725-1.999,5.624c0,1.899,0,8.499,0,8.499C26,38.306,26.643,39,28.688,39h7.499C38.16,39,39,38.306,39,36.188 c0-1.899,0-8.535,0-8.535c0-6.83-5.845-14.026-9.374-14.026C28.201,13.627,27.999,14.151,27.999,15.502z M11.003,30.501 c1.544,0,3.623-1.905,3.623-4.497v-1.769c0-3.47,1.243-7.037,3.75-8.732 M14.625,24.234c0,2.221,0,5.291,0,5.291 c0,4.638,0.409,7.474,3.751,7.474 M20.003,30.501v-1.875c0-3.427-5.375-1.105-5.375-4.762 M29.624,15.502 c2.506,1.695,3.75,5.262,3.75,8.732v1.769c0,2.592,2.084,4.497,3.628,4.497 M29.624,36.999c3.341,0,3.751-2.836,3.751-7.474 c0,0,0-3.07,0-5.291 M33.373,23.864c0,3.657-5.37,1.336-5.37,4.762v1.875"
  }), props.children);
});
var MachineLearning_01 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.001,23.31 c-0.038,2.182,1.487,4.318,3.695,4.925c-0.549,0.53-1.106,1.494-1.125,2.587c-0.042,2.386,1.866,3.907,4.252,3.949l0.724,0.013 c0.423,1.266,1.607,2.188,3.017,2.213c1.789,0.031,3.265-1.394,3.296-3.183l0.358-20.517c0.031-1.789-1.394-3.265-3.183-3.296 c-1.41-0.025-2.626,0.856-3.093,2.106l-0.724-0.012c-2.386-0.042-4.345,1.412-4.387,3.798c-0.019,1.092,0.504,2.075,1.034,2.624 C10.638,19.046,9.039,21.128,9.001,23.31z"
  }), React.createElement("circle", {
    cx: "19.959",
    cy: "14.32",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "16.644",
    cy: "18.583",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19.752",
    cy: "26.198",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "13.311",
    cy: "23.925",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "16.418",
    cy: "31.541",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.94 15.4L19.827 21.879M19.733 27.278L19.563 36.996"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.067,21.935 l-5.399-0.094c-0.596-0.01-1.088,0.465-1.099,1.061l-0.132,7.559"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.565 18.564L12.514 18.511M16.55 23.982L14.39 23.944"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39.236,23.838 c0.038-2.182-1.487-4.318-3.695-4.925c0.549-0.53,1.106-1.494,1.125-2.587c0.042-2.386-1.866-3.907-4.252-3.949l-0.724-0.013 c-0.423-1.266-1.607-2.188-3.017-2.213c-1.789-0.031-3.265,1.394-3.296,3.183l-0.358,20.517c-0.031,1.789,1.394,3.265,3.183,3.296 c1.41,0.025,2.626-0.856,3.093-2.106l0.724,0.012c2.386,0.042,4.345-1.412,4.387-3.798c0.019-1.092-0.504-2.075-1.034-2.624 C37.599,28.101,39.198,26.02,39.236,23.838z"
  }), React.createElement("circle", {
    cx: "28.278",
    cy: "32.828",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.592",
    cy: "28.565",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "28.485",
    cy: "20.95",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "34.926",
    cy: "23.222",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.819",
    cy: "15.607",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.296 31.748L28.409 25.269M28.504 19.87L28.673 10.151"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.17,25.212 l5.399,0.094c0.596,0.01,1.088-0.465,1.099-1.061l0.132-7.559"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.672 28.584L35.723 28.637M31.687 23.166L33.846 23.204"
  }), props.children);
});
var MachineLearning_02 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_02(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "19.192",
    cy: "16.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19.692",
    cy: "26.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "26.192",
    cy: "13.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.192",
    cy: "31.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.692",
    cy: "21.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.192,39 l0.002-10.756c1.862-2.044,2.998-4.761,2.998-7.744c0-6.351-5.149-11.5-11.5-11.5s-11.5,5.149-11.5,11.5l-3.276,6.053 C10.583,27.218,11.066,28,11.81,28h2.382v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.192 31c0 3.314 3.686 6 7 6l0 0v2M24.192 39L24.192 30.183 20.851 27.449M24.192 27L24.192 21 20.295 17.512M26.192 39L26.192 15M28.192 31L28.192 24 30.39 22.241M28.192 39L28.192 34 30.017 32.431"
  }), props.children);
});
var MachineLearning_03 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_03(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "25",
    cy: "31",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 30L31 36M25 32L25 36M32.123 14.603L17.88 24.395M12.194 17.881L19.698 17.13M20.834 11.648L29 18 36.196 24.297M36 19.444L28.829 22.631M30 28.714L17.875 25.25M36.128 25.581L31.866 28.423M37 20.104L37 23.927M33.681 14.851L36.299 18.124M27.942 11.471L32.057 13.529M21.09 11L25.921 11M15.941 13.03L19.057 11.471M11.702 17.211L14.395 14.18M11 23.082L11 18.905M15.925 24.821L12.05 24.175"
  }), React.createElement("circle", {
    cx: "27",
    cy: "11",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "33",
    cy: "14",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "37",
    cy: "19",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "37",
    cy: "25",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31",
    cy: "29",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "28",
    cy: "23",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "21",
    cy: "17",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19",
    cy: "29",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "25",
    cy: "37",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31",
    cy: "37",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "17",
    cy: "25",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "15",
    cy: "13.5",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "20",
    cy: "11",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.111 23.247L36 24.778M25.375 30L27.667 23.887M21.286 18L24.714 30M16.829 24.015L15.193 14.607M18.517 28.035L17.472 25.945M23.941 30.647L19.915 29.305"
  }), props.children);
});
var MachineLearning_04 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_04(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,23v11c0,2.209-1.791,4-4,4H17c-2.209,0-4-1.791-4-4V23c0-2.209,1.791-4,4-4h14C33.209,19,35,20.791,35,23z M30,26 c0-1.105-0.895-2-2-2s-2,0.895-2,2s0.895,2,2,2S30,27.105,30,26z M26,11c0-1.105-0.895-2-2-2s-2,0.895-2,2s0.895,2,2,2 S26,12.105,26,11z M27,19c0-1.657-1.343-3-3-3s-3,1.343-3,3 M22,26c0-1.105-0.895-2-2-2s-2,0.895-2,2s0.895,2,2,2S22,27.105,22,26z M28,35c1.105,0,2-0.895,2-2s-0.895-2-2-2h-8c-1.105,0-2,0.895-2,2s0.895,2,2,2H28z M24,13v3 M39,23h-2v8.5h2V23z M11,23H9v8.5h2 V23z"
  }), props.children);
});
var MachineLearning_05 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_05(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 15H33V33H15zM20 15L20 12"
  }), React.createElement("circle", {
    cx: "20",
    cy: "10.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 15L28 12"
  }), React.createElement("circle", {
    cx: "28",
    cy: "10.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "7",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 33L28 36"
  }), React.createElement("circle", {
    cx: "28",
    cy: "37.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 33L20 36"
  }), React.createElement("circle", {
    cx: "20",
    cy: "37.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 20L36 20"
  }), React.createElement("circle", {
    cx: "37.5",
    cy: "20",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 28L36 28"
  }), React.createElement("circle", {
    cx: "37.5",
    cy: "28",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 28L12 28"
  }), React.createElement("circle", {
    cx: "10.5",
    cy: "28",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 20L12 20"
  }), React.createElement("circle", {
    cx: "10.5",
    cy: "20",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,29.5v-1 c0-1.798-1.194-3.301-2.827-3.805c0.786-0.421,1.327-1.241,1.327-2.195c0-1.381-1.119-2.5-2.5-2.5s-2.5,1.119-2.5,2.5 c0,0.954,0.541,1.774,1.327,2.195C21.194,25.199,20,26.702,20,28.5V30"
  }), props.children);
});
var MachineLearning_06 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_06(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17,34 c-1.381,0-2.5-1.119-2.5-2.5 M22,14c0-1.105-0.895-2-2-2s-2,0.895-2,2 M20,20.5c1.105,0,2-0.895,2-2s-0.895-2-2-2 M17.414,21.584 C17.002,21.172,16.5,21,16,21c-1.23,0-2,0.842-2,2c0,0.511,0.196,1.022,0.586,1.412 M20,28c-1.105,0-2,0.895-2,2s0.895,2,2,2 M20,36c1.105,0,2-0.895,2-2 M24,19h9c1.105,0,2-0.895,2-2v-2 M35,33v-2c0-1.105-0.895-2-2-2h-9 M24,22h12 M36,14 c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1S36,14.552,36,14z M36,34c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1 S36,34.552,36,34z M38,22c0-0.552-0.448-1-1-1s-1,0.448-1,1s0.448,1,1,1S38,22.552,38,22z M24,26h12 M38,26c0-0.552-0.448-1-1-1 s-1,0.448-1,1s0.448,1,1,1S38,26.552,38,26z M24,14c0-2.209-1.791-4-4-4c-1.479,0-2.756,0.812-3.448,2.005 C16.534,12.005,16.518,12,16.5,12c-2.485,0-4.5,2.015-4.5,4.5c0,0.999,0.336,1.913,0.887,2.66C11.168,20.09,10,21.908,10,24 s1.168,3.91,2.887,4.84C12.336,29.587,12,30.501,12,31.5c0,2.485,2.015,4.5,4.5,4.5c0.018,0,0.034-0.005,0.052-0.005 C17.244,37.188,18.521,38,20,38c2.209,0,4-1.791,4-4V14z M16.5,12.062C16.181,12.636,16,13.297,16,14c0,0.729,0.195,1.412,0.535,2 M16.5,27c-1.414,0-2.675,0.652-3.5,1.672"
  }), props.children);
});
var MadridCathedral =
/*#__PURE__*/
React.forwardRef(function MadridCathedral(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39L39 30 9 30 9 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 22L32 24M34 22L34 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 20L36 30M30 22L37 22M37 24L30 24M36 26L32 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 20L30 30M26 20L26 30M28 12L28 14M28 26L28 30M23 26L23 30M26 24L30 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 14L26 20 30 20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 20L20 30M16 20L16 30M18 22L18 24M28 22L28 24M18 12L18 14M18 26L18 30M16 24L20 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 14L16 20 20 20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,24h-2v-1 c0-0.552-0.448-1-1-1s-1,0.448-1,1v1h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 37L12 39M14 37L14 39M18 37L18 39M20 37L20 39M22 37L22 39M24 37L24 39M26 37L26 39M28 37L28 39M30 37L30 39M32 37L32 39M34 37L34 39M36 37L36 39M16 37L16 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 33c0-.552-.448-1-1-1s-1 .448-1 1v2h2V33zM17 33c0-.552-.448-1-1-1-.552 0-1 .448-1 1v2h2V33zM21 33c0-.552-.448-1-1-1s-1 .448-1 1v2h2V33zM25 33c0-.552-.448-1-1-1s-1 .448-1 1v2h2V33zM29 33c0-.552-.448-1-1-1s-1 .448-1 1v2h2V33zM33 33c0-.552-.448-1-1-1s-1 .448-1 1v2h2V33zM37 33c0-.552-.448-1-1-1s-1 .448-1 1v2h2V33z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 27c0-1.105.895-2 2-2s2 .895 2 2M11 24c0-.552.448-1 1-1s1 .448 1 1M10 27L14 27M11 24L11 25M13 24L13 25M12 21L12 23M10 27L10 30M14 27L14 30M31 12c0-.552.448-1 1-1s1 .448 1 1M31 12L31 16M33 12L33 16M32 9L32 11M31 13L33 13"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,17.354 C29.733,16.524,30.805,16,32,16c2.209,0,4,1.791,4,4"
  }), React.createElement("circle", {
    cx: "34.5",
    cy: "28.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "32.5",
    cy: "28.5",
    r: ".5"
  }), props.children);
});
var MadridSkyscrapers =
/*#__PURE__*/
React.forwardRef(function MadridSkyscrapers(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 38L12 12M25.979 38L26 30 25.938 17.956 30 15 31 17 31 37.979M23 15L23 37.979M18 38L18 15M39 16c0 9-4.995 11-4.995 21.634M26 36.979L30 15M23 18L20 18 20 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32L10 32M9 17L10 17M14 24L15 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 21.956L29 21.956M34 19L36 19M34 21L36 21M37 33L39 33M29 33L31 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 38L39 38 39 37.979 39 16 33.995 16 34 37.979 34 37.979"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 26.999L23.063 27M21 30L23.063 30.001M10 37.979L10 34 9 34 9 29 10 29 10 26.979 9 26.979 9 21.979 10 21.979 10 19.979 9 19.979 9 15 10 15 10 12 14 12 14 15 15 15 15 19.979 14 19.979 14 21.979 15 21.979 15 26.979 14 26.979 14 29 15 29 15 34 14 34 14 37.979M23 15c0-.552-1.119-1-2.5-1S18 14.448 18 15"
  }), props.children);
});
var MadridStatue =
/*#__PURE__*/
React.forwardRef(function MadridStatue(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 23v-1l2 1h1l1 1h.884v1.022l-1 .978L33 28l1.587 1.587c.269.269.456.61.539.982l.53 2.397c.143.646-.043 1.321-.497 1.803L34 36l1 3h-6v-3l1-3-1-2.5-1.884-1L24 27.962V25l0 0 2.116 1.5 2.884 1v-2l-1.116-1L28 23zM9 38.991L39 38.991"
  }), React.createElement("ellipse", {
    cx: "18.017",
    cy: "16.461",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "20.5",
    cy: "18.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "16.5",
    cy: "18.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "22.5",
    cy: "20.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "26.997",
    cy: "16.461",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "24.5",
    cy: "17.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "20.5",
    cy: "12.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "23.5",
    cy: "12.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "28.5",
    cy: "18.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "17.5",
    cy: "13.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "24.5",
    cy: "15.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "21.5",
    cy: "15.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "26.5",
    cy: "13.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 39c2.108 0 4-1.892 4-4V23M28 39c-2.108 0-4-1.892-4-4V23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.033,15.694 C29.624,15.146,30,14.37,30,13.5c0-1.657-1.343-3-3-3c-0.516,0-0.995,0.142-1.419,0.372C24.994,9.764,23.842,9,22.5,9 s-2.494,0.764-3.081,1.872C18.995,10.642,18.516,10.5,18,10.5c-1.657,0-3,1.343-3,3c0,0.87,0.376,1.646,0.967,2.194 C14.821,16.116,14,17.208,14,18.5c0,1.657,1.343,3,3,3c0.861,0,1.632-0.367,2.179-0.948C19.627,21.967,20.936,23,22.5,23 s2.873-1.033,3.321-2.448C26.368,21.133,27.139,21.5,28,21.5c1.657,0,3-1.343,3-3C31,17.208,30.179,16.116,29.033,15.694z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 34L31 36 32 39"
  }), props.children);
});
var Magnify =
/*#__PURE__*/
React.forwardRef(function Magnify(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,20c0,6.075-4.925,11-11,11 s-11-4.925-11-11S19.925,9,26,9S37,13.925,37,20z M39,33l-5.215-5.215 M26,14c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S27.657,14,26,14z M29,22c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S30.657,22,29,22z M15.287,22.462 C15.772,22.801,16.363,23,17,23c1.657,0,3-1.343,3-3s-1.343-3-3-3c-0.642,0-1.237,0.202-1.725,0.545 M23.028,9.406 C23.226,10.871,24.481,12,26,12c1.519,0,2.774-1.129,2.973-2.593 M32.6,11.199C32.224,11.701,32,12.324,32,13c0,1.657,1.343,3,3,3 c0.414,0,0.809-0.084,1.168-0.236"
  }), React.createElement("path", {
    d: "M9.5,11c0,0.276-0.224,0.5-0.5,0.5S8.5,11.276,8.5,11s0.224-0.5,0.5-0.5S9.5,10.723,9.5,11z M15,12.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S15.276,12.5,15,12.5z M12,14.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S12.276,14.5,12,14.5z M13,16.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S13.276,16.5,13,16.5z M10,15.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 S10.276,15.5,10,15.5z M11,17.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S11.276,17.5,11,17.5z M9,19.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S9.276,19.5,9,19.5z M12,21.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S12.276,21.5,12,21.5z M10,22.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S10.276,22.5,10,22.5z M15,23.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 S15.276,23.5,15,23.5z M12,24.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S12.276,24.5,12,24.5z M17,28.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S17.276,28.5,17,28.5z M20,30.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S20.276,30.5,20,30.5z M14,29.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S14.276,29.5,14,29.5z M12,30.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 S12.276,30.5,12,30.5z M10,31.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S10.276,31.5,10,31.5z M13,33.5 c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5C13.5,33.723,13.276,33.5,13,33.5z M12,35.5 c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5C12.5,35.723,12.276,35.5,12,35.5z M16,32.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S16.276,32.5,16,32.5z M19,34.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S19.276,34.5,19,34.5z M29,32.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S29.276,32.5,29,32.5z M22,38.5c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 C22.5,38.723,22.276,38.5,22,38.5z M13,9c-0.276,0-0.5,0.224-0.5,0.5S12.724,10,13,10s0.5-0.224,0.5-0.5S13.276,9,13,9z M17,9.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S17.276,9.5,17,9.5z"
  }), props.children);
});
var Marketplace =
/*#__PURE__*/
React.forwardRef(function Marketplace(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,12 c0,1.657-1.343,3-3,3s-3-1.343-3-3s1.343-3,3-3S27,10.343,27,12z M13.393,13.393c-1.172,1.172-1.172,3.071,0,4.243 c1.172,1.172,3.071,1.172,4.243,0c1.172-1.172,1.172-3.071,0-4.243C16.464,12.222,14.565,12.222,13.393,13.393z M9,24 c0,1.657,1.343,3,3,3s3-1.343,3-3s-1.343-3-3-3S9,22.343,9,24z M13.393,34.607c1.172,1.172,3.071,1.172,4.243,0 c1.172-1.172,1.172-3.071,0-4.243c-1.172-1.172-3.071-1.172-4.243,0C12.222,31.536,12.222,33.435,13.393,34.607z M24,39 c1.657,0,3-1.343,3-3s-1.343-3-3-3s-3,1.343-3,3S22.343,39,24,39z M34.607,34.607c1.172-1.172,1.172-3.071,0-4.243 c-1.172-1.172-3.071-1.172-4.243,0c-1.172,1.172-1.172,3.071,0,4.243C31.536,35.778,33.435,35.778,34.607,34.607z M39,24 c0-1.657-1.343-3-3-3s-3,1.343-3,3s1.343,3,3,3S39,25.657,39,24z M34.607,13.393c-1.172-1.172-3.071-1.172-4.243,0 c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.172,3.071,1.172,4.243,0C35.778,16.464,35.778,14.565,34.607,13.393z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".752",
    d: "M24 18L24 30M18 24L30 24M19.757 19.757L28.243 28.243M19.757 28.243L28.243 19.757"
  }), props.children);
});
var Mas =
/*#__PURE__*/
React.forwardRef(function Mas(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(10.5 23.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M39,9H9v23h30 V9z"
  }), props.children);
});
var Maximize =
/*#__PURE__*/
React.forwardRef(function Maximize(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,9h9v9 M29,19L39,9 M18,9 H9v9 M9,9l10,10 M30,39h9v-9 M29,29l10,10 M9,30v9h9 M19,29L9,39"
  }), props.children);
});
var MedicalCharts =
/*#__PURE__*/
React.forwardRef(function MedicalCharts(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.5,19h4 M17.5,17v4 M18,11h-5v24h18V11h-5 M14,35v2h19V13h-2 M16,37v2h19V15h-2 M24,10V9h-4v1h-2v2h8v-2L24,10z M20.5,17h8 M20.5,21h8 M15.5,25h13 M15.5,29h13"
  }), props.children);
});
var MedicalStaff =
/*#__PURE__*/
React.forwardRef(function MedicalStaff(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,40v-6.809c0-3.781,2.656-6.927,6.149-7.782c-1.596-0.71-2.709-2.306-2.709-4.166c0-2.519,2.042-4.56,4.56-4.56 s4.56,2.042,4.56,4.56c0,1.859-1.114,3.455-2.709,4.166C29.376,26.244,32,29.41,32,33.191V40 M16.051,11.437 c-1.543,0.731-2.611,2.303-2.611,4.124c0,1.859,1.114,3.455,2.709,4.166C12.624,20.562,10,23.728,10,27.509v6.49 M22.329,16.999 c0.15-0.452,0.232-0.935,0.232-1.438c0-1.819-1.066-3.39-2.607-4.122 M27.068,12.067c-0.996,0.837-1.629,2.091-1.629,3.494 c0,0.503,0.082,0.987,0.232,1.44 M38,34v-6.492c0-3.781-2.624-6.947-6.149-7.782c1.595-0.71,2.709-2.306,2.709-4.166 c0-1.402-0.633-2.656-1.628-3.493 M24.002,35.999v-3 M24.002,36c-0.828,0-1.499,0.671-1.499,1.499s0.671,1.499,1.499,1.499 c0.828,0,1.499-0.671,1.499-1.499S24.83,36,24.002,36z M18.003,9c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2 S19.107,9,18.003,9z M20,26.264V29c0,2.2,1.8,4,4,4h0c2.2,0,4-1.8,4-4v-2.736 M28,13c0,0,0.579-0.727,2-0.727 c1.454,0,2,0.728,2,0.728L34,11c0,0-0.988-2-4-2s-4,2-4,2L28,13z"
  }), props.children);
});
var Medical =
/*#__PURE__*/
React.forwardRef(function Medical(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,31v8 M24,12.999v13.002 M25.617,20.001c0.937-0.658,1.478-1.446,1.478-2.637c0-1.035-0.617-1.993-1.478-2.361 M22.382,29.827 c-0.937,0.658-1.478,1.446-1.478,2.637c0,1.035,0.617,1.993,1.478,2.361 M25.617,27.485c0.976-0.74,1.478-1.33,1.478-2.622 c0-3.246-6.179-4.1-6.179-7.618c0-0.999,0.608-1.865,1.442-2.242 M25.617,34.825c0.976-0.74,1.478-1.33,1.478-2.622 c0-3.246-6.179-4.1-6.179-7.618c0-0.999,0.608-1.865,1.442-2.242 M36,17h-6.848 M33.979,19.001h-5.164 M38,15h-6.286 c-1.241,0-2.619,0.453-2.619,2.576c0,1.275-0.855,2.84-2.095,3.424 M12,17h6.869 M14,19.001h5.187 M21,21 c-1.239-0.584-2.093-2.149-2.093-3.424c0-2.123-1.378-2.576-2.619-2.576H10 M24,9c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2 S25.105,9,24,9z"
  }), props.children);
});
var Melbourne =
/*#__PURE__*/
React.forwardRef(function Melbourne(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.5 10L29.5 10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.5 24L30.5 24M21.5 10L24.5 14 27.5 10M22.5 16L26.5 16M18.5 20c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2M22.5 18L22.5 24M18.5 20L18.5 24M26.5 18L26.5 24M30.5 20L30.5 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,20c0-3.314,2.686-6,6-6h5c3.314,0,6,2.686,6,6v8c0,1.105-0.895,2-2,2H18c-1.105,0-2-0.895-2-2V20z"
  }), React.createElement("circle", {
    cx: "24.5",
    cy: "27",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32L16 38M29 32L33 38"
  }), React.createElement("circle", {
    cx: "20.5",
    cy: "26",
    r: ".5"
  }), React.createElement("circle", {
    cx: "28.5",
    cy: "26",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.5",
    cy: "28",
    r: ".5"
  }), React.createElement("circle", {
    cx: "28.5",
    cy: "28",
    r: ".5"
  }), props.children);
});
var Meter =
/*#__PURE__*/
React.forwardRef(function Meter(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24c0,8.284-6.716,15-15,15 S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M24,11v3 M17.5,12.742L18.804,15 M12.742,17.5l1.758,1.015 M11,24h1.5 M12.742,30.5 l0.866-0.5 M35.258,30.5l-3.899-2.251 M37,24h-4 M35.258,17.5L24,24 M30.5,12.742L28.619,16"
  }), props.children);
});
var MexicoCityAngelOfIndependence =
/*#__PURE__*/
React.forwardRef(function MexicoCityAngelOfIndependence(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 18L23 16 25 16 25 18M20 39L20 33 28 33 28 39M22 19L22 18 26 18 26 19M26 25L22 25M26 29L22 29M22 33L22 20M26 33L26 20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 35H26V37H22z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 17c-.552 0-1 .448-1 1s.448 1 1 1h7c.552 0 1-.448 1-1s-.448-1-1-1h-1c0-.552-.448-1-1-1s-1 .448-1 1c0-1.105-.895-2-2-2S10 15.896 10 17zM30 29c-.552 0-1 .448-1 1s.448 1 1 1h7c.552 0 1-.448 1-1s-.448-1-1-1h-1c0-.552-.448-1-1-1s-1 .448-1 1c0-1.105-.895-2-2-2C30.895 27 30 27.895 30 29zM25 14.5L24 12 23 14.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 14.5L24 16M21 19L21 20 27 20 27 19M20.5 10.563c.219 2.053 2.67 2.27 3.5 1.438l-3-3h-3C18 9 18.219 11 20.5 10.563z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 9h3l3 3c-.83.832-3.281.616-3.5-1.438C18.219 11 18 9 18 9zM30 9h-3l-3 3c.83.832 3.281.616 3.5-1.438C29.781 11 30 9 30 9zM26 22L22 22"
  }), props.children);
});
var MexicoCityMuseoSoumaya =
/*#__PURE__*/
React.forwardRef(function MexicoCityMuseoSoumaya(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,14v1 M25,14v1 M26,16v1 M24,16v1 M28,16v1 M30,16v1 M25,18v1 M27,18v1 M29,18v1 M28,20v1 M27,22v1 M25,22v1 M29,22v1 M26,24v1 M26,20v1 M11.625,34H21 M10.134,36H26 M17,32l2-3h2v3c0,0,18,4,18,4v-4l0,0c-5.144-0.806-8.676-5.629-7.87-10.772 C31.539,18.614,33.001,16.42,35,15l-13.725-3.851c-0.828-0.232-1.709-0.192-2.512,0.115C18.763,11.265,9,15,9,15 c5.144,0.806,8.661,5.629,7.855,10.772c-0.249,1.592-0.89,3.009-1.792,4.228C12.842,33,11,34,9,38h22 M39,32H13.418"
  }), props.children);
});
var Microorganisms =
/*#__PURE__*/
React.forwardRef(function Microorganisms(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.734,11.999l-3,5.196c-0.55,0.953-1.779,1.282-2.732,0.732l0,0c-0.953-0.55-1.282-1.779-0.732-2.732l3-5.196 c0.55-0.953,1.779-1.282,2.732-0.732l0,0C27.955,9.817,28.284,11.046,27.734,11.999z M29.688,36.379l5.796,1.553 c1.063,0.285,2.165-0.352,2.449-1.414v0c0.285-1.063-0.352-2.165-1.414-2.449l-5.796-1.553c-1.063-0.285-2.165,0.352-2.449,1.414 l0,0C27.989,34.992,28.625,36.095,29.688,36.379z M14.998,25.073L14.998,25.073c-0.953-0.55-2.182-0.221-2.732,0.732l-3,5.196 c-0.55,0.953-0.221,2.182,0.732,2.732h0c0.953,0.55,2.182,0.221,2.732-0.732l3-5.196C16.281,26.853,15.951,25.623,14.998,25.073z M36.999,28.927L36.999,28.927c0.953-0.55,1.282-1.779,0.732-2.732l-3-5.196c-0.55-0.953-1.779-1.282-2.732-0.732l0,0 c-0.953,0.55-1.282,1.779-0.732,2.732l3,5.196C34.817,29.147,36.047,29.477,36.999,28.927z M18.928,12.999L18.928,12.999 c-0.55-0.953-1.779-1.282-2.732-0.732l-5.196,3c-0.953,0.55-1.282,1.779-0.732,2.732l0,0c0.55,0.953,1.779,1.282,2.732,0.732 l5.196-3C19.148,15.181,19.478,13.951,18.928,12.999z M22.926,33.001L22.926,33.001c-0.55-0.953-1.779-1.282-2.732-0.732l-5.196,3 c-0.953,0.55-1.282,1.779-0.732,2.732l0,0c0.55,0.953,1.779,1.282,2.732,0.732l5.196-3C23.147,35.183,23.476,33.954,22.926,33.001z M30.073,11.999L30.073,11.999c-0.55,0.953-0.221,2.182,0.732,2.732l5.196,3c0.953,0.55,2.182,0.221,2.732-0.732v0 c0.55-0.953,0.221-2.182-0.732-2.732l-5.196-3C31.853,10.717,30.623,11.046,30.073,11.999z M19.074,23.002L19.074,23.002 c-0.55,0.953-0.221,2.182,0.732,2.732l5.196,3c0.953,0.55,2.182,0.221,2.732-0.732l0,0c0.55-0.953,0.221-2.182-0.732-2.732 l-5.196-3C20.854,21.72,19.624,22.049,19.074,23.002z"
  }), props.children);
});
var Microscope =
/*#__PURE__*/
React.forwardRef(function Microscope(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.5,33.5H35V39H13l3.667-3.666H29.5V33.5z M25.833,17.002c-1.519,0-2.75,1.231-2.75,2.75s1.231,2.75,2.75,2.75 c1.519,0,2.75-1.231,2.75-2.75S27.352,17.002,25.833,17.002z M14.41,28.048l4.763,2.75l0.917-1.588l-4.763-2.75L14.41,28.048z M26.993,17.253l3.179-5.506l-4.763-2.75l-9.166,15.875l4.763,2.75l3.249-5.627 M17.831,25.789l-0.917,1.588l1.588,0.917 l0.917-1.588L17.831,25.789z M31.939,33.501c0.78-1.348,1.226-2.913,1.226-4.583c0-3.486-1.946-6.518-4.812-8.068"
  }), props.children);
});
var MilanDuomoDiMilano =
/*#__PURE__*/
React.forwardRef(function MilanDuomoDiMilano(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 15L24 12M24 20L24 18M22 20L22 19M26 20L26 19M22 14L22 17M26 14L26 17M20 20H28V22H20zM16 18H20V31H16zM10 25H12V39H10zM16 18L17 14 18 18 19 14 20 18M28 18L29 14 30 18 31 14 32 18M28 18H32V31H28z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19L24 15 28 19M12 27L16 23M36 27L32 23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 32L22 26 24 24 26 26 26 32"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 20L18 30.5M16 31H20V39H16zM18 33L18 39M28 31H32V39H28zM30 33L30 39M30 20L30 30.5M17 14L17 9M10 25L11 21 12 25M11 21L11 16M36 25H38V39H36zM36 25L37 21 38 25M37 21L37 16M19 14L19 9M29 14L29 9M31 14L31 9M22 31L26 31M20 35L28 35M12 31L19 31M32 31L36 31M20 22H28V39H20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 39L26 35 24 33 22 35 22 39M14 27L14 31M34 27L34 31M14 33L14 37M34 33L34 37M12 37L16 37M32 37L36 37"
  }), props.children);
});
var MilanSkyscrapers =
/*#__PURE__*/
React.forwardRef(function MilanSkyscrapers(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 25L13 25M11 30L9 30M11 33L9.165 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 38L9 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 38V16h-6c0 11-.181 15.363-1.67 22M39 21L37 21M39 19L37 19M34 33L32 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.001 16c0 8-.001 13 3.999 21.979M15.8 38c-.525-2.585-.8-5.26-.8-8 0-3.664.493-7.213 1.415-10.585l-3.938-3.938C10.254 19.836 9 24.772 9 30c0 2.761.35 5.44 1.007 7.995"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.392 18L15.733 22.341"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 38L29 12 19 12 19 38M20 15L28 15M20 18L28 18M20 21L28 21M20 24L28 24M20 27L28 27M20 30L28 30M20 33L28 33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 12L24 9"
  }), props.children);
});
var Minimize =
/*#__PURE__*/
React.forwardRef(function Minimize(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38,19h-9v-9 M29,19L39,9 M10,19h9v-9 M9,9l10,10 M38,29h-9v9 M39,39L29,29 M19,38v-9h-9 M9,39l10-10"
  }), props.children);
});
var MobileAdd =
/*#__PURE__*/
React.forwardRef(function MobileAdd(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "28",
    cy: "35.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,9v30H19V28 c4.42,0,8-3.58,8-8c0-4.42-3.58-8-8-8V9H37z M19,32h18 M19,16v8 M23,20l-8,0 M19,12c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8 S23.418,12,19,12z"
  }), props.children);
});
var MobileChat =
/*#__PURE__*/
React.forwardRef(function MobileChat(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "19",
    cy: "35.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,24v15H10V9h18v3 M10,32h18 M36,12H25c-1.104,0-2,0.896-2,2v10v4l4-4h9c1.104,0,2-0.896,2-2v-8C38,12.896,37.105,12,36,12z M26,16h9 M26,20h9"
  }), props.children);
});
var MobileDevices =
/*#__PURE__*/
React.forwardRef(function MobileDevices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "16",
    cy: "35.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,39H9V15h14V39z M9,32h30 M28,39V19h-5 M23,39h5h11v-7.03V9H15v6"
  }), props.children);
});
var MobilePhone =
/*#__PURE__*/
React.forwardRef(function MobilePhone(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33,39H15V9h18V39z M15,32h18"
  }), React.createElement("circle", {
    cx: "24",
    cy: "35.5",
    r: "1"
  }), props.children);
});
var MortarAndPestle =
/*#__PURE__*/
React.forwardRef(function MortarAndPestle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,23c0,8.284-6.734,15-15.018,15S9,31.284,9,23H39z M22.196,23l-6.64-11.502c-0.825-1.429-2.669-1.923-4.098-1.098l0,0 c-1.429,0.825-1.923,2.669-1.098,4.098L15.271,23"
  }), props.children);
});
var Moscow =
/*#__PURE__*/
React.forwardRef(function Moscow(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.723 26L28 26 28 28 16 28"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 34c0-.552.448-1 1-1s1 .448 1 1M32 34c0-.552.448-1 1-1s1 .448 1 1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 33L34 39M32 29L32 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 30L36 34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 27L28 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 35L24 39M20 35L20 39M24 28L24 33M20 28L20 33M16 28L16 33M22 39L22 39M26 39L26 39M22 37L22 39M18 39L18 39M18 37L18 39M26 37L26 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 37L22 38M18 37L18 38M26 37L26 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 33L36 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 35L36 35M32 28H36V29.906H32zM34 28L34 14M14 18L14 14M14 34c0-.552.448-1 1-1s1 .448 1 1M12 34c0-.552.448-1 1-1s1 .448 1 1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 34L12 39M14 34L14 39M16 34L16 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 30L14 31M12 30L12 34M12 35L16 35M16 33H28V35H16zM15 33L14 31 13 33M24 26L22 22 20 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19L17.634 23.14"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 19L18 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 26L24 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 26L22 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31c1.105-1.333 2.895-1.333 4 0M20 31c1.105-1.333 2.895-1.333 4 0M16 31c1.105-1.333 2.895-1.333 4 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 17H24V19H20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 15H23V17H21z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9L22 11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 11c0 .724.333 1.448 1 2 .667.552.667 1.448 0 2M22 11c0 .724-.333 1.448-1 2-.667.552-.667 1.448 0 2M34 18c0 1.302.764 2.48 2 3.333 1.236.853 2 2.032 2 3.333 0 1.302-.764 2.48-2 3.333"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 18c0 1.302.382 2.48 1 3.333.618.853 1 2.032 1 3.333 0 1.302-.382 2.48-1 3.333M34 18c0 1.302-.382 2.48-1 3.333-.618.853-1 2.032-1 3.333 0 1.302.382 2.48 1 3.333"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 18c0 1.302-.764 2.48-2 3.333-1.236.853-2 2.032-2 3.333 0 1.302.764 2.48 2 3.333M12 28c-1.236-.853-2-2.032-2-3.333 0-1.302.764-2.48 2-3.333 1.236-.853 2-2.032 2-3.333 0 1.302.764 2.48 2 3.333 1.236.853 2 2.032 2 3.333 0 1.302-.764 2.48-2 3.333"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 30L12 30 12 28 16 28"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.019 25L11 26 12 25 13 26 14 25 15 26 16 25 17.478 26.478M10.299 23.285L11 24 12 23 13 24 14 23 15 24 16 23 17 24 17.701 23.285"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 30L34 31M35 33L34 31 33 33"
  }), props.children);
});
var Mqa =
/*#__PURE__*/
React.forwardRef(function Mqa(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(10.005 23.994)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M39,9H9v23h30 V9z"
  }), props.children);
});
var Multitask =
/*#__PURE__*/
React.forwardRef(function Multitask(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,13c0,2.209-1.791,4-4,4s-4-1.791-4-4s1.791-4,4-4S28,10.791,28,13z M13,17c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4 S15.209,17,13,17z M35,17c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S37.209,17,35,17z M31.25,39 c0-3.357-2.285-6.173-5.382-6.998c1.392-0.691,2.357-2.113,2.357-3.772c0-2.333-1.892-4.225-4.225-4.225s-4.225,1.892-4.225,4.225 c0,1.659,0.966,3.081,2.357,3.772C19.035,32.827,16.75,35.643,16.75,39"
  }), props.children);
});
var Munich =
/*#__PURE__*/
React.forwardRef(function Munich(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32L39 32M9 34L39 34"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 14c0 1.508-.425 2.913-1.15 4.117M16 14c0 2.455 1.109 4.65 2.85 6.117M22.573 21.866C23.037 21.949 23.512 22 24 22c2.91 0 5.45-1.559 6.85-3.883M34.573 19.866C32.994 18.404 32 16.321 32 14M28 12c0 2.455 1.109 4.65 2.85 6.117M21.034 19.926C24.963 19.418 28 16.067 28 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M22.573 21.866c-.607-.562-1.129-1.214-1.539-1.94M18.85 20.117C19.575 18.913 20 17.508 20 16c0 1.428.378 2.765 1.034 3.926M28 24c-2.097 0-4-.814-5.427-2.134M18.85 20.117C17.45 22.441 14.91 24 12 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 30L12 32M28 30L28 32M14 28.089L14 32M16 26.891L16 32M18 26.222L18 32M20 26L20 32M22 26.222L22 32M24 26.891L24 32M26 28.089L26 32M26 28.089c-.639-.484-1.309-.883-2-1.198M28 30c-.617-.745-1.291-1.374-2-1.911M16 26.891c-.691.315-1.361.714-2 1.198M18 26.222c-.679.147-1.348.372-2 .669M24 26.891c-.652-.297-1.321-.523-2-.669M14 28.089c-.709.537-1.383 1.166-2 1.911M20 26c-.67 0-1.339.079-2 .222M22 26.222C21.339 26.079 20.67 26 20 26M9 21.931c3.945-.493 7-3.852 7-7.931M12 30c-.9-1.087-1.918-1.94-3-2.584M34.573 19.866c1.196 1.107 2.728 1.85 4.427 2.064M39 26.497c-3.793-1.255-8.02-.094-11 3.503"
  }), props.children);
});
var NaturalLanguageClassifier =
/*#__PURE__*/
React.forwardRef(function NaturalLanguageClassifier(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,26h-8v-4h8V26z M17,22H9v4h8V22z M39,22h-8v4h8V22z M27,33h-6v6h6V33z M13,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S14.657,9,13,9z M35,9l-3.464,6l6.928,0L35,9z M13,15v7 M35,15v7 M24,26v7"
  }), props.children);
});
var NetworkServices =
/*#__PURE__*/
React.forwardRef(function NetworkServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5,36.5c0,1.381-1.119,2.5-2.5,2.5s-2.5-1.119-2.5-2.5S22.619,34,24,34S26.5,35.119,26.5,36.5z M28,20 c-1.381,0-2.5,1.119-2.5,2.5S26.619,25,28,25s2.5-1.119,2.5-2.5S29.381,20,28,20z M28,25v6c0,1.105,0.895,2,2,2h4 M14,33h4 c1.105,0,2-0.895,2-2v-2 M14,30.5H9v5h5V30.5z M34,30v6l5-3L34,30z M32,27.014L34.5,27c2.485,0,4.5-2.015,4.5-4.5 S36.985,18,34.5,18C34,18,34,18,34,18c0-4.971-4.029-9-9-9c-3.529,0-6.567,2.042-8.041,5H15.5C11.91,14,9,16.91,9,20.5 s2.91,6.5,6.5,6.5h6.486c1.105,0,2,0.895,2,2L24,34"
  }), props.children);
});
var Network =
/*#__PURE__*/
React.forwardRef(function Network(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 24L26 27.464 22 27.464 20 24 22 20.536 26 20.536zM20 24L14.5 24M22 27.464L19.25 32.227M26 27.464L28.75 32.227M33.5 24L28 24M26 20.536L28.75 15.773"
  }), React.createElement("circle", {
    cx: "12",
    cy: "24",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18",
    cy: "34.392",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "30",
    cy: "34.392",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "36",
    cy: "24",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "30",
    cy: "13.608",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18",
    cy: "13.608",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.51 13.607L20.49 13.607M34.755 21.844L31.245 15.764M31.245 32.236L34.755 26.156M20.49 34.392L27.51 34.392M13.245 26.156L16.755 32.236M16.755 15.764L13.245 21.844M22 20.536L19.25 15.773"
  }), props.children);
});
var Networking_01 =
/*#__PURE__*/
React.forwardRef(function Networking_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5,24 c0,1.381-1.119,2.5-2.5,2.5s-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5S26.5,22.62,26.5,24z M36.5,21.5c-1.381,0-2.5,1.119-2.5,2.5 s1.119,2.5,2.5,2.5S39,25.381,39,24S37.881,21.5,36.5,21.5z M11.5,21.5C10.119,21.5,9,22.62,9,24s1.119,2.5,2.5,2.5 S14,25.381,14,24S12.881,21.5,11.5,21.5z M15.335,33.25c-0.69,1.196-0.281,2.724,0.915,3.414c1.196,0.69,2.724,0.281,3.414-0.915 c0.69-1.196,0.281-2.724-0.915-3.414C17.554,31.645,16.025,32.055,15.335,33.25z M28.335,33.25 c-0.69,1.196-0.281,2.724,0.915,3.414c1.196,0.69,2.724,0.281,3.414-0.915c0.69-1.196,0.281-2.724-0.915-3.414 C30.554,31.645,29.026,32.055,28.335,33.25z M15.335,14.75c0.69,1.196,2.219,1.605,3.414,0.915c1.196-0.69,1.605-2.219,0.915-3.414 s-2.219-1.605-3.414-0.915C15.054,12.026,14.645,13.554,15.335,14.75z M28.335,14.75c0.69,1.196,2.219,1.605,3.414,0.915 c1.196-0.69,1.605-2.219,0.915-3.414c-0.69-1.196-2.219-1.605-3.414-0.915C28.055,12.026,27.645,13.554,28.335,14.75z"
  }), props.children);
});
var Networking_02 =
/*#__PURE__*/
React.forwardRef(function Networking_02(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.995,24H33 M12,21c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,21,12,21z M36,21c-1.657,0-3,1.343-3,3s1.343,3,3,3 s3-1.343,3-3S37.657,21,36,21z M36,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S37.657,9,36,9z M36,33c-1.657,0-3,1.343-3,3 s1.343,3,3,3s3-1.343,3-3S37.657,33,36,33z M33,12h-9v24h9"
  }), props.children);
});
var Networking_03 =
/*#__PURE__*/
React.forwardRef(function Networking_03(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,12h15c3.313,0,6,2.686,6,5.999C39,21.313,36.313,24,33,24h-3 M18,24h-3c-3.313,0-6,2.687-6,6.001C9,33.314,11.687,36,15,36h15 M15,9H9v6h6V9z M39,33h-6v6h6V33z M27,21h-6v6h6V21z"
  }), props.children);
});
var Networking_04 =
/*#__PURE__*/
React.forwardRef(function Networking_04(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27H21V39H9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,15c0,3.314-2.686,6-6,6s-6-2.686-6-6 s2.686-6,6-6S39,11.686,39,15z M24.5,15H17c-1.105,0-2,0.895-2,2v8 M21.672,17.828L24.5,15l-2.828-2.828 M23.5,33H31 c1.105,0,2-0.895,2-2v-8 M26.328,30.172L23.5,33l2.828,2.828 M13,33h2.5c0.825,0,1.5-0.675,1.5-1.5v0c0-0.825-0.675-1.5-1.5-1.5 H13V33z M13,33v3h2.5c0.825,0,1.5-0.675,1.5-1.5l0,0c0-0.825-0.675-1.5-1.5-1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.62 17.995L33.006 11.995 35.39 17.995"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31.359 15.995L34.631 15.995"
  }), props.children);
});
var Networking_05 =
/*#__PURE__*/
React.forwardRef(function Networking_05(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,33v-7 M15,36.001c0-1.658-1.343-3-3-3c-1.658,0-3,1.343-3,3c0,1.657,1.342,3,3,3C13.656,39,15,37.658,15,36.001z M15,12.001 c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3C13.656,15,15,13.658,15,12.001z M20,31c1.657,0,3-1.343,3-3 c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3C17,29.657,18.343,31,20,31z M36,19v7 M35.999,13c-1.658,0-3,1.343-3,3 c0,1.658,1.342,3,3,3c1.657,0,3-1.343,3-3C39,14.343,37.656,13,35.999,13z M22,37h6V18 M20,25v-5l-6-6 M35.965,25.984 c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2s2-0.895,2-2C37.965,26.88,37.07,25.984,35.965,25.984z M28,14c-1.105,0-2,0.895-2,2 c0,1.105,0.895,2,2,2c1.105,0,2-0.895,2-2C30,14.896,29.104,14,28,14z M20,35c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2 c1.105,0,2-0.895,2-2C22,35.896,21.104,35,20,35z M12,22c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2s2-0.895,2-2 C14,22.896,13.104,22,12,22z"
  }), props.children);
});
var Nice =
/*#__PURE__*/
React.forwardRef(function Nice(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.394 27.801L17 31M28.606 27.801L31 31M21 35L19 31 17 31 16.145 32.185 15 33 15 35M27 35L26 32 22 32 21 35"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23,25c0,2.954-2,5-2,5h6c0,0-2-1.892-2-5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 13L25 13M23 25l-3 3-1-1 3-4c-.363-.621-1-2-1-3 0-2 2-3 2-5 0-1 0-1-1-1h-1M27 11.016L24 11.016M27 15L25 15"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,22v4 c0,0.552-0.448,1-1,1s-1-0.448-1-1V16c0-1.105,0.895-2,2-2h1.034C17,16,18,17,20,17h2.325"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 23c0 .552.448 1 1 1s1-.448 1-1v-3M18 21c0 .552.448 1 1 1s1-.448 1-1v-1M31 22v4c0 .552.448 1 1 1s1-.448 1-1V16c0-1.105-.895-2-2-2h-1.034C30 16 29 17 27 17"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 23c0 .552-.448 1-1 1s-1-.448-1-1v-3M27 17L25 17 25 12.016"
  }), React.createElement("ellipse", {
    cx: "21.5",
    cy: "9.508",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "23.5",
    cy: "9.508",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "25.5",
    cy: "9.508",
    rx: ".5",
    ry: ".508"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 21c0 .552-.448 1-1 1s-1-.448-1-1v-1M15 39c-.605 0-1.053-.191-1.482-.525S12.605 38 12 38s-1.089.14-1.518.475S9.605 39 9 39M21 39c-.605 0-1.053-.191-1.482-.525C19.089 38.14 18.605 38 18 38s-1.089.14-1.518.475C16.053 38.809 15.605 39 15 39M27 39c-.605 0-1.053-.191-1.482-.525C25.089 38.14 24.605 38 24 38s-1.089.14-1.518.475C22.053 38.809 21.605 39 21 39M33 39c-.605 0-1.053-.191-1.482-.525C31.089 38.14 30.605 38 30 38s-1.089.14-1.518.475C28.053 38.809 27.605 39 27 39M39 39c-.605 0-1.053-.191-1.482-.525C37.089 38.14 36.605 38 36 38s-1.089.14-1.518.475C34.053 38.809 33.605 39 33 39M15 37c-.605 0-1.053-.191-1.482-.525S12.605 36 12 36s-1.089.14-1.518.475S9.605 37 9 37M21 37c-.605 0-1.053-.191-1.482-.525C19.089 36.14 18.605 36 18 36s-1.089.14-1.518.475C16.053 36.809 15.605 37 15 37M27 37c-.605 0-1.053-.191-1.482-.525C25.089 36.14 24.605 36 24 36s-1.089.14-1.518.475C22.053 36.809 21.605 37 21 37M33 37c-.605 0-1.053-.191-1.482-.525C31.089 36.14 30.605 36 30 36s-1.089.14-1.518.475C28.053 36.809 27.605 37 27 37M39 37c-.605 0-1.053-.191-1.482-.525C37.089 36.14 36.605 36 36 36s-1.089.14-1.518.475C34.053 36.809 33.605 37 33 37M15 35c-.605 0-1.053-.191-1.482-.525S12.605 34 12 34s-1.089.14-1.518.475S9.605 35 9 35M21 35c-.605 0-1.053-.191-1.482-.525C19.089 34.14 18.605 34 18 34s-1.089.14-1.518.475C16.053 34.809 15.605 35 15 35M27 35c-.605 0-1.053-.191-1.482-.525C25.089 34.14 24.605 34 24 34s-1.089.14-1.518.475C22.053 34.809 21.605 35 21 35M33 35c-.605 0-1.053-.191-1.482-.525C31.089 34.14 30.605 34 30 34s-1.089.14-1.518.475C28.053 34.809 27.605 35 27 35M39 35c-.605 0-1.053-.191-1.482-.525C37.089 34.14 36.605 34 36 34s-1.089.14-1.518.475C34.053 34.809 33.605 35 33 35"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 35L29 31 31 31 31.855 32.185 33 33 33 35M21 12h1c0 0 0-1 1-1s1 0 1 0c.465 0 1 .393 1 .857v1.091l-.001-.003M21 12c-.552 0-1 .448-1 1M25 25L28 28 29 27 26 23 26 20"
  }), props.children);
});
var NightClear =
/*#__PURE__*/
React.forwardRef(function NightClear(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.4,32.839c0.042,0,0.083-0.006,0.126-0.006C30.151,35.391,26.77,37,23.004,37C15.822,37,10,31.179,10,23.997 C10,16.858,15.698,11.068,22.821,11c-2.154,2.32-3.425,5.419-3.425,8.835C19.397,27.017,25.219,32.839,32.4,32.839z M34,14h-4 M32,16v-4 M28,18h-4 M26,20v-4 M38,27h-4 M36,29v-4"
  }), props.children);
});
var NycBrooklyn =
/*#__PURE__*/
React.forwardRef(function NycBrooklyn(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 18L36 22M32 18L32 22M37 12L37 18 31 18 31 12 34 10z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32L20 9 9 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 24L16 28M16 18L16 22M16 12L16 16M18 24L18 28M18 18L18 22M18 12L18 16M14 24L14 28M14 18L14 22M14 12L14 16M12 24L12 28M12 18L12 22M12 12L12 16M10 24L10 28M10 18L10 22M10 12L10 16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 39L12 32 28 32M28 39L28 22 39 22M20 36L20 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 29L36 32M32 29L32 32M36 34L36 37M32 34L32 37M32 24L32 27M36 24L36 27"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 39L16 36 24 36 24 39M24 32L24 16 20 16"
  }), props.children);
});
var NycManhattanAlt =
/*#__PURE__*/
React.forwardRef(function NycManhattanAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,15.998h-6v-5l3-2l3,2V15.998z M13,15.998v4 M17,15.998v4 M24,38.998v-19H9 M24,26.998h8 M39,15.998h-7v23 M11,24.998v-2 M15,24.998v-2 M19,24.998v-2 M11,30.998v-2 M15,30.998v-2 M19,30.998v-2 M26.5,30.998v-2 M29.5,30.998v-2 M26.5,34.998v-2 M29.5,34.998v-2 M34.5,20.998v-2 M37.5,20.998v-2 M34.5,24.998v-2 M37.5,24.998v-2"
  }), props.children);
});
var NycManhattan =
/*#__PURE__*/
React.forwardRef(function NycManhattan(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,13h15v16 M30,29H16v9.998 M39,21.998h-9v17 M38,11.998l-3-2l-3,2v6h6V11.998z M33,17.998v4 M37,17.998v4 M12,17v-2 M16,17v-2 M20,17v-2 M12,22v-2 M16,22v-2 M20,22v-2 M12,27.002v-2 M16,27.002v-2 M20,27.002v-2 M20,33v-2 M24,33v-2 M33,28.002v-2 M37,28.002v-2 M33,33v-2 M37,33v-2 M20,38v-2 M24,38v-2 M33,38v-2 M37,38v-2"
  }), props.children);
});
var Office =
/*#__PURE__*/
React.forwardRef(function Office(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,39 h-4v-8h4V39z M12,15v-2 M12,21v-2 M12,27v-2 M20,15v-2 M20,21v-2 M20,27v-2 M16,15v-2 M16,21v-2 M16,27v-2 M12,33v-2 M24,15v-2 M24,21v-2 M24,27v-2 M24,33v-2 M31,21v-2 M31,27v-2 M31,33v-2 M35,21v-2 M35,27v-2 M35,33v-2 M27,9H9v30h18V9z M39,16H27v23h12V16 z M33,12h-6v4h6V12z"
  }), props.children);
});
var OilPump =
/*#__PURE__*/
React.forwardRef(function OilPump(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.478,39v-4h3.043v4 M35.988,30v5 M13,23.5V39 M30.059,38.98l-6.06-16l-6.088,16 M21,30.98h6 M19.434,35h9.111 M22.5,26.979h3 M40,39H8 M37.664,27.402L18.661,16.439l-1.5,2.598L36.164,30L37.664,27.402z M19.874,9.333L19.874,9.333 c-1.191-0.688-2.728-0.276-3.415,0.915l-5.5,9.526c-0.687,1.191-0.276,2.728,0.915,3.415l0,0c1.191,0.687,2.728,0.276,3.415-0.915 l5.5-9.526C21.476,11.557,21.064,10.021,19.874,9.333z"
  }), React.createElement("circle", {
    cx: "13.134",
    cy: "20.98",
    r: "1"
  }), props.children);
});
var OilRig =
/*#__PURE__*/
React.forwardRef(function OilRig(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 31H9v-4h30V31zM23 20H9v7h14V20zM31 20h-6v7h6V20zM29 27h6V15h-6v5M19 13h-4v7h4V13zM33 11h-2l-2 4h6L33 11zM33 9h-2v2h2V9zM21 31v7.5M15 31v7.5M35 31v7.5M33 31v7.5M31 9l-12 6M9 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M11 38c0 .552.448 1 1 1s1-.448 1-1M13 38c0 .552.448 1 1 1s1-.448 1-1M15 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M17.001 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M19 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M21 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M23 38c0 .552.448 1 1 1s1-.448 1-1M25.001 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M27 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M29 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M31 38c0 .552.448 1 1 1s1-.448 1-1M33.001 38c0 .552.448 1 1 1s1-.448 1-1M35 38c0 .552.448 1 1 1 .552 0 1-.448 1-1M37 38c0 .552.448 1 1 1 .552 0 1-.448 1-1"
  }), props.children);
});
var Overcast =
/*#__PURE__*/
React.forwardRef(function Overcast(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,22.574c0,3.078-2.495,5.393-5.574,5.426H13.631C11.058,27.967,9,26.231,9,23.658C9,21.086,11.058,19,13.631,19 c0.839,0,1.624,0.225,2.303,0.613C16.32,15.537,19.75,12,23.927,12c3.408,0,6.313,2.304,7.479,5.299 C31.969,17.108,32.799,17,33.426,17C36.504,17,39,19.495,39,22.574z M9,33h18 M18,36h18"
  }), props.children);
});
var PaperClip =
/*#__PURE__*/
React.forwardRef(function PaperClip(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.982,26.845l11.935-6.89c0.405-0.234,0.848-0.339,1.284-0.329c0.83,0.019,1.631,0.458,2.077,1.23l0,0 c0.227,0.393,0.333,0.823,0.33,1.246c-0.006,0.844-0.447,1.663-1.231,2.115l-15.676,9.051c-0.615,0.355-1.289,0.519-1.951,0.509 c-1.294-0.018-2.546-0.698-3.24-1.9l0,0C9.171,31.289,9.007,30.65,9,30.019c-0.014-1.327,0.669-2.623,1.901-3.334l20.388-11.771 c0.857-0.495,1.797-0.715,2.719-0.687c1.722,0.051,3.378,0.967,4.303,2.569l0,0c0.494,0.856,0.714,1.795,0.687,2.715 c-0.05,1.723-0.966,3.381-2.569,4.306l-16.647,9.611"
  }), props.children);
});
var Parliament =
/*#__PURE__*/
React.forwardRef(function Parliament(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 34v-2M22 38v-4M16 34v-2M29 34v-2M26 38v-4M32 34v-2M19 38v-2M16 38v-2M29 38v-2M32 38v-2M36 38v-2M36 34v-2M36 30v-2M12 38v-2M12 34v-2M12 30v-2M24 14v-4M24 28v-2M21 28v-2M19 24h10M27 28v-2M11 39h25.5M14 26h-4v13h4V26zM38 26h-4v13h4V26zM34 30H14v9h20V30zM12 21L10 26 14 26zM36 21L34 26 38 26zM24 10H27V12H24zM19 28L19 24 24 14 29 24 29 28"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,34 c0-1.105-0.895-2-2-2s-2,0.895-2,2"
  }), props.children);
});
var PartnerRelationship =
/*#__PURE__*/
React.forwardRef(function PartnerRelationship(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.001,22l2,2 l-2,2 M21,22l-2,2l2,2 M19.001,24h10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35.001,10 c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S36.381,10,35.001,10z M33.001,38v-9 c-1.295-0.467-2-1.469-2-2.79L31,21c0-2.209,1.791-4,4-4s4,1.791,4,4l0.001,5.199c0,1.321-0.705,2.333-2,2.801v9 M13.001,10 c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S14.381,10,13.001,10z M11.001,38v-9 c-1.295-0.467-2-1.469-2-2.79L9,21c0-2.209,1.791-4,4-4s4,1.791,4,4l0.001,5.199c0,1.321-0.705,2.333-2,2.801v9"
  }), props.children);
});
var Path =
/*#__PURE__*/
React.forwardRef(function Path(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,24c0,1.657-1.343,3-3,3s-3-1.343-3-3s1.343-3,3-3S27,22.343,27,24z M13,21c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S14.657,21,13,21z M35,21c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S36.657,21,35,21z M24,10c-1.657,0-3,1.343-3,3s1.343,3,3,3 s3-1.343,3-3S25.657,10,24,10z M13,10c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S14.657,10,13,10z M35,10c-1.657,0-3,1.343-3,3 s1.343,3,3,3s3-1.343,3-3S36.657,10,35,10z M24,32c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S25.657,32,24,32z M13,32 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S14.657,32,13,32z M35,32c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S36.657,32,35,32z M16,13h5 M24,16v5 M24,27v5 M27,35h5"
  }), props.children);
});
var Pattern =
/*#__PURE__*/
React.forwardRef(function Pattern(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,29H11c-1.1,0-2-0.9-2-2V11c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v16C29,28.1,28.1,29,27,29z M19,29v8c0,1.1,0.9,2,2,2h16 c1.1,0,2-0.9,2-2V21c0-1.1-0.9-2-2-2h-8 M23,11l0-1c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1l0,1c0,0.552,0.448,1,1,1h1 C22.552,12,23,11.552,23,11z M18,17l0-1c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h1 C17.552,18,18,17.552,18,17z M29,17l0-1c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1l0,1c0,0.552,0.448,1,1,1h1 C28.552,18,29,17.552,29,17z M12,22v-1c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h1 C11.552,23,12,22.552,12,22z M23,22l0-1c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1l0,1c0,0.552,0.448,1,1,1h1 C22.552,23,23,22.552,23,22z M18,28l0-1c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h1 C17.552,29,18,28.552,18,28z M29,27L29,27c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1v1c0,0.552,0.448,1,1,1h0 C28.105,29,29,28.105,29,27z M9,11L9,11c0,0.552,0.448,1,1,1h1c0.552,0,1-0.448,1-1v-1c0-0.552-0.448-1-1-1h0"
  }), props.children);
});
var Perfume =
/*#__PURE__*/
React.forwardRef(function Perfume(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,39H16c-0.55,0-1-0.45-1-1V20c0-0.55,0.45-1,1-1h16c0.55,0,1,0.45,1,1v18C33,38.55,32.55,39,32,39z M27,19v-4.5 c0-0.275-0.225-0.5-0.5-0.5h-5c-0.275,0-0.5,0.225-0.5,0.5v4.275 M25.5,13.975V10.5c0-0.275-0.225-0.5-0.5-0.5h-2 c-0.275,0-0.5,0.225-0.5,0.5V14 M28.5,10.5L31,9 M28.5,12H32 M31,15l-2.5-1.5 M30.083,25.062h-12.25V34h12.25V25.062z"
  }), props.children);
});
var Person_01 =
/*#__PURE__*/
React.forwardRef(function Person_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15s2.5-1.119,2.5-2.5S25.381,10,24,10z M22,38v-9h-2c-1.105,0-2-0.895-2-2v-5 c0-2.761,2.239-5,5-5h2c2.761,0,5,2.238,5,5l0,5c0,1.105-0.895,2-2,2h-2v9"
  }), props.children);
});
var Person_02 =
/*#__PURE__*/
React.forwardRef(function Person_02(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.62,15,24,15s2.5-1.119,2.5-2.5S25.381,10,24,10z M22,38v-8.314 c-2.611-0.843-4.5-3.294-4.5-6.186c0-3.59,2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5c0,2.892-1.889,5.343-4.5,6.186l0,0V38"
  }), props.children);
});
var Person_03 =
/*#__PURE__*/
React.forwardRef(function Person_03(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15s2.5-1.119,2.5-2.5S25.381,10,24,10z M22,38v-9c-1.295-0.467-2-1.469-2-2.79 L20,21c0-2.209,1.791-4,4-4s4,1.791,4,4v5.199c0,1.321-0.705,2.333-2,2.801v9"
  }), props.children);
});
var Person_04 =
/*#__PURE__*/
React.forwardRef(function Person_04(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15c1.381,0,2.5-1.119,2.5-2.5S25.381,10,24,10z M22,38v-9h0h-2 c-1.427,0-2.394-1.452-1.845-2.77L21.17,19c0.546-1.198,1.401-2,2.829-2h0c1.429,0,2.3,0.802,2.829,2l-0.008-0.021l3.024,7.251 C30.394,27.548,29.427,29,28,29h-2v9"
  }), props.children);
});
var Person_05 =
/*#__PURE__*/
React.forwardRef(function Person_05(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15c1.381,0,2.5-1.119,2.5-2.5S25.381,10,24,10z M22,38l0-9l-3.845-9.23 C17.606,18.452,18.573,17,20,17h8c1.427,0,2.394,1.452,1.845,2.77L26,29l0,9"
  }), props.children);
});
var Person_06 =
/*#__PURE__*/
React.forwardRef(function Person_06(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15s2.5-1.119,2.5-2.5S25.381,10,24,10z M22,38V28h-3c-0.552,0-1-0.448-1-1v-9 c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1l0,9c0,0.552-0.448,1-1,1h-3v10"
  }), props.children);
});
var Person_07 =
/*#__PURE__*/
React.forwardRef(function Person_07(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15s2.5-1.119,2.5-2.5S25.381,10,24,10z M29,21H19c-0.552,0-1-0.448-1-1v-2 c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1v2C30,20.553,29.553,21,29,21z M22,38V28l-3,0c-0.552,0-1-0.448-1-1v-2 c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1v2c0,0.552-0.448,1-1,1h-3l0,0v10"
  }), props.children);
});
var Person_08 =
/*#__PURE__*/
React.forwardRef(function Person_08(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10c-1.381,0-2.5,1.119-2.5,2.5S22.619,15,24,15s2.5-1.119,2.5-2.5S25.381,10,24,10z M18,27v-9c0-0.552,0.448-1,1-1h2 c0.552,0,1,0.448,1,1v9c0,0.552-0.448,1-1,1h-2C18.448,28,18,27.553,18,27z M26,27v-9c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v9 c0,0.552-0.448,1-1,1h-2C26.448,28,26,27.553,26,27z M22,30v8 M26,38v-8"
  }), props.children);
});
var Person_09 =
/*#__PURE__*/
React.forwardRef(function Person_09(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,17c-1.381,0-2.5,1.119-2.5,2.5S22.62,22,24,22c1.381,0,2.5-1.119,2.5-2.5S25.381,17,24,17z M22,38V28l-3,0 c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1v2c0,0.552-0.448,1-1,1h-3l0,0v10"
  }), props.children);
});
var PersonalityInsights =
/*#__PURE__*/
React.forwardRef(function PersonalityInsights(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,24v-9 M30,39v-2.98c0-2.78-1.871-5.112-4.433-5.799c1.04-0.557,1.749-1.653,1.749-2.916c0-1.826-1.48-3.306-3.306-3.306 s-3.306,1.48-3.306,3.306c0,1.263,0.708,2.359,1.749,2.916C19.89,30.908,18,33.24,18,36.02V39 M12,15.002v5h23.501V15 M26.998,9h-6 v6h6V9z M12,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,9,12,9z M35.536,9l-3.464,6L39,15L35.536,9z"
  }), props.children);
});
var PetriCulture =
/*#__PURE__*/
React.forwardRef(function PetriCulture(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M24.5,24.001c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5S24.5,23.725,24.5,24.001z M28.5,13.5 c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S29.052,13.5,28.5,13.5z M16.5,28.5c-0.552,0-1,0.448-1,1s0.448,1,1,1 c0.552,0,1-0.448,1-1S17.052,28.5,16.5,28.5z M20.501,15c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 S20.777,15,20.501,15z M31,28.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S31.276,28.5,31,28.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M20.5,13c-1.381,0-2.5,1.119-2.5,2.5 s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S21.881,13,20.5,13z M33,18c-1.381,0-2.5,1.119-2.5,2.5S31.619,23,33,23 c1.381,0,2.5-1.119,2.5-2.5S34.381,18,33,18z M24.5,30c-1.381,0-2.5,1.119-2.5,2.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5 C27,31.119,25.881,30,24.5,30z M14,23c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S15.105,23,14,23z"
  }), props.children);
});
var PillBottle_01 =
/*#__PURE__*/
React.forwardRef(function PillBottle_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,15H14V9h20V15z M16,9v4 M24,9v4 M28,9v4 M20,9v4 M32,9v4 M32,15H16v24h16V15z M16,20h16 M19,23h5 M19,26h10 M19,28h10 M32,34 H16"
  }), props.children);
});
var Pills =
/*#__PURE__*/
React.forwardRef(function Pills(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.536,20.364c1.953,1.953,1.953,5.118,0,7.071s-5.118,1.953-7.071,0l-9.899-9.899c-1.953-1.953-1.953-5.118,0-7.071 s5.118-1.953,7.071,0L37.536,20.364z M25.515,22.485l7.071-7.071 M10.464,27.536c1.953,1.953,5.118,1.953,7.071,0 s1.953-5.118,0-7.071s-5.118-1.953-7.071,0S8.512,25.583,10.464,27.536z M12,33c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S13.657,33,12,33z M36.5,9c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S37.881,9,36.5,9z M12,9 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,9,12,9z M18.895,24h-9.84 M19.343,32.586c-0.781,0.781-0.781,2.047,0,2.828 c0.781,0.781,2.047,0.781,2.828,0l4.243-4.243c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.047-0.781-2.828,0L19.343,32.586z M36,37.879c1.105,0,2-0.895,2-2c0-1.105-0.895-2-2-2h-6c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2H36z M33,34v3.809"
  }), props.children);
});
var Podcast =
/*#__PURE__*/
React.forwardRef(function Podcast(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.393,34.607C10.679,31.892,9,28.142,9,24c0-8.284,6.716-15,15-15s15,6.716,15,15c0,4.142-1.679,7.892-4.393,10.607 M31.778,31.778C33.769,29.788,35,27.038,35,24c0-6.075-4.925-11-11-11s-11,4.925-11,11c0,3.038,1.231,5.788,3.222,7.778 M24,21 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S25.657,21,24,21z M24,29v10"
  }), props.children);
});
var Police =
/*#__PURE__*/
React.forwardRef(function Police(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,14 c-0.741-0.212-1.25-0.964-1.25-1.643c0-0.548,0-0.981,0-0.981c0.64,0,0.914-0.098,1.25-0.376c0.336,0.278,0.61,0.376,1.25,0.376 c0,0,0,0.433,0,0.981C25.25,13.036,24.741,13.788,24,14z M30,10.71c-3.07,0-4.38-0.44-6-1.71c-1.62,1.27-2.93,1.71-6,1.71 c-1.15,2.09-4,2.61-4,2.61l1.23,1.62l1.37,1.81l0.18,0.23L16.79,17c1.64-0.88,3.83-1.63,7.23-1.63s5.33,0.75,7.22,1.62l0.17-0.22 l1.37-1.83L34,13.32C34,13.32,31.15,12.8,30,10.71z M31.225,18.99c-1.89-0.87-3.82-1.62-7.22-1.62s-5.59,0.75-7.23,1.63 M16.403,19 c1.757,0.959,3.934,2.4,7.567,2.4s5.869-1.442,7.626-2.4 M32,35.714c0-1.096,0-1.963,0-1.963c-1.28,0-1.827-0.196-2.5-0.752 c-0.673,0.556-1.22,0.752-2.5,0.752c0,0,0,0.866,0,1.963c0,1.358,1.018,2.861,2.5,3.286C30.982,38.575,32,37.072,32,35.714z M32,35.714c0-1.096,0-1.963,0-1.963c-1.28,0-1.827-0.196-2.5-0.752c-0.673,0.556-1.22,0.752-2.5,0.752c0,0,0,0.866,0,1.963 c0,1.358,1.018,2.861,2.5,3.286C30.982,38.575,32,37.072,32,35.714z M31.24,16.99c0.18,0.47,0.31,0.97,0.4,1.48 c0.06,0.41,0.1,0.83,0.1,1.26c0,3.16-1.89,5.86-4.6,7.07C33.12,28.22,38,33.59,38,40 M10,40c0-6.41,4.88-11.78,10.86-13.2 c-2.7-1.21-4.59-3.91-4.59-7.07c0-0.43,0.04-0.86,0.11-1.27c0.08-0.51,0.21-1.01,0.4-1.48 M16,36h5"
  }), props.children);
});
var Power =
/*#__PURE__*/
React.forwardRef(function Power(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.984,9 L38,25H10L23.984,9z M33.528,9L10,33h28L14.568,9H33.528z M31,39l-2.636-25h-8.75L17,39 M17.627,33h12.736l-6.38-8L17.627,33z"
  }), props.children);
});
var Presentation =
/*#__PURE__*/
React.forwardRef(function Presentation(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22,15.981V9h17v14H24 M24,11h5 M24,13h4 M18.999,39v-1.573c0-2.174-1.415-4.016-3.362-4.7c1.144-0.595,1.933-1.778,1.933-3.156 c0-1.973-1.599-3.572-3.572-3.572s-3.572,1.599-3.572,3.572c0,1.379,0.79,2.562,1.934,3.157C10.413,33.413,9,35.255,9,37.427V39 M29,39l-0.001-1.573c0-2.174-1.415-4.016-3.362-4.7c1.144-0.595,1.933-1.778,1.933-3.156c0-1.973-1.599-3.572-3.572-3.572 s-3.572,1.599-3.572,3.572c0,1.379,0.79,2.562,1.934,3.157C20.414,33.413,19,35.255,19,37.427V39 M39,39v-1.573 c0-2.174-1.415-4.016-3.362-4.7c1.144-0.595,1.933-1.778,1.933-3.156c0-1.973-1.599-3.572-3.572-3.572s-3.572,1.599-3.572,3.572 c0,1.379,0.79,2.562,1.934,3.157c-1.947,0.685-3.36,2.526-3.36,4.699L29,39 M36.121,18.121c1.172-1.172,1.172-3.071,0-4.243 c-1.172-1.172-3.071-1.172-4.243,0s-1.172,3.071,0,4.243C33.05,19.293,34.95,19.293,36.121,18.121z M34,16l-0.745,2.885 M34,16 l2.152-2.134 M34,16l-2.567-1.508 M18,23v-5.272h7.04c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H22v0h-6.384 c1.14-0.595,1.927-1.778,1.927-3.156C17.543,10.599,15.967,9,14,9s-3.578,1.599-3.578,3.572c0,1.379,0.787,2.562,1.928,3.157 C10.409,16.413,9,18.255,9,20.427V23"
  }), props.children);
});
var Presenter =
/*#__PURE__*/
React.forwardRef(function Presenter(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,25 c1.56-2.16,3.905-3.75,6.525-4.37c-2.12-0.95-3.61-3.08-3.61-5.55c0-3.36,2.72-6.08,6.08-6.08s6.08,2.72,6.08,6.08 c0,2.47-1.49,4.6-3.61,5.55C29.085,21.25,31.44,22.84,33,25 M27.182,35.182c1.757-1.757,1.757-4.607,0-6.364 c-1.757-1.757-4.607-1.757-6.364,0c-1.757,1.757-1.757,4.607,0,6.364C22.576,36.939,25.425,36.939,27.182,35.182z M22.877,36.328 L24,32 M27.19,28.831L24,32 M24,32l-3.857-2.262 M35,29.47V25H13v4.47 M13,34.47V39h22v-4.53"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.5,32 c0,1.381-1.119,2.5-2.5,2.5s-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5S15.5,30.619,15.5,32z M35,29.5 c-1.381,0-2.5,1.119-2.5,2.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5C37.5,30.619,36.381,29.5,35,29.5z"
  }), props.children);
});
var Price =
/*#__PURE__*/
React.forwardRef(function Price(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,22.205L22.209,39L9,25.787L25.791,9L39,22.205z M36,12l-6.469,6.474 M30.917,19.86c0.767-0.767,0.767-2.01,0-2.777 c-0.767-0.767-2.01-0.767-2.777,0c-0.767,0.767-0.767,2.01,0,2.777S30.15,20.627,30.917,19.86z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.995,22.011l-8.263,8.263 M24.971,26.259c0.815-0.815,0.755-2.198-0.136-3.089c-0.89-0.89-2.273-0.951-3.089-0.136 c-0.815,0.815-0.755,2.198,0.136,3.089 M18.794,25.988c-0.815,0.815-0.755,2.198,0.136,3.089c0.89,0.89,2.273,0.951,3.089,0.136 s0.755-2.198-0.136-3.089"
  }), props.children);
});
var Printer =
/*#__PURE__*/
React.forwardRef(function Printer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,32 H9V18h30v14h-4 M35,26H13v13h22V26z M35,18V9H13v9 M31,22h4"
  }), props.children);
});
var PrivateNetwork_01 =
/*#__PURE__*/
React.forwardRef(function PrivateNetwork_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,12h15 c3.313,0,6,2.687,6,6c0,3.314-2.687,6-6,6h-3 M18,24h-3c-3.313,0-6,2.686-6,6c0,3.313,2.687,6,6,6h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,15H9V9h6V15z M39,33h-6v6h6V33z M25.995,21.022v-2.527c0-1.102-0.893-1.995-1.995-1.995c-1.101,0-1.995,0.893-1.995,1.995 v2.527 M24,24.25v1.5 M24,20.5c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S26.209,20.5,24,20.5z"
  }), props.children);
});
var PrivateNetworkAlt_01 =
/*#__PURE__*/
React.forwardRef(function PrivateNetworkAlt_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,12h15 c3.313,0,6,2.687,6,6c0,3.314-2.687,6-6,6h-3 M18,24h-3c-3.313,0-6,2.686-6,6c0,3.313,2.687,6,6,6h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,15H9V9h6V15z M39,33h-6v6h6V33z M25.995,21.022v-2.527c0-1.102-0.893-1.995-1.995-1.995c-1.101,0-1.995,0.893-1.995,1.995 v2.527 M24,24.25v1.5 M28,21h-8v7h8V21z"
  }), props.children);
});
var PrivateNetworkAlt =
/*#__PURE__*/
React.forwardRef(function PrivateNetworkAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,12h15 c3.313,0,6,2.686,6,5.999C39,21.313,36.313,24,33,24h-3 M18,24h-3c-3.313,0-6,2.687-6,6.001C9,33.314,11.687,36,15,36h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.005,21.022v-2.527c0-1.102,0.893-1.995,1.995-1.995c1.102,0,1.995,0.893,1.995,1.995v2.527 M24,24.25v1.5 M12,9 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.657,9,12,9z M36,33c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S37.657,33,36,33z M28,21h-8v7h8V21z"
  }), props.children);
});
var PrivateNetwork =
/*#__PURE__*/
React.forwardRef(function PrivateNetwork(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,12h15 c3.313,0,6,2.686,6,5.999C39,21.313,36.313,24,33,24h-3 M18,24h-3c-3.313,0-6,2.687-6,6.001C9,33.314,11.687,36,15,36h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.005,21.022v-2.527c0-1.102,0.893-1.995,1.995-1.995c1.102,0,1.995,0.893,1.995,1.995v2.527 M24,24.25v1.5 M24,20.5 c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S26.209,20.5,24,20.5z M12,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S13.657,9,12,9z M36,33c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S37.657,33,36,33z"
  }), props.children);
});
var Progress =
/*#__PURE__*/
React.forwardRef(function Progress(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17,35 c0,2.209-1.791,4-4,4s-4-1.791-4-4s1.791-4,4-4S17,32.791,17,35z M39,31h-8v8h8V31z M31,28h8v-8h-8 M39,17V9h-8 M20,39h8l-4-8 L20,39z M23.994,9.004 M27.994,17.004 M9,24c0,2.209,1.791,4,4,4s4-1.791,4-4s-1.791-4-4-4 M13,17c2.209,0,4-1.791,4-4 s-1.791-4-4-4 M20,28h8l-4-8 M28,17l-4-8"
  }), props.children);
});
var Puzzle =
/*#__PURE__*/
React.forwardRef(function Puzzle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,24H9 V13h4v-0.3c-0.57-0.35-0.96-0.98-0.96-1.7c0-1.11,0.9-2,2-2s2,0.89,2,2c0,0.75-0.42,1.4-1.04,1.74V13h7v5h0.24 c0.34-0.62,1-1,1.75-1C25.1,17,26,17.9,26,19c0,1.1-0.9,2-2.01,2c-0.72,0-1.35-0.43-1.7-1H22v4h-7 M23.993,28 c-0.757,0-1.408,0.383-1.75,1H22v-5h-7v-0.256c0.617-0.341,1.04-0.99,1.04-1.744c0-1.104-0.896-2-2-2s-2,0.896-2,2 c0,0.722,0.386,1.35,0.96,1.701V24H9v11h4v-0.299c-0.574-0.352-0.96-0.979-0.96-1.701c0-1.104,0.896-2,2-2s2,0.896,2,2 c0,0.754-0.423,1.403-1.04,1.744V35h7v-4h0.285c0.353,0.574,0.983,1,1.708,1C25.101,32,26,31.105,26,30S25.101,28,23.993,28z M22,31v4h4v0.27c-0.57,0.35-0.96,0.98-0.96,1.7c0,1.1,0.86,2.03,1.96,2.03s2.04-0.93,2.04-2.03c0-0.75-0.42-1.4-1.04-1.74V35h7v-4 h0.29c0.35,0.57,0.98,1,1.7,1C38.1,32,39,31.1,39,30c0-1.1-0.9-2-2.01-2c-0.75,0-1.41,0.38-1.75,1H35v-5H22v5 M22,20v4h13v-4h-0.28 c-0.36,0.57-0.99,1-1.71,1C31.9,21,31,20.1,31,19c0-1.1,0.9-2,2.01-2c0.75,0,1.41,0.38,1.75,1H35v-5h-7v-0.26 c0.62-0.34,1.04-0.99,1.04-1.74c0-1.11-0.9-2-2-2c-1.1,0-2,0.89-2,2c0,0.72,0.39,1.35,0.96,1.7V13h-4v5"
  }), props.children);
});
var QuestionAndAnswer =
/*#__PURE__*/
React.forwardRef(function QuestionAndAnswer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,39l-4-6.005h-4 c-1.1,0-2-0.9-2-2v-10c0-1.1,0.9-2,2-2h15c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2h-7 M32,25l2-4h3c1.1,0,2-0.9,2-2v-8 c0-1.1-0.9-2-2-2H25c-1.1,0-2,0.9-2,2v7.995 M31,21h-3 M31.018,16.495c0-1.111,0.157-1.434,0.827-1.816 c0.486-0.278,0.961-0.691,0.961-1.517c0-1.064-0.812-1.663-1.802-1.663c-0.997,0-1.81,0.711-1.81,1.663"
  }), React.createElement("path", {
    d: "M19.5,26c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S19.5,25.448,19.5,26z M23.5,25c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S24.052,25,23.5,25z M13.5,25c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S14.052,25,13.5,25z M31,18.625 c0.345,0,0.625-0.28,0.625-0.625c0-0.345-0.28-0.625-0.625-0.625c-0.345,0-0.625,0.28-0.625,0.625 C30.375,18.345,30.655,18.625,31,18.625z"
  }), props.children);
});
var Question =
/*#__PURE__*/
React.forwardRef(function Question(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.33,20.712 c0-3.706,2.991-6.71,6.68-6.71c3.689,0,6.68,2.363,6.68,6.069c0,6.676-6.695,4.732-6.695,11.924 M31.488,37 C35.978,34.408,39,29.557,39,24c0-8.284-6.716-15-15-15S9,15.716,9,24c0,5.557,3.022,10.408,7.512,13"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37.5",
    r: "1"
  }), props.children);
});
var RainyHeavy =
/*#__PURE__*/
React.forwardRef(function RainyHeavy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.861,34.366l1-1.732 M17.361,30.866l1-1.732 M13.361,37.866l1-1.732 M28.361,34.366l1-1.732 M15.361,34.366l1-1.732 M23.861,34.366l1-1.732 M25.861,30.866l1-1.732 M21.861,30.866l1-1.732 M30.361,30.866l1-1.732 M21.861,37.866l1-1.732 M17.861,37.866l1-1.732 M26.361,37.866l1-1.732 M33.426,15c-0.627,0-1.458,0.108-2.02,0.299C30.24,12.304,27.335,10,23.927,10 c-4.177,0-7.606,3.537-7.992,7.613C15.254,17.225,14.469,17,13.631,17C11.058,17,9,19.086,9,21.658 c0,2.573,2.058,4.309,4.631,4.342h19.795C36.504,25.967,39,23.652,39,20.574S36.504,15,33.426,15z"
  }), props.children);
});
var Rainy =
/*#__PURE__*/
React.forwardRef(function Rainy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14,34.464L16,31 M17.5,37l3.5-6 M24,34.464L26,31 M27.5,37l3.5-6 M33.426,16c-0.627,0-1.458,0.108-2.02,0.299 C30.24,13.304,27.335,11,23.927,11c-4.177,0-7.606,3.537-7.992,7.613C15.254,18.225,14.469,18,13.631,18 C11.058,18,9,20.086,9,22.658c0,2.573,2.058,4.309,4.631,4.342h19.795C36.504,26.967,39,24.652,39,21.574S36.504,16,33.426,16z"
  }), props.children);
});
var Rank =
/*#__PURE__*/
React.forwardRef(function Rank(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,15c-1.657,0-3-1.343-3-3 s1.343-3,3-3s3,1.343,3,3S13.657,15,12,15z M12.045,21.75H12c-1.242,0-2.25,1.008-2.25,2.25c0,1.242,1.008,2.25,2.25,2.25 c1.242,0,2.25-1.008,2.25-2.25C14.25,22.776,13.269,21.777,12.045,21.75z M12.03,34.5H12c-0.828,0-1.5,0.672-1.5,1.5 c0,0.828,0.672,1.5,1.5,1.5c0.828,0,1.5-0.672,1.5-1.5C13.5,35.185,12.846,34.519,12.03,34.5z M12,22v-7 M12,34.5V26 M21,9h18 M21,12h18 M21,15h18 M21,21h18 M21,24h18 M21,27h18 M21,33h18 M21,36h18 M21,39h18"
  }), props.children);
});
var Receipt =
/*#__PURE__*/
React.forwardRef(function Receipt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.605,38.998 M15,39h19v-8V9H15V39z M18,14h7 M29,14h2 M18,18h7 M29,18h2 M18,22h7 M29,22h2 M18,26h7 M18,30h13 M29,26h2 M29,34 h2"
  }), props.children);
});
var Recycle =
/*#__PURE__*/
React.forwardRef(function Recycle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.112,30l-3.409-6.15l5.252-2.911l3.285,5.934c0.378,0.682,0.319,1.436-0.018,2.03l-3.437,6.075 c-0.361,0.639-1.031,1.025-1.765,1.022H28v2l-4-5l4-5v2h8.409c0.81,0.004,1.463-0.48,1.813-1.097 M13.445,34.996 c-0.37-0.606-0.477-1.411-0.08-2.118l4.077-7.354l1.749,0.97l-2.434-5.923l-6.312,1.074l1.749,0.97l-2.434,4.39 c-0.359,0.64-0.346,1.414,0.038,2.039L13.445,34.996c0.356,0.583,0.987,0.999,1.767,1L21.994,36v-6.005h-7.032 M21.049,10.5 c0.71,0.001,1.453,0.331,1.848,1.038l4.141,7.319l-1.741,0.985l6.321,1.019L34,14.917l-1.741,0.985l-2.472-4.369 c-0.358-0.64-1.025-1.034-1.759-1.033H21.049c-0.683-0.001-1.368,0.319-1.776,0.984l-3.548,5.781l5.12,3.138l3.674-5.995"
  }), props.children);
});
var Refinery =
/*#__PURE__*/
React.forwardRef(function Refinery(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M40 39L8 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10,9c0,1.311,0.945,2,1.999,2l0,0c1.311,0,1.999,0.946,1.999,2 M16,12c0-2-1-3-3-3 M16,25.171V20h-4v12 M28,39V17h-4v22 M39,39 V25h-9v14 M10.5,17c0,1.063,0.739,2.374,1.5,3l4,0c0.761-0.626,1.5-1.937,1.5-3c0-1.063-0.739-2.374-1.5-3l-4,0 C11.238,14.626,10.5,15.937,10.5,17z M14,28 M16,39v-3h-4v3 M9,34c0,0.805,0.442,1.526,1,2h8c0.558-0.474,1-1.195,1-2 c0-0.805-0.442-1.526-1-2h-8C9.441,32.474,9,33.195,9,34z M30,36h9 M21,24.001 M27,17v-2c0-1.657-1.343-3-3-3h-2 c-1.657,0-3,1.343-3,3v9c0,0.552-0.448,1-1,1h-1c-1.657,0-3,1.343-3,3l0,4 M25,17v-2c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1 c0,0.691,0,9,0,9c0,1.657-1.343,3-3,3h-1c-0.552,0-1,0.448-1,1v4"
  }), props.children);
});
var Refresh =
/*#__PURE__*/
React.forwardRef(function Refresh(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,21l-6-6l6-6 M10,24v13 c0,1.105,0.895,2,2,2h24c1.105,0,2-0.895,2-2V17c0-1.105-0.895-2-2-2H15"
  }), props.children);
});
var RelationshipExtraction =
/*#__PURE__*/
React.forwardRef(function RelationshipExtraction(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,16H9v-4h7V16z M39,12H20v4h19V12z M16,32H9v4h7V32z M39,32H20v4h19V32z M32,26h7v-4h-7V26z M9,26h19v-4H9V26z"
  }), props.children);
});
var RenewTeam =
/*#__PURE__*/
React.forwardRef(function RenewTeam(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,32v-3.749 c0-1.89,1.314-3.473,3.076-3.891c-0.798-0.355-1.355-1.153-1.355-2.082C21.722,21.019,22.741,20,24,20s2.281,1.019,2.281,2.278 c0,0.929-0.557,1.727-1.355,2.082c1.762,0.418,3.073,2,3.073,3.891V32 M31,29v-3.747c0-1.89-1.312-3.473-3.074-3.891 c0.798-0.355,1.355-1.153,1.355-2.082c0-1.259-1.021-2.28-2.28-2.28c-1.259,0-2.28,1.021-2.28,2.28 c0,0.323,0.067,0.63,0.188,0.908 M23.091,20.188c0.121-0.278,0.188-0.585,0.188-0.908c0-1.259-1.021-2.28-2.28-2.28 c-1.259,0-2.28,1.021-2.28,2.28c0,0.929,0.557,1.727,1.355,2.082c-1.762,0.418-3.074,2-3.074,3.891V29 M24,11 c-7.18,0-13,5.817-13,12.997c0,6.147,4.267,11.298,10,12.652 M24,37c7.18,0,13-5.82,13-13c0-6.147-4.267-11.298-10-12.652"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22,9l2,2l-2,2 M25.997,35.004L24,37l2,2"
  }), props.children);
});
var Renew =
/*#__PURE__*/
React.forwardRef(function Renew(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36,9v6h-6 M18,33h-6v6 M36,15 c-2.737-3.643-7.093-6-12-6C15.716,9,9,15.716,9,24 M12,33c2.737,3.643,7.093,6,12,6c8.284,0,15-6.716,15-15"
  }), props.children);
});
var Repeat =
/*#__PURE__*/
React.forwardRef(function Repeat(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,9l4,4l-4,4 M39,13H11 c-1.1,0-2,0.9-2,2v9 M13,31l-4,4l4,4 M9,35h28c1.1,0,2-0.9,2-2v-9"
  }), props.children);
});
var Report =
/*#__PURE__*/
React.forwardRef(function Report(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 V9h30V39z M9,33l9-9l7,7l14-14 M9,17h30"
  }), props.children);
});
var ResetHybridCloud =
/*#__PURE__*/
React.forwardRef(function ResetHybridCloud(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,35.232H24 c-7.18,0-13-5.82-13-13s5.82-13,13-13s13,5.82,13,13 M33.464,38.768L37,35.232l-3.536-3.536 M22,29.98c-3.45-0.888-6-4.02-6-7.748 c0-4.418,3.582-8,8-8v4l3,2l-6,4l3,2v4c4.418,0,8-3.582,8-8c0-3.728-2.549-6.86-6-7.748"
  }), props.children);
});
var ResetSettings =
/*#__PURE__*/
React.forwardRef(function ResetSettings(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,35.232H24 c-7.18,0-13-5.82-13-13s5.82-13,13-13s13,5.82,13,13 M33.464,38.768L37,35.232l-3.536-3.536 M31.5,23.979v-2.957h-1.942 l-0.578-1.41l1.369-1.369l-2.091-2.091l-1.373,1.373l-1.406-0.588V15h-2.957v1.942l-1.41,0.578l-1.369-1.369l-2.091,2.091 l1.373,1.373l-0.588,1.406H16.5v2.957h1.942l0.578,1.41l-1.369,1.369l2.091,2.091l1.373-1.373l1.406,0.588V30h2.957v-1.942 l1.41-0.578l1.369,1.369l2.091-2.091l-1.373-1.373l0.588-1.406H31.5z"
  }), props.children);
});
var Reset =
/*#__PURE__*/
React.forwardRef(function Reset(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36,9v6h-6 M36.001,14.999 C33.264,11.356,28.907,9,24,9C15.716,9,9,15.716,9,24s6.716,15,15,15s15-6.716,15-15"
  }), props.children);
});
var RetrieveAndRank =
/*#__PURE__*/
React.forwardRef(function RetrieveAndRank(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,15h-6v-3h6V15z M27.55,12h-3.078v3H29.8 M29.8,25.001h-5.328v3h3.077 M20,18.5h-8v3h8V18.5z M30.882,18.5H23v3h7.883 M21,25.001h-6v3h6V25.001z M39,19.999h-8 M39,22.999h-8.414 M39,13.999h-9.779 M39,16.999h-8.414 M20,9C13.925,9,9,13.925,9,20 s4.925,11,11,11s11-4.925,11-11S26.075,9,20,9z M27.785,27.784L39,39"
  }), props.children);
});
var RichTextFormat =
/*#__PURE__*/
React.forwardRef(function RichTextFormat(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,31H9V16h15V31z M18.5,18c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S19.328,18,18.5,18z M24,28l-4-4l-2,2 l-5-5l-4,4 M15,31v8h24V15l-6-6H15v7 M33,9v6h6 M24,19h11 M24,23h11 M24,27h11 M24,31h11 M19,35h12"
  }), props.children);
});
var Robot =
/*#__PURE__*/
React.forwardRef(function Robot(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25,39 c0-1.105,0.895-2,2-2s2,0.895,2,2H25z M20,9V14h8V9H20z M24,14v3 M29,17H19v13h10V17z M11,24.17l0.828,0.243 c0.613,0.18,1.262-0.174,1.442-0.787l0,0c0.18-0.613-0.174-1.262-0.787-1.442L11.856,22l-0.002,0L11,22.5 M18.5,12.5v-2 M29.5,12.5v-2 M26,11.5L26,11.5c0-0.552-0.448-1-1-1h-2c-0.552,0-1,0.448-1,1v0c0,0.552,0.448,1,1,1h2 C25.552,12.5,26,12.052,26,11.5z M18.999,18h-1c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2h1 M28.999,22h1c1.105,0,2-0.895,2-2 c0-1.105-0.895-2-2-2h-1 M13.316,23.333L16.203,25h-0.008l0.866-3.233 M37,22.5L36.175,22l-0.002,0l-0.627,0.184 c-0.613,0.18-0.967,0.829-0.787,1.442v0c0.18,0.613,0.829,0.967,1.442,0.787L37,24.17 M30.967,21.767L31.834,25h-0.008 l2.887-1.667 M27,30v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,30v7 M23,39c0-1.105-0.895-2-2-2s-2,0.895-2,2H23z"
  }), props.children);
});
var Robotics =
/*#__PURE__*/
React.forwardRef(function Robotics(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.224,30l-2.876-4.99 c-0.493-0.854-0.435-1.917,0.005-2.676c0.228-0.394,0.557-0.736,0.977-0.978l0,0c0.858-0.494,1.882-0.456,2.685,0.009 c0.391,0.227,0.729,0.555,0.969,0.972L34.401,30 M37,30H24v5h13V30z M15.807,25.142l1.501-2.58 c0.799-1.324,0.369-3.061-0.955-3.86l0,0c-1.324-0.799-3.061-0.369-3.86,0.955l-1.597,2.65L15.807,25.142z M10.851,29.757 l1.563-0.463l0.002-0.002l0.521-0.96c0.509-0.939,0.157-2.125-0.782-2.634l0,0c-0.939-0.509-2.125-0.157-2.634,0.782L9,27.44 l0.463,1.563 M13.363,23.739l-1.151,1.993 M9,38.993L11.305,35H39v4H9V38.993z M34,9c-2.209,0-4,1.791-4,4s1.791,4,4,4 s4-1.791,4-4S36.209,9,34,9z M20,10c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S21.657,10,20,10z M27,21.021l3.506-6.073 M30.374,23l3.466-6.003 M15.433,18.349l2.102-3.64 M17.166,19.445l2.049-3.549 M22.827,12h7.301 M22.827,14h7.301"
  }), React.createElement("path", {
    d: "M20.5,13c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5S20.5,12.724,20.5,13z M34,12.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.276,12.5,34,12.5z M27.5,23.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5S28,24.276,28,24S27.776,23.5,27.5,23.5z"
  }), props.children);
});
var Rome =
/*#__PURE__*/
React.forwardRef(function Rome(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 36L9 36"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 21L12 21c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M12 21L12 24M14 21L14 24M16 21L16 21c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M16 21L16 24M18 21L18 24M12 27L12 27c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M12 27L12 30M14 27L14 30M16 27L16 27c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M16 27L16 30M18 27L18 30M20 27L20 27c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M20 27L20 30M22 27L22 30M24 27L24 27c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M24 27L24 30M26 27L26 30M12 33L12 33c0-.55.45-1 1-1h0c.55 0 1 .45 1 1l0 0M12 33L12 36M14 33L14 36M16 33L16 33c0-.55.45-1 1-1h0c.55 0 1 .45 1 1l0 0M16 33L16 36M18 33L18 36M20 33L20 33c0-.55.45-1 1-1h0c.55 0 1 .45 1 1l0 0M20 33L20 36M22 33L22 36M24 33L24 33c0-.55.45-1 1-1h0c.55 0 1 .45 1 1l0 0M24 33L24 36M26 33L26 36M28 33L28 33c0-.55.45-1 1-1h0c.55 0 1 .45 1 1l0 0M28 33L28 36M30 33L30 36M34 36v-3l0 0c0-.55.45-1 1-1l0 0c.55 0 1 .45 1 1l0 0M36 33L36 36M34 27L34 27c0-.55.45-1 1-1l0 0c.55 0 1 .45 1 1v0M36 27L36 30 34 30 34 27M30 27L30 27c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0M32 27L32 30 30 30 30 27"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 36L10 12 15 12 17 18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 16L13 14M9 18L19 18 21 24M9 24L27 24 29 30M31 22L31 20M27 22L27 20M35 22L35 20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 36L38 18 24 18 24 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 30L32 30 34 36"
  }), props.children);
});
var SaasEnablement =
/*#__PURE__*/
React.forwardRef(function SaasEnablement(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14,11.5 c0,1.381-1.119,2.5-2.5,2.5S9,12.881,9,11.5S10.119,9,11.5,9S14,10.119,14,11.5z M11.5,21.5C10.119,21.5,9,22.619,9,24 s1.119,2.5,2.5,2.5S14,25.381,14,24S12.881,21.5,11.5,21.5z M36.5,9c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 s2.5-1.119,2.5-2.5S37.881,9,36.5,9z M36.5,21.5c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5S39,25.381,39,24 S37.881,21.5,36.5,21.5z M24,9c-1.381,0-2.5,1.119-2.5,2.5S22.619,14,24,14s2.5-1.119,2.5-2.5S25.381,9,24,9z M11.5,34 C10.119,34,9,35.119,9,36.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S12.881,34,11.5,34z M36.5,34c-1.381,0-2.5,1.119-2.5,2.5 s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S37.881,34,36.5,34z M24,34c-1.381,0-2.5,1.119-2.5,2.5S22.619,39,24,39s2.5-1.119,2.5-2.5 S25.381,34,24,34z M30,18H18v12h12V18z M18,22h12 M20,26h8"
  }), React.createElement("circle", {
    cx: "28",
    cy: "20",
    r: ".5"
  }), props.children);
});
var SanFranciscoFog =
/*#__PURE__*/
React.forwardRef(function SanFranciscoFog(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 14H22V16H20zM22 14H24V16H22zM24 14H26V16H24zM26 14H28V16H26zM20 22H22V24H20zM22 22H24V24H22zM24 22H26V24H24zM26 22H28V24H26zM20 30H22V32H20zM22 30H24V32H22zM24 30H26V32H24zM26 30H28V32H26z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 9L19 12M29 9L29 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 15L18 32.256M18 15L18 12 20 12 20 33.082M30 15L30 12 28 12 28 34.555M30 15L30 30.725M18 15c0 0-.006 9.406-7.125 15.567M30 15c0 0 .003 7.181 4.75 13.104"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 32.256C17.361 32.091 16.691 32 16 32c-.814 0-1.598.123-2.338.349-.781-.783-1.737-1.378-2.788-1.782M20 33.082c-.62-.36-1.289-.642-2-.826M39 28.594C38.073 28.215 37.063 28 36 28c-.426 0-.842.04-1.25.104M30 30.725c-.949 1.082-1.616 2.418-1.873 3.898-.04-.026-.085-.044-.127-.069M28 34.555C27.41 34.21 26.732 34 26 34c-1.35 0-2.538.673-3.263 1.698-.689-1.076-1.631-1.973-2.737-2.616M10.875 30.567c-.598-.23-1.218-.416-1.875-.498M34.75 28.104c-1.885.297-3.547 1.25-4.75 2.622"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16,32c-0.697,0-1.392,0.098-2.069,0.279c-0.668,0.178-1.315,0.446-1.927,0.8"
  }), props.children);
});
var SanFrancisco =
/*#__PURE__*/
React.forwardRef(function SanFrancisco(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 39L28 9M20 39L20 9M9 28L39 28M9 30L39 30M20.028 14L28.028 14M20.028 12L28.028 12M20.028 22L28.028 22M20.028 20L28.028 20M20.028 34L28.028 34M20.028 36L28.028 36M32.028 20.943L32.028 28M36.028 23.316L36.028 28M16.028 20.943L16.028 28M12.028 23.316L12.028 28M22 12L22 14M24 12L24 14M26 12L26 14M22 20L22 22M24 20L24 22M26 20L26 22M22 34L22 36M24 34L24 36M26 34L26 36"
  }), React.createElement("path", {
    d: "M36.12 22.977c-1.436-.508-2.741-1.282-3.88-2.302-2.466-2.207-3.88-5.368-3.88-8.675H27.64c0 3.511 1.502 6.868 4.12 9.212 1.209 1.082 2.596 1.904 4.12 2.444 1.008.356 2.054.576 3.12.662v-.721C38.016 23.513 37.051 23.306 36.12 22.977zM19.64 12c0 3.307-1.414 6.468-3.88 8.675-1.139 1.02-2.444 1.794-3.88 2.302-.931.329-1.896.537-2.88.62v.721c1.066-.086 2.112-.306 3.12-.662 1.524-.54 2.911-1.362 4.12-2.444 2.618-2.344 4.12-5.701 4.12-9.212H19.64z"
  }), props.children);
});
var SaoPauloExpandedBase =
/*#__PURE__*/
React.forwardRef(function SaoPauloExpandedBase(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9L24 16 26 9"
  }), React.createElement("path", {
    d: "M28.353,39c0-0.031,0.003-0.062-0.006-0.093l-4-15c-0.084-0.314-0.611-0.314-0.695,0l-4,15 c-0.008,0.031-0.006,0.062-0.006,0.093h0.726L24,25.397L27.628,39H28.353z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 32L27 13M32 32L26 17M12 32L21 13M23 20L20 9 9 32 39 32 28 9 25 20M15 32L22 17"
  }), React.createElement("path", {
    d: "M30.354 39c0-.03.003-.061-.005-.092l-5-19c-.05-.19-.246-.304-.44-.257-.192.051-.307.248-.256.44L29.628 39H30.354zM23.092 19.651c-.194-.052-.39.065-.44.257l-5 19c-.008.031-.005.062-.005.092h.726l4.976-18.908C23.399 19.899 23.284 19.702 23.092 19.651z"
  }), props.children);
});
var SaoPaulo =
/*#__PURE__*/
React.forwardRef(function SaoPaulo(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9L24 16 26 9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 39L24 24 28 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 32L27 13M32 32L26 17M12 32L21 13"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 39L23 20 20 9 9 32 39 32 28 9 25 20 30 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 32L22 17"
  }), props.children);
});
var SatelliteDish =
/*#__PURE__*/
React.forwardRef(function SatelliteDish(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,12.591 c2.408,0,4.816,0.919,6.653,2.756c1.837,1.837,2.756,4.245,2.756,6.653 M29.983,22c0-1.531-0.584-3.062-1.752-4.23 c-1.168-1.168-2.699-1.752-4.23-1.752 M37,22c0-3.332-1.271-6.663-3.813-9.205C30.639,10.247,27.738,9,24,9 M16.629,16.629 c-3.515,3.515-3.515,9.213,0,12.728s9.213,3.515,12.728,0L16.629,16.629z M26.561,19.439c-0.586-0.586-1.536-0.586-2.121,0 c-0.586,0.586-0.586,1.536,0,2.121c0.586,0.586,1.536,0.586,2.121,0C27.146,20.975,27.146,20.025,26.561,19.439z M22.992,22.993 l1.414-1.414 M11,39h16 M22,39c0-1.657-1.343-3-3-3s-3,1.343-3,3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,36v-3"
  }), props.children);
});
var Satellite =
/*#__PURE__*/
React.forwardRef(function Satellite(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35.683,13.592 l-5.134,2.961l-0.581,1.976l2.002,0.485l5.134-2.961L35.683,13.592z M34.47,14.342l-3.075-5.343l-2.461,1.421l3.075,5.343 M29.968,18.529c-0.6-1.04-1.93-1.396-2.97-0.796l2.174,3.766C30.212,20.899,30.568,19.569,29.968,18.529z M28.06,19.577 l-1.059,0.611 M33.46,18.213l3.074,5.315L39,22.107l-3.079-5.315 M31,38c3.784-2.193,5.999-5.921,6-10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.289 20.003l1.404 2.433c.181.313.122.709-.142.956l-2.398 2.212c-.264.247-.323.642-.143.955l3.648 6.335c.18.312.122.706-.14.953l-4.947 4.694M13.751 37.73l1.677-2.901c.139-.24.139-.537 0-.777l-.911-1.578c-.18-.312-.122-.707.141-.954l1.379-1.297c.263-.247.321-.642.141-.955l-1.029-1.782c-.139-.24-.395-.388-.673-.388h-2.505c-.277 0-.533-.147-.672-.387l-1.081-1.862M25.878 23.576l-1.953 3.402c-.138.24-.138.535 0 .774l1.516 2.636c.139.241.395.389.673.389h1.784M18.5 20C13.253 20 9 24.253 9 29.5s4.253 9.5 9.5 9.5 9.5-4.253 9.5-9.5S23.747 20 18.5 20zM17.293 9.293L18.707 10.707M17.293 10.707L18.707 9.293M9.293 15.293L10.707 16.707M9.293 16.707L10.707 15.293"
  }), props.children);
});
var Scale =
/*#__PURE__*/
React.forwardRef(function Scale(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.066,22.093l-5.692-5.692C16.094,13.682,19.85,12,23.999,12s7.906,1.682,10.625,4.401l-5.692,5.692 c-1.262-1.262-3.006-2.043-4.933-2.043S20.329,20.831,19.066,22.093z M39,9H9v30h30V9z M24,20.056v-4 M24,14v-2 M29.501,15.208 l1-1.732 M18.5,15.212l-1-1.732"
  }), props.children);
});
var Seattle =
/*#__PURE__*/
React.forwardRef(function Seattle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9L24 14"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 30L22 39M24 30L24 39M26 30L26 39M28 30L28 39M20 30L20 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 20L28 18 28 16 20 16 20 18 18 20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24L39 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 22H36V26H12zM23 14H25V16H23z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 26L18 28M20 26L20 28M22 26L22 28M24 26L24 28M26 26L26 28M28 26L28 28M30 26L30 28M18 20L18 22"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 22L32 20 16 20 16 22"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 20L20 22M22 20L22 22M24 20L24 22M26 20L26 22M28 20L28 22M30 20L30 22"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 26L16 28 32 28 32 26M18 28L18 30 30 30 30 28"
  }), props.children);
});
var SecureData =
/*#__PURE__*/
React.forwardRef(function SecureData(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,14h14 M24,19h14 M24,24h14 M37.41,29.001H24 M34.7,34.001H24 M10,9v16c0,7.7,6.3,14,14,14s14-6.3,14-14V9H10z M24,9v30"
  }), props.children);
});
var SecureProfile =
/*#__PURE__*/
React.forwardRef(function SecureProfile(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31.5 30.499L31.5 33.415"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "30.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,27v12h15V24H9V9h15 v12.013 M34.999,24L35,19.5c0-1.925-1.575-3.5-3.5-3.5h-0.001C29.575,16,28,17.575,28,19.5V24 M21,24v-2.999 c0-2.059-1.409-3.787-3.304-4.317c0.775-0.425,1.307-1.238,1.307-2.184c0-1.381-1.119-2.5-2.5-2.5c-1.381,0-2.5,1.119-2.5,2.5 c0,0.945,0.531,1.758,1.305,2.183C13.41,17.212,12,18.941,12,21.001V24"
  }), props.children);
});
var SecurityShield =
/*#__PURE__*/
React.forwardRef(function SecurityShield(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("defs", null), React.createElement("clipPath", {
    id: "b"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 14.457L35 21M23 20.414L35 26.957M23 26.457L34 32.455M23 32.5L30.611 36.649",
    clipPath: "url(#b)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,9l-11,6c0,0,0,8,0,13c0,6,5,11,11,11 s11-5,11-11c0-7,0-13,0-13L24,9z"
  }), props.children);
});
var Security =
/*#__PURE__*/
React.forwardRef(function Security(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,9l-11,6c0,0,0,8,0,13 c0,6,5,11,11,11s11-5,11-11c0-7,0-13,0-13L24,9z"
  }), props.children);
});
var ServerRack =
/*#__PURE__*/
React.forwardRef(function ServerRack(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,39H13v-5h22V39z M27,36h6 M15,36h1 M17,36h1 M19,36h1 M35,29H13v5h22V29z M27,31h6 M15,31h1 M17,31h1 M19,31h1 M35,24H13v5h22 V24z M27,26h6 M15,26h1 M17,26h1 M19,26h1 M35,19H13v5h22V19z M27,21h6 M15,21h1 M17,21h1 M19,21h1 M35,14H13v5h22V14z M27,16h6 M15,16h1 M17,16h1 M19,16h1 M35,9H13v5h22V9z M27,11h6 M15,11h1 M17,11h1 M19,11h1"
  }), props.children);
});
var Servers =
/*#__PURE__*/
React.forwardRef(function Servers(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,39 H17V9h14V39z M20,12h8 M20,15h8 M20,18h8 M31,35h8V13h-8 M31,16h4 M31,19h4 M31,22h4 M17,13H9v22h8 M17,16h-4 M17,19h-4 M17,22h-4"
  }), props.children);
});
var Shop =
/*#__PURE__*/
React.forwardRef(function Shop(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39L9 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,27v12 M11,27v12 M19,27h-5v12h5V27z M14.014,33H19 M34,36v-9H24v9H34z M9,9v10h30V9H9z M37,24v-4.401l0-0.108V14H11v5.491V24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 22c0 1.105-.895 2-2 2s-2-.895-2-2M22 22c0 1.105-.895 2-2 2s-2-.895-2-2M26 22c0 1.105-.895 2-2 2-1.105 0-2-.895-2-2M30 22c0 1.105-.895 2-2 2s-2-.895-2-2M34 22c0 1.105-.895 2-2 2-1.105 0-2-.895-2-2M14 22c0 1.105-.895 2-2 2M36 24c-1.105 0-2-.895-2-2M11 24L12 24M36 24L37 24"
  }), props.children);
});
var ShoppingCart =
/*#__PURE__*/
React.forwardRef(function ShoppingCart(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17,14h22l-1.632,11.287C37.083,27,36.187,28,34.588,28c-1.45,0-15.499,0-15.499,0c-1.809,0-2.795-1.424-3.368-3.685L12,9H9 M13.719,16.018l3.214,13.438C17.5,32,18.434,33,20.319,33H37 M20.5,35c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2 S21.605,35,20.5,35z M34,35c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S35.105,35,34,35z"
  }), props.children);
});
var Shower =
/*#__PURE__*/
React.forwardRef(function Shower(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24H23v-2h16V24z M32,16h-2.001L23,22h16L32,16z M32,16v-5c0-1.105-0.895-2-2-2H13c-1.105,0-2,0.895-2,2v21 M29.999,16L30,12c0-0.552-0.448-1-1-1 H14c-0.552,0-1,0.448-1,1v20 M17,34l-9,0 M11,36v3 M13,36v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25,29v-3 M25,32v-1 M31,29v-3 M31,32v-1 M28,27v-1 M28,32v-3 M28,35v-1 M37,29v-3 M37,32v-1 M34,27v-1 M34,32v-3 M34,35v-1"
  }), props.children);
});
var Singapore =
/*#__PURE__*/
React.forwardRef(function Singapore(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 24L35 24M33 26L35 26M33 28L35 28M33 30L35 30M33 32L35 32M37 36c-1.105 0-2-.895-2-2V24c0-2.209 1.791-4 4-4H29c2.209 0 4 1.791 4 4v10c0 1.105-.895 2-2 2M13 24L15 24M13 26L15 26M13 28L15 28M13 30L15 30M13 32L15 32M17 36c-1.105 0-2-.895-2-2V24c0-2.209 1.791-4 4-4H9c2.209 0 4 1.791 4 4v10c0 1.105-.895 2-2 2M14 9L34 9M26 15L26 35M24 12L24 39M22 15L22 35M26 15c0-3.314 2.686-6 6-6M16 9c3.314 0 6 2.686 6 6M24 13c0-2.209 1.791-4 4-4M24 13c0-2.209-1.791-4-4-4M26 16c0 1.105-.895 2-2 2s-2-.895-2-2M26 20c0 1.105-.895 2-2 2s-2-.895-2-2M26 24c0 1.105-.895 2-2 2s-2-.895-2-2M26 28c0 1.105-.895 2-2 2s-2-.895-2-2M26 32c0 1.105-.895 2-2 2s-2-.895-2-2M22 35c0 2.209-1.791 4-4 4M26 35c0 2.209 1.791 4 4 4"
  }), props.children);
});
var SingleSignOn =
/*#__PURE__*/
React.forwardRef(function SingleSignOn(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M39,9H9v23h30 V9z"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(13.304 23.996)"
  }), props.children);
});
var Slider =
/*#__PURE__*/
React.forwardRef(function Slider(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,12c0,1.657-1.343,3-3,3 s-3-1.343-3-3s1.343-3,3-3S18,10.343,18,12z M33,21c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3 C36,22.343,34.657,21,33,21z M24,33c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3C27,34.343,25.657,33,24,33z M9,12h3 M18,12h21 M36,24h3 M30,24H9 M27,36h12 M21,36H9"
  }), props.children);
});
var Sneaker =
/*#__PURE__*/
React.forwardRef(function Sneaker(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,33.205h30 M26.308,24.749l-1.485,2.449 M26.839,28.315l1.47-2.424 M30.309,27.033l-1.455,2.399 M16,21c-1.657,0-3,1.343-3,3 s1.343,3,3,3s3-1.343,3-3S17.657,21,16,21z M9,35h28.501l0-0.002C38.332,34.989,39,34.168,39,33.154 c0-0.646-0.27-1.213-0.683-1.543l0.001-0.004L22,22.29v-2.378V13.5L11,20l-2,7V35z"
  }), props.children);
});
var Snow =
/*#__PURE__*/
React.forwardRef(function Snow(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,32h2 M19,31v2 M22,32h2 M23,31v2 M26,32h2 M27,31v2 M30,32h2 M31,31v2 M16,36h2 M17,35v2 M20,36h2 M21,35v2 M24,36h2 M25,35v2 M28,36h2 M29,35v2 M33.426,16c-0.627,0-1.458,0.108-2.02,0.299C30.24,13.304,27.335,11,23.927,11 c-4.177,0-7.606,3.537-7.992,7.613C15.254,18.225,14.469,18,13.631,18C11.058,18,9,20.086,9,22.658 c0,2.573,2.058,4.309,4.631,4.342h19.795C36.504,26.967,39,24.652,39,21.574S36.504,16,33.426,16z"
  }), props.children);
});
var SoftIceCream =
/*#__PURE__*/
React.forwardRef(function SoftIceCream(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,16c1.875,0,3.125,1.113,3.125,2.5c0,1.25-0.531,2.041-1.825,2.5 M18.353,21.176 M23,16h-3.25 M20,32l1,7h6l1-7H20z M18,28l1,4 h10l1-4 M25,9c-3.562,1-5,2.5-5,4.5c0,0.688,0.367,2.013,1,2.5 M28,16c0.542-0.393,1-1.143,1-2c0-1.46-1.266-1.785-2.5-2.18 C25.5,11.5,25,10.663,25,9 M20,21h-0.994C16.79,21,15,22.194,15,24.41S16.79,28,19.006,28h10.082C31.281,28,33,26.49,33,24.41 C33,22.69,31.75,21,29.132,21h-3.913 M19.5,16c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5"
  }), props.children);
});
var SoftlayerEnablement =
/*#__PURE__*/
React.forwardRef(function SoftlayerEnablement(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,15H9V9h30V15z M39,21H9v6h30V21z M39,33H9v6h30V33z"
  }), props.children);
});
var Solve =
/*#__PURE__*/
React.forwardRef(function Solve(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "35.495",
    cy: "35.495",
    r: "3.5",
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.0198,1.9765",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.5,16h-7V9h7V16z M16,32H9v7h7V32z M39,20.5h-7v7h7V20.5z M24,20.5c-1.933,0-3.5,1.567-3.5,3.5s1.567,3.5,3.5,3.5 s3.5-1.567,3.5-3.5S25.933,20.5,24,20.5z M12.5,9C10.567,9,9,10.567,9,12.5s1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5S14.433,9,12.5,9z M24,33l-3.5,6h7L24,33z M12.5,21L9,27h7L12.5,21z M35.5,9L32,15h7L35.5,9z"
  }), props.children);
});
var Spaceship =
/*#__PURE__*/
React.forwardRef(function Spaceship(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.208,22.044c-0.783,1.355-2.516,1.82-3.871,1.037s-1.82-2.516-1.037-3.871s2.516-1.82,3.871-1.037 C30.527,18.955,30.991,20.689,30.208,22.044z M26.981,38.104l4.01-2.312l-2.662-4.61l3.571-4.978 C33.915,23.396,35,20.028,35,16.572v-6.306c0-0.973-1.052-1.582-1.895-1.095c-2.18,1.258-5.463,3.154-5.463,3.154 c-2.992,1.728-5.368,4.35-6.792,7.498l-2.525,5.582H13v4.64"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.799,39c1.025-0.518,2.341-1.241,2.782-2.004l0.045-0.078c0.777-1.346,0.316-3.067-1.03-3.845 c-1.346-0.777-3.067-0.316-3.845,1.03l-0.045,0.078c-0.44,0.763-0.408,2.263-0.344,3.41"
  }), props.children);
});
var SpeechAlphabetAExpanded =
/*#__PURE__*/
React.forwardRef(function SpeechAlphabetAExpanded(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.004,19.001L18.778,19l-2.437-6.133h-0.669l-2.439,6.134h0.775l0.653-1.641h2.691L18.004,19.001z M14.947,16.64l1.06-2.666l1.059,2.666H14.947z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.006,12h6 M32.006,10.498V12 M29.006,17c4.709,0,4.351-5,4.351-5 M30.424,13.5C30.744,14.987,32.367,17,35.006,17 M33.994,39 c0-4.625-3.145-8.505-7.409-9.648c1.731-0.926,2.91-2.751,2.91-4.852c0-3.038-2.463-5.501-5.501-5.501s-5.501,2.463-5.501,5.501 c0,2.101,1.179,3.925,2.91,4.852c-4.265,1.143-7.409,5.023-7.409,9.648 M23,17v-4c0-1.105-0.895-2-2-2H11c-1.105,0-2,0.895-2,2v7 c0,1.105,0.895,2,2,2h3l2,4 M32,24l2-4h3c1.1,0,2-0.9,2-2v-7c0-1.1-0.9-2-2-2H27c-1.1,0-2,0.9-2,2v4"
  }), props.children);
});
var SpeechToText =
/*#__PURE__*/
React.forwardRef(function SpeechToText(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,20h12 M24,14h12 M24,26h12 M21,23H11c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h4l2,4 M16.999,35h6c1.1,0,2-0.9,2-2v-2 M18.014,14.002h-4.015 c-1.105,0-2,0.895-2,2v4.5 M15.186,16.83l2.828-2.828l-2.828-2.828 M39,9H21v22h18V9z"
  }), React.createElement("path", {
    d: "M18,29c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S18,28.448,18,29z M13,28c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S13.552,28,13,28z M20.639,28.073C20.266,28.218,20,28.576,20,29c0,0.424,0.266,0.782,0.639,0.927V28.073z"
  }), props.children);
});
var Speech =
/*#__PURE__*/
React.forwardRef(function Speech(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.006,12h6 M32.006,10.498V12 M29.006,17c4.709,0,4.351-5,4.351-5 M30.424,13.5C30.744,14.987,32.367,17,35.006,17 M33.994,39 c0-4.625-3.145-8.505-7.409-9.648c1.731-0.926,2.91-2.751,2.91-4.852c0-3.038-2.463-5.501-5.501-5.501s-5.501,2.463-5.501,5.501 c0,2.101,1.179,3.925,2.91,4.852c-4.265,1.143-7.409,5.023-7.409,9.648 M18.391,19l-2.385-6l-2.385,6 M14.36,17h3.271 M23,17v-4 c0-1.105-0.895-2-2-2H11c-1.105,0-2,0.895-2,2v7c0,1.105,0.895,2,2,2h3l2,4 M32,24l2-4h3c1.1,0,2-0.9,2-2v-7c0-1.1-0.9-2-2-2H27 c-1.1,0-2,0.9-2,2v4"
  }), props.children);
});
var Speedometer =
/*#__PURE__*/
React.forwardRef(function Speedometer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,12v5 M16.5,14.01 l2.5,4.33 M15.34,22l-4.33-2.5 M9,27h5 M11.01,34.5l4.33-2.5 M32.66,32l4.33,2.5 M39,27h-5 M37,19.5L24,27 M31.5,14.01L29,18.34"
  }), props.children);
});
var StairsPlanView =
/*#__PURE__*/
React.forwardRef(function StairsPlanView(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,10v28 M24,12H10v20h28l0,0 M24,36h14V16H10 M38,20H10 M38,24H10 M38,28H10"
  }), props.children);
});
var StationaryBicycle =
/*#__PURE__*/
React.forwardRef(function StationaryBicycle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.464 33L17 27"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8,39h32 M30,39v-3 M18,36v3 M22.655,19.296C21.297,18.473,19.704,18,18,18c-4.971,0-9,4.029-9,9s4.029,9,9,9 M17,24c-1.657,0-3,1.343-3,3 c0,1.657,1.343,3,3,3s3-1.343,3-3C20,25.343,18.657,24,17,24z M18,33h5 M16,18.056L13.658,14 M27.969,22.718L33.58,13 M29,13h6 c2.2,0,4-1.8,4-4v0 M37.001,28.536l-14.346-9.24 M18,36h17 M35,36c2.209,0,4-1.791,4-4c0-1.48-0.804-2.773-1.999-3.464 M11,12h7 M18,14h-7 M11,12c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1 M18,14c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1"
  }), props.children);
});
var Steel =
/*#__PURE__*/
React.forwardRef(function Steel(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 v-2h30V39z M39,33H9v2h30V33z M38,35H10v2h28V35z M33,33l-9-9l-9,9 M24,9v10c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3"
  }), props.children);
});
var SteeringWheel =
/*#__PURE__*/
React.forwardRef(function SteeringWheel(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24c0,8.284-6.716,15-15,15S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M24,12c-6.627,0-12,5.373-12,12s5.373,12,12,12 s12-5.373,12-12S30.627,12,24,12z M24,20c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S26.209,20,24,20z M36,24h-8 M20,24h-8 M24,28v8"
  }), props.children);
});
var Stethoscope =
/*#__PURE__*/
React.forwardRef(function Stethoscope(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "13",
    cy: "24",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,24c0,1.105-0.895,2-2,2s-2-0.895-2-2c0-1.105,0.895-2,2-2S15,22.895,15,24z M13,26v5c0,4.418,3.582,8,8,8s8-3.582,8-8v-3 M24,9h-3v11c0,4.418,3.582,8,8,8s8-3.582,8-8V9h-3"
  }), props.children);
});
var StrategyDirect =
/*#__PURE__*/
React.forwardRef(function StrategyDirect(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35,39H13v-6h22V39z M29,9v2h-3V9h-4v2h-3V9h-4v8h18V9H29z M31,17l1,16 M17,17l-1,16 M24,24h7.5 M27,20h4 M29,28h3 M16,30h4"
  }), props.children);
});
var StrategyMove =
/*#__PURE__*/
React.forwardRef(function StrategyMove(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32,19h-3 M32,23h-3 M32,27h-3 M29,33l3-4v-9.432c0-4.06-1.744-5.877-3.369-7.502L24,9l-0.001,3.75h-2.5l-7.5,6.25l1.25,2.5L24,20 l-6,9l2,4 M19.25,33C16.903,33,15,34.903,15,37.25V39h19v-1.75c0-2.347-1.903-4.25-4.25-4.25H19.25z"
  }), props.children);
});
var StrategyPlay =
/*#__PURE__*/
React.forwardRef(function StrategyPlay(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.998,29 c0,1.105-0.895,2-2,2c-1.105,0-2-0.895-2-2s0.895-2,2-2C36.102,27,36.998,27.895,36.998,29z M27.998,27c-1.105,0-2,0.895-2,2 s0.895,2,2,2c1.105,0,2-0.895,2-2S29.102,27,27.998,27z M27.998,34c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2 S29.102,34,27.998,34z M20.998,27c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2S22.102,27,20.998,27z M25.886,20l4.112,4 M25.998,24l4-4 M18.886,10l4.112,4 M18.998,14l4-4 M32.886,17l4.112,4 M32.998,21l4-4 M12.998,13c0,0,0,13,0,18 s4.997,5.005,4.997,5.005H24 M14.998,15l-2-2l-1.996,1.996 M33.998,12l-2-2l-1.996,1.996 M31.986,10c0,0,0,0,0,3s-2.988,3-2.988,3 s0,0-4,0s-4,4-4,4v5"
  }), props.children);
});
var Strategy =
/*#__PURE__*/
React.forwardRef(function Strategy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8,39 M11,19h8 M9,31h12 M12,21v5l-3,8l1,2h4.941h-0.023H20l1-2l-3-8v-5 M10,36v3 M20,36v3 M13,11h4V9h-4V11z M13,13h4 M18,17v-2l1-2 l-1-2h-6l-1,2l1,2v2 M25.999,23H28 M25.999,26H28 M25.999,29H28 M35,34.126l1-3.128L32,24l6,1l1-2l-6-5h-2v-3l-2.905,2.453 c-1.3,1.3-2.095,2.754-2.095,6.002v7.548L27,34.126 M8,39h32 M38,39v-1.001c0-2.2-1.8-4-4-4h-6c-2.2,0-4,1.8-4,4V39"
  }), props.children);
});
var Streamline =
/*#__PURE__*/
React.forwardRef(function Streamline(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24h-7.5 c-1.381,0-2.5,1.119-2.5,2.5v1c0,1.381-1.119,2.5-2.5,2.5S24,28.881,24,27.5v-7c0-1.381-1.119-2.5-2.5-2.5S19,19.119,19,20.5v11 c0,1.381-1.119,2.5-2.5,2.5S14,32.881,14,31.5v-15c0-1.381-1.119-2.5-2.5-2.5S9,15.119,9,16.5V19 M36,27l3-3l-3-3"
  }), props.children);
});
var SunnyHazy =
/*#__PURE__*/
React.forwardRef(function SunnyHazy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,28h15 M23,24h15 M23,32h15 M21,36h12 M10,32h7 M24,20c0-2.209-1.791-4-4-4s-4,1.791-4,4s1.791,4,4,4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,14v-2 M15.757,15.757l-1.414-1.414 M14,20h-2 M26,20h2 M24.243,15.757l1.414-1.414"
  }), props.children);
});
var Sunny =
/*#__PURE__*/
React.forwardRef(function Sunny(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,24c0,3.866-3.134,7-7,7s-7-3.134-7-7s3.134-7,7-7S31,20.134,31,24z M24,14v-3 M16.929,16.929l-2.121-2.121 M11,24h3 M16.929,31.071l-2.121,2.121 M24,34v3 M31.071,31.071l2.121,2.121 M34,24h3 M31.071,16.929l2.121-2.121"
  }), props.children);
});
var SupportServices =
/*#__PURE__*/
React.forwardRef(function SupportServices(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27,27h-6v-6h6V27z M17,17v-0.501c0-1.827-1.232-3.35-2.905-3.829C14.639,12.313,15,11.699,15,11c0-1.104-0.895-2-2-2 s-2,0.895-2,2c0,0.699,0.36,1.313,0.904,1.671C10.232,13.149,9,14.673,9,16.499V17 M29,24h4.5c3.038,0,5.5-2.462,5.5-5.5 S36.538,13,33.5,13H19 M19,24h-4.5C11.462,24,9,26.462,9,29.5s2.462,5.5,5.5,5.5H29 M39,39v-0.501c0-1.827-1.232-3.35-2.905-3.829 C36.639,34.313,37,33.699,37,33c0-1.104-0.895-2-2-2s-2,0.895-2,2c0,0.699,0.36,1.313,0.904,1.671 C32.232,35.149,31,36.673,31,38.499V39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 38L29 34.99 26 32"
  }), props.children);
});
var SwipeLeft =
/*#__PURE__*/
React.forwardRef(function SwipeLeft(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,15L9,15 M12,12l-3,3l3,3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,15c0-1.186,0.821-2,2-2h-0.003C27.176,13,28,13.814,28,15v8c0,0,4.663,0,6.913,0S39,24.541,39,26.776c0,0,0,2.758,0,4.01 C39,35.478,37.706,39,30.769,39c-4.829,0-7.104-2.056-10.134-5.48c-0.845-0.955-3.439-3.765-3.439-3.765 C16.365,28.819,15,27.415,15,26.985c0-1.299,3.219-2.011,4.792-0.803C21.008,27.116,24,30.5,24,30.5V15z M30.006,19.46 c1.23-1.09,2-2.69,2-4.46c0-3.31-2.69-6-6-6s-6,2.69-6,6c0,1.77,0.77,3.37,2,4.46"
  }), props.children);
});
var SwipeRight =
/*#__PURE__*/
React.forwardRef(function SwipeRight(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38,15l-11,0 M35,18l3-3l-3-3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,15c0-1.186,0.821-2,2-2h-0.003C22.176,13,23,13.814,23,15v8c0,0,4.663,0,6.913,0C32.162,23,34,24.541,34,26.776 c0,0,0,2.758,0,4.01C34,35.478,32.706,39,25.769,39c-4.829,0-7.104-2.056-10.134-5.48c-0.845-0.955-3.439-3.765-3.439-3.765 C11.365,28.819,10,27.415,10,26.985c0-1.299,3.219-2.011,4.792-0.803C16.008,27.116,19,30.5,19,30.5V15z M24.994,19.46 c1.23-1.09,2-2.69,2-4.46c0-3.31-2.69-6-6-6s-6,2.69-6,6c0,1.77,0.77,3.37,2,4.46"
  }), props.children);
});
var Tags =
/*#__PURE__*/
React.forwardRef(function Tags(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.285,25.131L22.285,36L9,22.872v-7.248L12.666,12H20L33.285,25.131z M25.103,33.218L27.921,36L39,25.131L25.636,12L20,12 M16.315,16.849c-0.665-0.657-1.743-0.657-2.409,0c-0.665,0.657-0.665,1.723,0,2.381c0.666,0.657,1.744,0.657,2.409,0 C16.979,18.572,16.979,17.506,16.315,16.849z"
  }), props.children);
});
var TargetArea =
/*#__PURE__*/
React.forwardRef(function TargetArea(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("ellipse", {
    cx: "24",
    cy: "24",
    rx: "1",
    ry: "1",
    transform: "translate(-.026 .026)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14,24 c0-5.523,4.477-10,10-10c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10C18.477,34,14,29.523,14,24z M24,29c2.761,0,5-2.239,5-5 c0-2.761-2.239-5-5-5c-2.761,0-5,2.239-5,5C19,26.761,21.239,29,24,29z M39,39V9H14 M9,9v30h25"
  }), props.children);
});
var Target =
/*#__PURE__*/
React.forwardRef(function Target(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,24c0-8.284,6.716-15,15-15c8.284,0,15,6.716,15,15c0,8.284-6.716,15-15,15C15.715,39,9,32.284,9,24z M24,34 c5.523,0,10-4.477,10-10c0-5.523-4.477-10-10-10c-5.523,0-10,4.477-10,10C14,29.523,18.477,34,24,34z M24,29c2.761,0,5-2.239,5-5 c0-2.761-2.239-5-5-5c-2.761,0-5,2.239-5,5C19,26.761,21.238,29,24,29z"
  }), React.createElement("ellipse", {
    cx: "24",
    cy: "24",
    rx: "1",
    ry: "1",
    transform: "translate(-.026 .026)"
  }), props.children);
});
var TelAviv =
/*#__PURE__*/
React.forwardRef(function TelAviv(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 20L25 28M27 20L27 28M29 20L29 28M31 20L31 28M33 20L33 28M35 20L35 28M37 20L37 28M39 20L39 28M23 20L23 28M21 20L21 28M19 20L19 28M17 20L17 28M15 20L15 28M13 20L13 28M11 20L11 28M9 20L9 28M24 29L24 34M26 29L26 34M28 29L28 34M30 29L30 34M32 29L32 34M34 29L34 34M36 29L36 34M22 29L22 34M20 29L20 34M18 29L18 34M16 29L16 34M14 29L14 34M12 29L12 34M24 14L24 19M26 14L26 19M28 14L28 19M30 14L30 19M32 14L32 19M34 14L34 19M36 14L36 19M22 14L22 19M20 14L20 19M18 14L18 19M16 14L16 19M14 14L14 19M12 14L12 19M27 35L27 38M29 35L29 38M31 35L31 38M25 35L25 38M23 35L23 38M21 35L21 38M19 35L19 38M17 35L17 38M27 10L27 13M29 10L29 13M31 10L31 13M25 10L25 13M23 10L23 13M21 10L21 13M19 10L19 13M17 10L17 13"
  }), props.children);
});
var Telecom =
/*#__PURE__*/
React.forwardRef(function Telecom(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,18 c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S26,16.895,26,18z M19.757,13.757C18.672,14.843,18,16.343,18,18 c0,1.657,0.672,3.157,1.757,4.243 M28.243,22.243C29.328,21.157,30,19.657,30,18c0-1.657-0.672-3.157-1.757-4.243 M17.636,11.636 C16.007,13.265,15,15.515,15,18c0,2.485,1.007,4.735,2.636,6.364 M30.364,24.364C31.993,22.735,33,20.485,33,18 c0-2.485-1.007-4.735-2.636-6.364 M15.515,9.515C13.343,11.686,12,14.686,12,18c0,3.321,1.349,6.328,3.53,8.5 M32.485,26.485 C34.657,24.314,36,21.314,36,18c0-3.314-1.343-6.314-3.515-8.485 M11,39h26 M23.062,19.769L17.91,39 M30.09,39l-5.153-19.233 M20.324,30h7.358 M18.982,35H29.02 M21.662,25h4.678"
  }), props.children);
});
var Telephone =
/*#__PURE__*/
React.forwardRef(function Telephone(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,15h19v24H9V15h3 M36,18H23v10h13V18z M20,35V13c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2v22c0,1.1,0.9,2,2,2h4 C19.1,37,20,36.1,20,35z M30,31h6 M37,15V9"
  }), props.children);
});
var Television =
/*#__PURE__*/
React.forwardRef(function Television(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9V17h30V39z M33,19H11v18h22V19z M36,19c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S36.552,19,36,19z M36,23 c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S36.552,23,36,23z M23,17l-7-4 M23,17l7-7"
  }), props.children);
});
var TemperatureHigh =
/*#__PURE__*/
React.forwardRef(function TemperatureHigh(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,11h8 M26,14h4 M26,17h8 M26,20h4 M26,23h8 M26,26h4 M22,27.349V9h-4v18.349c-2.329,0.825-4,3.04-4,5.651c0,3.313,2.686,6,6,6 s6-2.687,6-6C26,30.389,24.329,28.173,22,27.349z M18,14h4"
  }), props.children);
});
var TemperatureLow =
/*#__PURE__*/
React.forwardRef(function TemperatureLow(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30,11h8 M30,14h4 M30,17h8 M30,20h4 M30,23h8 M30,26h4 M22,20h4 M26,27.349V9h-4v18.349c-2.329,0.825-4,3.04-4,5.651 c0,3.313,2.686,6,6,6s6-2.687,6-6C30,30.389,28.329,28.173,26,27.349z"
  }), props.children);
});
var Tennis =
/*#__PURE__*/
React.forwardRef(function Tennis(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.998,14.498l-7.59,7.59 M27.998,16.498l-3.747,3.747"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.245,23.768 c0.005,2.538-0.092,4.996,2.109,7.197l6.022,6.022c0.22,0.22,0.168,0.628-0.116,0.913l-0.847,0.847 c-0.284,0.284-0.693,0.336-0.913,0.116l-6.022-6.022l-0.001-0.001c-2.201-2.201-4.659-2.104-7.197-2.109 M32.389,31.001 l-1.876,1.876 M24.512,11.462c-4.074-2.316-9.098-1.944-12.29,1.247c-3.905,3.905-3.589,10.553,0.707,14.849 s10.944,4.612,14.849,0.707c2.441-2.441,3.232-5.953,2.434-9.293 M28.379,9.879c-1.172,1.172-1.172,3.071,0,4.243 c1.172,1.172,3.071,1.172,4.243,0c1.172-1.172,1.172-3.071,0-4.243C31.45,8.707,29.551,8.707,28.379,9.879z M30.334,9.005 c-0.045,0.822,0.246,1.66,0.874,2.288c0.627,0.627,1.463,0.919,2.285,0.874 M30.651,14.996c0.041-0.817-0.251-1.648-0.875-2.272 c-0.624-0.624-1.455-0.916-2.272-0.875"
  }), props.children);
});
var TestTubes =
/*#__PURE__*/
React.forwardRef(function TestTubes(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,39L24,39c-1.65,0-3-1.35-3-3V9h6v27C27,37.65,25.65,39,24,39z M17,36V9h-6v27c0,1.65,1.35,3,3,3h0C15.65,39,17,37.65,17,36z M37,36V9h-6v27c0,1.65,1.35,3,3,3h0C35.65,39,37,37.65,37,36z M10,9h8 M11,25h6 M21,31h6 M31,21h6 M20,9h8 M9,14h30 M30,9h8"
  }), props.children);
});
var TextToSpeech =
/*#__PURE__*/
React.forwardRef(function TextToSpeech(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M20,25.5c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S20,24.948,20,25.5z M23,24.5c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S23.552,24.5,23,24.5z M15,24.5c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S15.552,24.5,15,24.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,16h8 M29,13h8 M37,19.003L29,19 M21,33h6c1.1,0,2-0.9,2-2V20c0-1.1-0.9-2-2-2H11c-1.1,0-2,0.9-2,2v11c0,1.1,0.9,2,2,2h6l4,6 M29,23h10V9H27v9 M31,33h4.001C36.105,33,37,32.105,37,31v-4 M33.828,30.171L31,33l2.828,2.828"
  }), props.children);
});
var TimeLapse =
/*#__PURE__*/
React.forwardRef(function TimeLapse(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.072 28L24 24 24 13"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,36h-6v-6 M33.001,36.001 C36.644,33.264,39,28.907,39,24c0-8.284-6.716-15-15-15S9,15.716,9,24s6.716,15,15,15"
  }), props.children);
});
var Time =
/*#__PURE__*/
React.forwardRef(function Time(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,24c0,8.284-6.716,15-15,15 S9,32.284,9,24S15.716,9,24,9S39,15.716,39,24z M24,12V9 M12,24H9 M24,39v-3 M36,24h3 M24,14v10l6.928,4"
  }), props.children);
});
var Toggle =
/*#__PURE__*/
React.forwardRef(function Toggle(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33,21H15 c-3.3,0-6-2.7-6-6v0c0-3.3,2.7-6,6-6h18c3.3,0,6,2.7,6,6v0C39,18.3,36.3,21,33,21z M39,33L39,33c0-3.3-2.7-6-6-6H15 c-3.3,0-6,2.7-6,6v0c0,3.3,2.7,6,6,6h18C36.3,39,39,36.3,39,33z M15,12c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3 S16.657,12,15,12z M33,30c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3C36,31.343,34.657,30,33,30z"
  }), props.children);
});
var TokyoCherryBlossom =
/*#__PURE__*/
React.forwardRef(function TokyoCherryBlossom(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 17.406L24 24.811M24 24.811L16.957 22.523M19.647 30.803L24 24.811M24 24.811L28.353 30.803M31.043 22.523L24 24.811M24 29.043L24 24.811M24 24.811L19.975 26.119M21.513 21.388L24 24.811M24 24.811L26.487 21.388M28.025 26.119L24 24.811"
  }), React.createElement("circle", {
    cx: "24",
    cy: "30.101",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "20.891",
    cy: "20.532",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "29.031",
    cy: "26.446",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18.969",
    cy: "26.446",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "27.109",
    cy: "20.532",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38.086,20.234 c-0.433-1.331-1.267-2.416-2.321-3.177c-1.076-0.777-2.382-1.213-3.739-1.208c-0.563,0.002-1.133,0.093-1.698,0.252 c-0.024-0.603-0.12-1.188-0.3-1.737c-0.422-1.282-1.241-2.38-2.312-3.156C26.67,10.452,25.389,10,24,10s-2.67,0.452-3.716,1.209 c-1.071,0.776-1.89,1.874-2.312,3.156c-0.181,0.549-0.276,1.134-0.3,1.737c-0.581-0.164-1.167-0.253-1.745-0.251 c-1.35,0.005-2.647,0.445-3.716,1.223c-1.043,0.76-1.868,1.839-2.298,3.16c-0.429,1.321-0.396,2.679,0.001,3.907 c0.407,1.258,1.198,2.377,2.287,3.174c0.466,0.341,0.993,0.613,1.56,0.822c-0.335,0.502-0.602,1.032-0.778,1.582 c-0.412,1.285-0.395,2.655,0.015,3.912c0.401,1.227,1.172,2.345,2.296,3.162c1.124,0.817,2.426,1.204,3.717,1.206 c1.322,0.002,2.63-0.405,3.725-1.195c0.469-0.338,0.89-0.755,1.264-1.229c0.364,0.461,0.772,0.87,1.226,1.203 c1.094,0.802,2.407,1.216,3.735,1.22c1.3,0.004,2.613-0.383,3.746-1.206c1.132-0.823,1.906-1.952,2.304-3.19 c0.406-1.264,0.418-2.641-0.006-3.929c-0.176-0.534-0.438-1.048-0.765-1.537c0.551-0.204,1.065-0.465,1.522-0.794 c1.1-0.793,1.9-1.914,2.315-3.175C38.481,22.934,38.519,21.566,38.086,20.234z"
  }), React.createElement("circle", {
    cx: "24",
    cy: "16.348",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "15.951",
    cy: "22.196",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19.025",
    cy: "31.658",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "28.975",
    cy: "31.658",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "32.049",
    cy: "22.196",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10L24 12.116M9.914 20.234L11.926 20.888M15.294 36.794L16.538 35.082M32.706 36.794L31.462 35.082M38.086 20.234L36.074 20.888"
  }), props.children);
});
var TokyoGates =
/*#__PURE__*/
React.forwardRef(function TokyoGates(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 20L34 20M14 18L34 18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 12L14 16 34 16 36 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 10L16 14 32 14 39 10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 20L24 16M18 24L18 16M30 24L30 16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 38L36 38M12 36L16 36 16 26 14 24 20 24 20 36 28 36 28 24 34 24 32 26 32 36 36 36"
  }), props.children);
});
var TokyoTemple =
/*#__PURE__*/
React.forwardRef(function TokyoTemple(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9L24 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19L28 19M30 15L18 15 24 12zM16 21c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2M34 27c0 1.105-.895 2-2 2H16c-1.105 0-2-.895-2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39L39 39M30 13v2c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19L24 21M26 19L26 21M28 17L28 21M22 19L22 21M20 17L20 21M18 25L30 25M24 25L24 27M26 25L26 27M28 25L28 27M30 23L30 27M22 25L22 27M20 25L20 27M18 23L18 27M16 31L32 31M22 31L22 33M24 31L24 33M26 31L26 33M28 31L28 33M30 31L30 33M32 29L32 33M20 31L20 33M18 31L18 33M16 29L16 33M22 37L22 39M24 37L24 39M26 37L26 39M28 37L28 39M30 37L30 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 39L14 37 34 37 34 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 35L32 39M20 37L20 39M18 37L18 39M16 35L16 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 26L14 27 34 27 34 26M12 32L12 33 36 33 36 32M16 20L16 21 32 21 32 20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36,33c0,1.105-0.895,2-2,2H14c-1.105,0-2-0.895-2-2"
  }), props.children);
});
var TokyoVolcano =
/*#__PURE__*/
React.forwardRef(function TokyoVolcano(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 37L21.667 37M26.333 37L32 37M21 33L26.667 33M14 35L34 35"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 24L28 25 26 24 24 25 22 24 20 25 18 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,33h-8l11.317-12.58c0.222-0.266,0.55-0.42,0.896-0.42h3.574c0.346,0,0.675,0.154,0.896,0.42L38,33h-9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.423,25.859C15.523,24.458,15,22.79,15,21c0-4.971,4.029-9,9-9s9,4.029,9,9c0,1.79-0.523,3.458-1.423,4.859"
  }), props.children);
});
var ToneAnalyzer =
/*#__PURE__*/
React.forwardRef(function ToneAnalyzer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M22.5,23.5c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5S21.724,23,22,23S22.5,23.224,22.5,23.5z M15,23 c-0.276,0-0.5,0.224-0.5,0.5S14.724,24,15,24s0.5-0.224,0.5-0.5S15.276,23,15,23z M34,12.5c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.276,12.5,34,12.5z M28,12.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5S28.276,12.5,28,12.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,39l-4-6h-4 c-1.1,0-2-0.9-2-2V21c0-1.1,0.9-2,2-2h15c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2h-7 M32,25l2-4h3c1.1,0,2-0.9,2-2v-8c0-1.1-0.9-2-2-2 H25c-1.1,0-2,0.9-2,2v7.999 M31,21h-3.009 M15,25.5c0,1.933,1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5 M34,18c0-1.657-1.343-3-3-3 c-1.657,0-3,1.343-3,3"
  }), props.children);
});
var Tools =
/*#__PURE__*/
React.forwardRef(function Tools(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.732,18.889l9.311-9.311c0.932-0.932,2.443-0.932,3.375,0l0,0c0.932,0.932,0.932,2.443,0,3.375l-9.311,9.311 M27.419,20.576 l9.282-9.282 M13.069,34.926l7.731-7.731 M9.115,37.137l1.743,1.743l3.228-2.936l-2.035-2.035L9.115,37.137z M27.495,31.031 c-0.79,2.131-0.329,4.62,1.383,6.333c1.847,1.847,4.599,2.238,6.83,1.173l0,0l-4.001-4.001c-0.778-0.778-0.778-2.051,0-2.828l0,0 c0.778-0.778,2.051-0.778,2.828,0l4.001,4.001l0,0c1.065-2.23,0.674-4.982-1.173-6.83c-1.712-1.712-4.202-2.173-6.333-1.383 L20.505,16.971c0.791-2.131,0.33-4.622-1.383-6.334c-1.847-1.847-4.599-2.238-6.83-1.173l0,0l4.001,4.001 c0.778,0.778,0.778,2.051,0,2.828l0,0c-0.778,0.778-2.051,0.778-2.828,0l-4.001-4.001l0,0c-1.065,2.23-0.674,4.982,1.173,6.83 c1.712,1.712,4.201,2.173,6.331,1.384L27.495,31.031z"
  }), props.children);
});
var Tornado =
/*#__PURE__*/
React.forwardRef(function Tornado(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.5,10h20 M11.5,14h20 M16.5,18h17 M19.5,22h17 M17.5,26h12 M21.5,30h12 M23.5,34h8 M21.5,38h4"
  }), props.children);
});
var Toronto =
/*#__PURE__*/
React.forwardRef(function Toronto(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 38c-.724 0-1.448-.333-2-1-.552.667-1.276 1-2 1-.724 0-1.448-.333-2-1-.552.667-1.276 1-2 1-.724 0-1.448-.333-2-1-.552.667-1.276 1-2 1-.724 0-1.448-.333-2-1-.552.667-1.276 1-2 1-.724 0-1.448-.333-2-1-.552.667-1.276 1-2 1M21 20L27 20 26 18 22 18zM21 20L27 20 26 22 22 22zM22 38L23 24M25 24L26 38M26 22c.552 0 1 .448 1 1s-.448 1-1 1h-4c-.552 0-1-.448-1-1s.448-1 1-1M23 14H25V18H23zM24 10L24 14M18.5 12.5L19.5 13.5M19.5 12.5L18.5 13.5M13 18L14 19M14 18L13 19M34 18L35 19M35 18L34 19"
  }), props.children);
});
var TouchGesture =
/*#__PURE__*/
React.forwardRef(function TouchGesture(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 36V24.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5V35M28 31.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5V35M31 32c0-.828.672-1.5 1.5-1.5S34 31.172 34 32v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 33L9 33 9 10 39 10 39 30M34 33c0-.828.672-1.5 1.5-1.5S37 32.172 37 33v5M22 38v-2.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5V38"
  }), props.children);
});
var TouchId =
/*#__PURE__*/
React.forwardRef(function TouchId(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.259,13.519C16.091,10.621,19.867,8.986,24.132,9c4.049,0.014,7.858,1.725,10.641,4.568 M35.215,18.205 c-2.406-3.653-6.545-6.064-11.247-6.064c-6.242,0-9.831,3.838-12.237,7.491 M35.065,33.425c-1.964-0.854-2.46-2.007-2.46-4.1 c0-2.648,0.649-2.517,0.649-5.828c0-3.84-3.382-8.33-9.286-8.33c-4.345,0-6.425,2.169-8.167,4.341 c-1.064,1.327-2.698,3.926-4.802,4.778 M33.173,35.859c-2.725-1.071-3.744-3.228-3.744-5.611c0-1.811,0.786-3.416,0.786-5.951 c0-2.774-2.357-6.091-6.246-6.091c-3.018,0-5.132,2.045-6.376,4.15c-1.45,2.454-3.801,5.025-6.593,6.056 M16.515,37.009 c2.979-1.976,5.252-3.817,7.454-5.924c1.808-1.73,3.342-3.98,3.342-6.269c0-1.708-1.196-3.553-3.342-3.553 c-2.859,0-4.486,4.567-6.487,6.523c-1.841,1.799-3.74,2.872-5.937,4.029 M13.823,35.025c3.95-2.431,7.973-5.819,10.166-9.936 M25.304,39c-0.126-1.404-1.04-2.807-2.674-2.807c-1.469,0-2.336,0.828-3.196,2.102 M26.627,31.542 c-0.241,0.607-0.342,1.336-0.342,1.883c0,1.611,0.97,3.422,2.943,4.63 M35.475,30.423C36.509,29.01,37,26.703,37,24.628 c0-1.332-0.13-2.682-0.835-4.185"
  }), props.children);
});
var TouchScreen =
/*#__PURE__*/
React.forwardRef(function TouchScreen(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,29H9V10h25v19h-7 M34,26h-7 M15,26H9 M30,29v8h9V21h-5 M30,34h9 M20.998,27.621c0-0.573-0.447-1.037-0.998-1.037s-0.998,0.464-0.998,1.037v2.378 l-0.005-6.962c0-0.573-0.447-1.037-0.998-1.037S17,22.464,17,23.037v5.882v4.924C17,36.139,18.792,38,21.002,38 S25,36.121,25,33.842v-5.04c0-0.573-0.447-1.037-0.998-1.037s-0.998,0.464-0.998,1.037v1.196l-0.005-1.935 c0-0.573-0.447-1.037-0.998-1.037s-1.002,0.464-1.002,1.037l0.004,1.935L20.998,27.621z"
  }), props.children);
});
var TouchSwipe =
/*#__PURE__*/
React.forwardRef(function TouchSwipe(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11,21l4,0 M13,19l-2,2l2,2 M25,21l-4,0 M23,23l2-2l-2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,29H9V10h25v19h-7 M34,26h-7 M15,26H9 M30,29v8h9V21h-5 M30,34h9 M20.998,27.621c0-0.573-0.447-1.037-0.998-1.037s-0.998,0.464-0.998,1.037v2.378 l-0.005-6.962c0-0.573-0.447-1.037-0.998-1.037S17,22.464,17,23.037v5.882v4.924C17,36.139,18.792,38,21.002,38 S25,36.121,25,33.842v-5.04c0-0.573-0.447-1.037-0.998-1.037s-0.998,0.464-0.998,1.037v1.196l-0.005-1.935 c0-0.573-0.447-1.037-0.998-1.037s-1.002,0.464-1.002,1.037l0.004,1.935L20.998,27.621z"
  }), props.children);
});
var Touch =
/*#__PURE__*/
React.forwardRef(function Touch(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21,15 c0-1.186,0.821-2,2-2h-0.003C24.176,13,25,13.814,25,15v8c0,0,4.663,0,6.913,0C34.162,23,36,24.541,36,26.776c0,0,0,2.758,0,4.01 C36,35.478,34.706,39,27.769,39c-4.829,0-7.104-2.056-10.134-5.48c-0.845-0.955-3.439-3.765-3.439-3.765 C13.365,28.819,12,27.415,12,26.985c0-1.299,3.219-2.011,4.792-0.803C18.008,27.116,21,30.5,21,30.5V15z M26.994,19.46 c1.23-1.09,2-2.69,2-4.46c0-3.31-2.69-6-6-6s-6,2.69-6,6c0,1.77,0.77,3.37,2,4.46"
  }), props.children);
});
var Tractor =
/*#__PURE__*/
React.forwardRef(function Tractor(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19,34 c0,2.761-2.239,5-5,5s-5-2.239-5-5s2.239-5,5-5S19,31.239,19,34z M21,34c0-3.866-3.134-7-7-7c-1.959,0-3.73,0.805-5,2.101 M14,31 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S15.657,31,14,31z M32,27c-2.761,0-5,2.239-5,5s2.239,5,5,5c2.761,0,5-2.239,5-5 S34.762,27,32,27z M32,25c-3.866,0-7,3.134-7,7s3.134,7,7,7s7-3.134,7-7S35.866,25,32,25z M37,27.103V22H11v5.675 M19,34h6.291 M21,34V22 M37,12H21v2h16V12z M21,22l2.144-8 M37,22l-0.889-8 M34.111,14L35,22 M29,25.676V14 M25,12V9 M13,22v-4h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,24h6 M23,24h2"
  }), props.children);
});
var TradeoffAnalytics =
/*#__PURE__*/
React.forwardRef(function TradeoffAnalytics(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8,24h32 M19,38h10 M24,24v14 M33,12c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S35.761,12,33,12z M12,18c-1.105,0-2,0.895-2,2 c0,1.105,0.895,2,2,2s2-0.895,2-2C14,18.896,13.105,18,12,18z M20,18c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2s2-0.895,2-2 C22,18.896,21.105,18,20,18z M16,12c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S17.105,12,16,12z"
  }), props.children);
});
var Train =
/*#__PURE__*/
React.forwardRef(function Train(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,31H14 V17c0-3.314,2.686-6,6-6h8c3.314,0,6,2.686,6,6V31z M32,17c0-2.209-1.791-4-4-4h-8c-2.209,0-4,1.791-4,4v6h16V17z M17.5,25 c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.328,25,17.5,25z M30.5,25c-0.828,0-1.5,0.672-1.5,1.5 s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S31.328,25,30.5,25z M19,9h10 M14,39l3.423-6 M34,39l-3.423-6"
  }), props.children);
});
var Transform =
/*#__PURE__*/
React.forwardRef(function Transform(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28,13l-6,4V9L28,13z M13,31c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S15.209,31,13,31z M39,25h-8v14h8V25z M17,35h11 M35,25 V13h-4 M22,13h-9v15.5"
  }), props.children);
});
var Trash =
/*#__PURE__*/
React.forwardRef(function Trash(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,39H14V13h20V39z M10,13h28 M29,9H19v4h10V9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,35V17 M29,35V17 M19,35V17"
  }), props.children);
});
var University =
/*#__PURE__*/
React.forwardRef(function University(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9v-3h30V39z M9,18h30L24,9L9,18z M37,33H11v3h26V33z M26,24h-4v6h4V24z M35,24h-4v6h4V24z M17,24h-4v6h4V24z M11,21h26 M24,11.5c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2S25.105,11.5,24,11.5z"
  }), props.children);
});
var UnlockAlt =
/*#__PURE__*/
React.forwardRef(function UnlockAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "29.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,29.5V33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".711",
    d: "M14 21H34V39H14z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,14 c0-2.761-2.239-5-5-5s-5,2.239-5,5v7"
  }), props.children);
});
var Unlock =
/*#__PURE__*/
React.forwardRef(function Unlock(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29,14 c0-2.761-2.239-5-5-5s-5,2.239-5,5v6.338"
  }), React.createElement("circle", {
    cx: "24",
    cy: "28.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34,29c0,5.523-4.477,10-10,10s-10-4.477-10-10s4.477-10,10-10S34,23.477,34,29z M24,28.5V32"
  }), props.children);
});
var UploadAlt =
/*#__PURE__*/
React.forwardRef(function UploadAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17,28H9V9h30v19h-8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,21l6-6l6,6 M24,39V15"
  }), props.children);
});
var Upload =
/*#__PURE__*/
React.forwardRef(function Upload(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,17V9h30v8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,23l6-6l6,6 M24,39V17"
  }), props.children);
});
var UserAnalytics =
/*#__PURE__*/
React.forwardRef(function UserAnalytics(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,32v5h21V11H18v3 M27,23c0,4.971-4.029,9-9,9s-9-4.029-9-9s4.029-9,9-9S27,18.029,27,23z M30,15h6 M30,18h6 M30,21h6 M36,37V24 h-4v13 M30,37v-6h-4v6 M24.687,29c-1.065-1.982-3.01-3.421-5.293-3.852c1.624-0.582,2.793-2.119,2.793-3.943 c0-2.322-1.882-4.204-4.204-4.204s-4.204,1.882-4.204,4.204c0,1.824,1.169,3.362,2.793,3.943c-2.283,0.431-4.193,1.87-5.258,3.852"
  }), props.children);
});
var UserInsights =
/*#__PURE__*/
React.forwardRef(function UserInsights(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.538,24.05c-1.283-1.27-1.283-3.329,0-4.599c1.283-1.27,3.318-1.27,4.601,0L24,20.302l0.86-0.851c1.283-1.27,3.319-1.27,4.602,0 c1.282,1.27,1.282,3.329,0,4.599L24,29.502L18.538,24.05z M36,15V9 M33,12h6 M12,39v-6 M9,36h6 M30,12H14c-1.1,0-2,0.9-2,2v16 M18,36h16c1.1,0,2-0.9,2-2V18"
  }), props.children);
});
var UserSearch =
/*#__PURE__*/
React.forwardRef(function UserSearch(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.999,13.609c5.739,3.313,7.705,10.651,4.392,16.39s-10.651,7.705-16.39,4.392s-7.705-10.651-4.392-16.39 S21.26,10.296,26.999,13.609z M39,34.391L31.394,30 M28,33.752l0-1.289c0-3.3-2.287-6.06-5.36-6.799 c1.4-0.628,2.378-2.028,2.378-3.662c0-2.219-1.799-4.019-4.019-4.019s-4.019,1.799-4.019,4.019c0,1.634,0.979,3.033,2.379,3.662 C16.286,26.403,14,29.163,14,32.463l0,1.283"
  }), props.children);
});
var Vancouver =
/*#__PURE__*/
React.forwardRef(function Vancouver(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20,26.006 c-1.105,0-2-0.895-2-2h20c0,1.105-0.895,2-2,2H20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 16.006L32 24.006M25 22.006L24 24.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 15.006L36 21.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 18.006L16 18.006 14 15 11 15 13 20.006 24 22.006 34 22.006 34 20.006 36 18.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 18.006L37 18.006M24 18.006c2.209-2.667 5.791-2.667 8 0v2h-7L24 18.006M15 37.006c-1.105 1.333-2.895 1.333-4 0M19 37.006c-1.105 1.333-2.895 1.333-4 0M23 37.006c-1.105 1.333-2.895 1.333-4 0M27 37.006c-1.105 1.333-2.895 1.333-4 0M31 37.006c-1.105 1.333-2.895 1.333-4 0M35 37.006c-1.105 1.333-2.895 1.333-4 0M39 37.006c-1.105 1.333-2.895 1.333-4 0M11 37.006c-.552.667-1.276 1-2 1M11 30.006c0-1.105.895-2 2-2s2 .895 2 2M11 32.006c-.552 0-1-.448-1-1 0-.552.448-1 1-1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15,30.006 c0-0.552,0.448-1,1-1c0.552,0,1,0.448,1,1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 30.006c.552 0 1 .448 1 1 0 .552-.448 1-1 1M18 30.006L17 30.006M18 32.006L11 32.006"
  }), props.children);
});
var VideoAlt =
/*#__PURE__*/
React.forwardRef(function VideoAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9 M39,10H9v22h30V10z M20.005,15.799l0,10.392l9-5.196L20.005,15.799z"
  }), props.children);
});
var VideoChat =
/*#__PURE__*/
React.forwardRef(function VideoChat(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M37,10.5c0,0.276-0.224,0.5-0.5,0.5S36,10.776,36,10.5s0.224-0.5,0.5-0.5S37,10.224,37,10.5z M34.5,10 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.776,10,34.5,10z M32.5,10c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S32.776,10,32.5,10z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39H9V9h30V39z M9,12h30 M35,39v-1c0-5.038-3.837-9.259-8.534-10.372c2.126-0.946,3.611-3.074,3.611-5.551c0-3.356-2.721-6.077-6.077-6.077 s-6.077,2.721-6.077,6.077c0,2.477,1.484,4.605,3.611,5.551C16.835,28.741,13,32.962,13,38v1"
  }), props.children);
});
var VideoPlay =
/*#__PURE__*/
React.forwardRef(function VideoPlay(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26,24l-9,5.181V18.789L26,24z M31,20v-7H9v22h22v-7l8,4.676v-17.32L31,20z"
  }), props.children);
});
var Video =
/*#__PURE__*/
React.forwardRef(function Video(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,35H9 V13h22l0,7l8-4.645l0,17.321L31,28L31,35z"
  }), props.children);
});
var Virus =
/*#__PURE__*/
React.forwardRef(function Virus(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.578,15.552c1.913-1.105,4.36-0.449,5.464,1.464c1.105,1.913,0.449,4.36-1.464,5.464 M22.918,24 c-1.104-1.913-3.55-2.568-5.463-1.464s-2.568,3.55-1.464,5.463s3.55,2.568,5.463,1.464S24.022,25.913,22.918,24z M33.31,18 c-0.552-0.956-1.775-1.284-2.732-0.732c-0.956,0.552-1.284,1.775-0.732,2.732c0.552,0.956,1.775,1.284,2.732,0.732 S33.862,18.957,33.31,18z M33.578,22.48c-1.732,1-3.714,1.567-4.58,2.067c-0.866,0.5-2.408,1.879-2.802,3.35 M36.775,16.016 l-1.732,1 M19.454,17.016v2 M22.283,17.348l0.466,1.945 M24.498,16.753l1,1.732 M27.681,16.827l-1.356-1.47 M28.376,27.9 l-1.451-1.376 M28.998,24.547l1,1.732 M32.121,25.395l-0.596-1.909 M14.954,18.222l1,1.732 M13.392,22.516l-1.732-1 M10.454,26.016 h2 M11.66,30.516l1.732-1 M14.954,33.81l1-1.732 M19.454,35.016v-2 M23.954,33.81l-1-1.732 M27.248,30.516l-1.732-1 M34.578,13.82 l-1,1.732 M31.578,13.016v2 M28.578,13.82l1,1.732 M34.578,24.212l-1-1.732 M36.775,22.016l-1.732-1 M37.578,19.016h-2 M21.187,19.234c-1.709-0.437-3.584-0.232-5.233,0.72c-3.348,1.933-4.495,6.214-2.562,9.562s6.214,4.495,9.562,2.562 c1.652-0.954,2.768-2.479,3.243-4.182 M21.197,19.237c1.471,0.394,3.436-0.251,4.302-0.751c0.866-0.5,2.348-1.933,4.08-2.933"
  }), props.children);
});
var Vision =
/*#__PURE__*/
React.forwardRef(function Vision(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.121,33.879l4.242-4.242 M29.635,18.366l4.515-4.515 M11.999,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S13.656,9,11.999,9 z M11.999,33c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3C14.999,34.343,13.656,33,11.999,33z M35.999,33 c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3C38.999,34.343,37.655,33,35.999,33z M11.999,35.001 c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S12.552,35.001,11.999,35.001z M35.999,9c-1.657,0-3,1.343-3,3s1.343,3,3,3 c1.657,0,3-1.343,3-3S37.655,9,35.999,9z M35.999,11.001c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1s1-0.448,1-1 C36.999,11.449,36.551,11.001,35.999,11.001z M24,19c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S26.761,19,24,19z M24,21.001 c-1.657,0-3,1.343-3,3s1.343,3,3,3c1.657,0,3-1.343,3-3S25.656,21.001,24,21.001z M13,24.002c0,0,3,7,11,7s11-7,11-7s-3-7-11-7 S13,24.001,13,24.002z"
  }), props.children);
});
var VisualInsights =
/*#__PURE__*/
React.forwardRef(function VisualInsights(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39.464,15l-6.928,0L36,9L39.464,15z M39,33h-6v6h6V33z M36,21c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S37.656,21,36,21z M25,23.992h8 M34.268,11.992H29v24h4 M24.956,29.004L21.011,25l-1.906,1.993l-5.101-4.996L9,27.002 M25,16H9v16h16V16z M19.5,18.999c-0.828,0-1.5,0.672-1.5,1.5c0,0.828,0.672,1.5,1.5,1.5c0.828,0,1.5-0.672,1.5-1.5 C21,19.671,20.328,18.999,19.5,18.999z"
  }), props.children);
});
var VisualRecognition =
/*#__PURE__*/
React.forwardRef(function VisualRecognition(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25,17c0,4.418-3.582,8-8,8s-8-3.582-8-8s3.582-8,8-8S25,12.582,25,17z M23.927,13H18v3.24h6.963 M24.746,19H14v3h9.244 M16,24.937 V39h23V16H24.936 M33,20c-1.105,0-2,0.895-2,2c0,1.105,0.895,2,2,2c1.105,0,2-0.895,2-2C35,20.896,34.104,20,33,20z M39,35l-5-5 l-3,3l-7-7l-8,8"
  }), props.children);
});
var WarningAlt =
/*#__PURE__*/
React.forwardRef(function WarningAlt(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.511,37 C12.021,34.408,9,29.557,9,24c0-8.284,6.716-15,15-15s15,6.716,15,15c0,5.557-3.022,10.408-7.512,13 M24,32V14"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37.5",
    r: "1"
  }), props.children);
});
var Warning =
/*#__PURE__*/
React.forwardRef(function Warning(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,37H9l15-26L39,37z M24,28V18"
  }), React.createElement("circle", {
    cx: "24",
    cy: "32",
    r: "1"
  }), props.children);
});
var Washer =
/*#__PURE__*/
React.forwardRef(function Washer(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37,39 H11V9h26V39z M24,18c-3.866,0-7,3.134-7,7s3.134,7,7,7s7-3.134,7-7S27.866,18,24,18z M28,12h6 M17.291,27h13.419"
  }), props.children);
});
var WashingtonDcCapitol =
/*#__PURE__*/
React.forwardRef(function WashingtonDcCapitol(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 34L30 34M16 36L32 36M39 22L9 22"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 25L9 25M36 31L36 29M36 28L36 26M38 31L38 29M38 28L38 26M36 24L36 23M32 24L32 23M24 15L24 14M26 15L26 14M22 15L22 14M26 18L26 17M28 18L28 17M24 18L24 17M22 18L22 17M20 18L20 17M16 24L16 23M12 24L12 23M34 31L34 29M34 28L34 26M32 31L32 29M32 28L32 26M24 32L24 28M18 32L18 25M22 32L22 25M26 32L26 25M28 32L28 25M30 32L30 25M14 31L14 29M14 28L14 26M16 31L16 29M16 28L16 26M12 31L12 29M12 28L12 26M10 31L10 29M10 28L10 26"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 25L24 22 30 25M30 19L18 19M29 16L19 16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 19L30 22M28 19L28 22M26 19L26 22M29 16L29 19M19 16L19 19M24 19L24 22M22 19L22 22M20 19L20 22M18 19L18 22M20 16c0-2.209 1.791-4 4-4s4 1.791 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9L24 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32L39 32M18 32L30 32M19.917 32L19.917 25"
  }), React.createElement("circle", {
    cx: "14",
    cy: "23.499",
    r: ".5"
  }), React.createElement("circle", {
    cx: "10",
    cy: "23.499",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34",
    cy: "23.499",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38",
    cy: "23.499",
    r: ".5"
  }), props.children);
});
var WashingtonDcMonument =
/*#__PURE__*/
React.forwardRef(function WashingtonDcMonument(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 38L22 13 24 9 26 13 26 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 30L18 38M32 30L32 38M14 30L14 38M36 30L36 38M28 30L28 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 38L39 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 30H20V32H18zM14 30H16V32H14z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 30L10 38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 30H12V32H10zM28 30H30V32H28zM32 30H34V32H32zM36 30H38V32H36z"
  }), props.children);
});
var WashingtonDc =
/*#__PURE__*/
React.forwardRef(function WashingtonDc(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 22L19 22"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 20L20 20M28 20L28 24M26 22L26 24M24 22L24 24M22 22L22 24M20 24L20 20M20 20c0-2.209 1.791-4 4-4s4 1.791 4 4M24 14L24 16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24L39 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 24L32 12 33 10 34 12 34 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 30c0-2.209 1.791-4 4-4s4 1.791 4 4M20 30c0-2.209 1.791-4 4-4s4 1.791 4 4M10 30c0-2.209 1.791-4 4-4s4 1.791 4 4M14 35c-1.105 1.333-2.895 1.333-4 0M18 35c-1.105 1.333-2.895 1.333-4 0M22 35c-1.105 1.333-2.895 1.333-4 0M26 35c-1.105 1.333-2.895 1.333-4 0M30 35c-1.105 1.333-2.895 1.333-4 0M34 35c-1.105 1.333-2.895 1.333-4 0M38 35c-1.105 1.333-2.895 1.333-4 0M16 32c-1.105 1.333-2.895 1.333-4 0M20 32c-1.105 1.333-2.895 1.333-4 0M24 32c-1.105 1.333-2.895 1.333-4 0M28 32c-1.105 1.333-2.895 1.333-4 0M32 32c-1.105 1.333-2.895 1.333-4 0M36 32c-1.105 1.333-2.895 1.333-4 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 18L14 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 18H16V20H14z"
  }), props.children);
});
var WatsonAvatar =
/*#__PURE__*/
React.forwardRef(function WatsonAvatar(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.001,18.664l2.973,1.716 M17.057,15.297l-1.716-2.973 M24,10.004v3.432 M32.66,12.325l-1.716,2.973 M36.026,20.38l2.973-1.716 M18.568,36.581c5.045,2.913,11.495,1.184,14.408-3.861c2.913-5.045,1.184-11.495-3.861-14.408 M29.115,18.312 c-2.509-1.448-5.365-1.749-7.961-1.065 M13.584,29.903c0.651,2.716,2.373,5.171,4.984,6.678 M29.114,18.314 c-2.249-1.299-6.433,1.737-9.345,6.781s-3.449,10.185-1.2,11.484 M20.813,19.735c-2.753-0.182-5.081,0.668-6.149,2.518 c-1.839,3.185,0.759,8.128,5.802,11.04s10.623,2.69,12.462-0.495"
  }), props.children);
});
var Weather =
/*#__PURE__*/
React.forwardRef(function Weather(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.698,38l2.309-4 h-2.309l2.309-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12.698 34l2.309-4M16.698 34l2.309-4M19.421 12.671c-.58-.22-1.093-.25-1.75-.25-2.899 0-5.25 2.35-5.25 5.25M17.671 10.545V9M14.108 11.5l-.773-1.338M10.162 13.335l1.338.773M21.233 11.5l.773-1.338M10.545 17.671H9M39 22.758C39 25.653 36.653 28 33.758 28H15.356C12.936 28 11 26.038 11 23.619c0-2.42 1.936-4.381 4.356-4.381.789 0 1.527.211 2.166.576C17.885 15.98 21.111 13 25.039 13c3.205 0 5.938 1.98 7.034 4.797.529-.18 1.094-.282 1.684-.282C36.653 17.516 39 19.863 39 22.758zM29.301 30.293L30.715 31.707M29.301 31.707L30.715 30.293M32.301 34.293L33.715 35.707M32.301 35.707L33.715 34.293M27.301 34.293L28.715 35.707M27.301 35.707L28.715 34.293M35.707 31.715L34.293 30.301M35.707 30.301L34.293 31.715"
  }), props.children);
});
var WebDeveloper =
/*#__PURE__*/
React.forwardRef(function WebDeveloper(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M27.49,11c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5S27.49,10.724,27.49,11z M24.99,10.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S25.266,10.5,24.99,10.5z M22.99,10.5 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S23.266,10.5,22.99,10.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24,28H9V9h20v11 M9,13 h20 M10.989,16h8 M10.99,19h8 M10.99,22h8 M39,40c0-4.625-3.156-8.495-7.42-9.638c1.731-0.926,2.91-2.751,2.91-4.852 c0-3.038-2.463-5.511-5.501-5.511s-5.501,2.473-5.501,5.511c0,2.101,1.179,3.925,2.91,4.852C22.133,31.505,19,35.375,19,40"
  }), props.children);
});
var Webcast =
/*#__PURE__*/
React.forwardRef(function Webcast(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39,39 H9 M39,10H9v22h30V10z M33,32l0-1h0c0-4.123-3.138-7.574-6.982-8.485c1.74-0.774,2.954-2.515,2.954-4.542 C28.973,15.226,26.746,13,24,13s-4.973,2.226-4.973,4.973c0,2.027,1.215,3.768,2.954,4.542C18.137,23.426,15,26.877,15,31h0l0,1"
  }), props.children);
});
var Wheat =
/*#__PURE__*/
React.forwardRef(function Wheat(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 11v20c0 2.761-2.239 5-5 5s-5-2.239-5-5V11M17 9v30M12 29.113L17 32l5-2.887M12 24.193l5 2.887 5-2.887M12 19.113L17 22l5-2.887M12 14.139l5 2.887 5-2.887M14.5 10v5.583M19.5 10v5.583M36 11v20c0 2.761-2.239 5-5 5s-5-2.239-5-5V11M31 9v30M26 29.113L31 32l5-2.887M26 24.193l5 2.887 5-2.887M26 19.113L31 22l5-2.887M26 14.139l5 2.887 5-2.887M28.5 10v5.583M33.5 10v5.583"
  }), props.children);
});
var Wifi =
/*#__PURE__*/
React.forwardRef(function Wifi(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,18.324 c3.953-3.617,9.217-5.824,14.998-5.824c5.782,0,11.049,2.209,15.002,5.828 M35.066,22.262c-2.944-2.617-6.821-4.207-11.07-4.207 c-4.246,0-8.121,1.588-11.064,4.202 M31.128,26.2c-1.93-1.616-4.416-2.589-7.13-2.589c-2.711,0-5.196,0.971-7.125,2.585 M24,29.496 c-1.658,0-3.002,1.344-3.002,3.002c0,1.658,1.344,3.002,3.002,3.002s3.002-1.344,3.002-3.002C27.002,30.84,25.658,29.496,24,29.496 z"
  }), props.children);
});
var WindPower =
/*#__PURE__*/
React.forwardRef(function WindPower(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.932,21.483c0.286,1.067-0.347,2.164-1.414,2.449c-1.067,0.286-2.164-0.347-2.449-1.414c-0.286-1.067,0.347-2.164,1.414-2.449 C24.549,19.783,25.646,20.416,25.932,21.483z M20.635,9.444l2.847,10.625 M14.808,31.193l7.778-7.778 M36.557,25.365 l-10.625-2.847 M24,26v11 M26,39c0-1.105-0.895-2-2-2s-2,0.895-2,2H26z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,39h30 M15.055,23 c0.077,0.694,0.232,1.363,0.457,2c0.137,0.389,0.301,0.765,0.488,1.128 M30.708,28.001c0.506-0.565,0.941-1.194,1.292-1.874 M26.996,13.511c-0.937-0.331-1.946-0.511-2.996-0.511 M31,31.748c0.145-0.104,0.287-0.211,0.426-0.321 c1.541-1.216,2.777-2.802,3.574-4.624 M30,11.606c-0.324-0.188-0.658-0.36-1-0.517c-1.522-0.699-3.216-1.088-5-1.088 c-0.337,0-0.67,0.014-1,0.041 M12.041,21C12.014,21.33,12,21.664,12,22.001c0,2.186,0.584,4.235,1.605,6 c0.125,0.216,0.257,0.428,0.395,0.636"
  }), props.children);
});
var Windows =
/*#__PURE__*/
React.forwardRef(function Windows(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,20V9h26v19h-4 M13,12h26 M35,20H9v19h26V20z M9,23h26"
  }), React.createElement("path", {
    d: "M37,10.5c0,0.276-0.224,0.5-0.5,0.5S36,10.776,36,10.5s0.224-0.5,0.5-0.5S37,10.224,37,10.5z M34.5,10 c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S34.776,10,34.5,10z M32.5,10c-0.276,0-0.5,0.224-0.5,0.5 s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S32.776,10,32.5,10z M32.5,21c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5C33,21.224,32.776,21,32.5,21z M30.5,21c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5C31,21.224,30.776,21,30.5,21z M28.5,21c-0.276,0-0.5,0.224-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5C29,21.224,28.776,21,28.5,21z"
  }), props.children);
});
var Windy =
/*#__PURE__*/
React.forwardRef(function Windy(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25,16 c0-2.209,1.791-4,4-4s4,1.791,4,4s-1.791,4-4,4H14 M18,32c0,2.209,1.791,4,4,4s4-1.791,4-4s-1.791-4-4-4H11 M31,28 c0,2.209,1.791,4,4,4s4-1.791,4-4s-1.791-4-4-4H9"
  }), props.children);
});
var Wine =
/*#__PURE__*/
React.forwardRef(function Wine(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13,25h6 v10h-6 M27,21l-1,6.485c0,2.495,2.005,4.518,4.5,4.518S35,29.98,35,27.485L34,21H27z M30.5,32.002V39 M34,39l-7,0 M26.05,27h8.9 M19,15.528V9h-3v6.528c0,2.375-3,2.6-3,6.911v15.233C13,38.406,13.675,39,14.508,39h5.985c0.833,0,1.508-0.594,1.508-1.327V22.439 C22.001,18.128,19,17.904,19,15.528z"
  }), props.children);
});
var WirelessHome =
/*#__PURE__*/
React.forwardRef(function WirelessHome(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9,24L24,9l0,0l15,15 M37,22v-5 M11,27v12 M37,27v12 M9,39h30 M32.635,27.361c-2.276-2.081-5.308-3.351-8.636-3.351 c-3.327,0-6.358,1.269-8.634,3.349 M30.525,29.48C28.789,27.937,26.503,27,23.998,27c-2.503,0-4.788,0.936-6.523,2.477 M28.4,31.598C27.209,30.601,25.674,30,23.999,30c-1.674,0-3.208,0.6-4.398,1.596"
  }), props.children);
});
var WirelessModem =
/*#__PURE__*/
React.forwardRef(function WirelessModem(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M14,33c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S14,32.448,14,33z M17,32c-0.552,0-1,0.448-1,1s0.448,1,1,1 s1-0.448,1-1S17.552,32,17,32z M21,32c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S21.552,32,21,32z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31,18v9 M38.925,12.076C36.836,10.165,34.054,9,30.999,9c-3.054,0-5.835,1.165-7.924,3.073 M36.8,14.205 C35.257,12.833,33.225,12,30.998,12c-2.225,0-4.256,0.832-5.798,2.202 M34.675,16.335C33.68,15.502,32.398,15,30.999,15 c-1.398,0-2.679,0.501-3.674,1.333 M39,27H9v12h30V27z"
  }), props.children);
});
var WreckingBall =
/*#__PURE__*/
React.forwardRef(function WreckingBall(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 20.986L18 17 15.999 17"
  }), React.createElement("path", {
    d: "M13,36c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1S13,35.448,13,36z M16,35c-0.552,0-1,0.448-1,1s0.448,1,1,1 c0.552,0,1-0.448,1-1S16.553,35,16,35z M20,35c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S20.552,35,20,35z M24,35 c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S24.553,35,24,35z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12,33l0-2H9V21h10v8h5l0,4 M35.001,28l-0.002-13 M16.999,23H11v4h5.998V23z M15,17c-1.055,0-2-0.688-2-2v-2 c0-1.055-0.548-1.994-1.86-1.994L11,11c-1.055,0-2-0.688-2-2 M15,14v-2.458C15,10.486,14.5,9,13,9 M9.5,13v1.11 C9.5,15.165,9.688,16,11,16 M27,36L27,36c0-1.65-1.35-3-3-3H12c-1.65,0-3,1.35-3,3v0c0,1.65,1.35,3,3,3h12 C25.65,39,27,37.65,27,36z M35,28c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S37.209,28,35,28z M37.254,30.916 c-0.263-0.546-0.72-0.982-1.28-1.22 M24,31h1.762L35,15 M21.389,29l10.899-15.565 M24.412,19.553L29,13 M21.412,19.553L26,13 M34.999,15l-2.711-1.565 M29.641,17.215l3.06,1.767 M30.469,22.848l-3.371-1.946 M24.212,24.968l3.775,2.179"
  }), props.children);
});
var Yoga_01 =
/*#__PURE__*/
React.forwardRef(function Yoga_01(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.936,18.998l-1.521,0.001c-0.573-0.004-1.55-1.074-2.406-1.074h-0.008h-0.008c-0.856,0-1.833,1.07-2.406,1.074l-1.521-0.001"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8,39h32 M20.002,21.999v2l-3.615,3.396c-0.577,0.675-0.497,1.7,0.178,2.277l4.25,3.941c0.675,0.577,2.224,0.497,2.8-0.178 c0.577-0.675,0.497-1.7-0.178-2.277l-2.572-2.551c0,0,2.03-1.931,2.136-2.037l0.996,0.429v10 M28.002,21.999v15 M24.002,21.999 h6.881h-0.04c0.689,0,1.247-1.084,1.247-1.773c0-0.332-0.13-0.634-0.342-0.858c0,0-1.119-1.288-2.196-2.404 c-1.11-1.184-2.681-1.957-4.297-2.224v0.003c1.05-0.467,1.783-1.518,1.783-2.742C27.038,10.343,25.657,9,24,9 s-3.036,1.343-3.036,3.001c0,1.224,0.733,2.274,1.783,2.742V14.74c-1.627,0.269-3.151,1.035-4.297,2.224 c-1.076,1.117-2.196,2.404-2.196,2.404c-0.212,0.224-0.342,0.525-0.342,0.858c0,0.689,0.558,1.773,1.247,1.773h-0.04H24.002 M24.001,21.999v-4.074 M24.002,37c0,1.105,0.895,2,2,2s2-0.895,2-2"
  }), props.children);
});
var Yoga_02 =
/*#__PURE__*/
React.forwardRef(function Yoga_02(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18,19 h-6.5c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5H19 M36.5,19c0.828,0,1.5-0.672,1.5-1.5S37.328,16,36.5,16l0,0H25.245 c1.082-0.482,1.837-1.646,1.837-2.907c0-1.708-1.384-3.093-3.092-3.093c-1.708,0-3.092,1.385-3.092,3.093 c0,1.261,0.755,2.425,1.837,2.907l0,0C21.145,16.335,20,17.642,20,19.27V26v-0.001l-9.202,9.202 c-0.661,0.588-0.721,1.61-0.134,2.272c0.588,0.662,1.61,0.722,2.271,0.134L22,29h8v7.5c0,0.828,0.672,1.5,1.5,1.5 s1.5-0.672,1.5-1.5v-8.891C33,26.724,32.276,26,31.391,26H27v-7H36.5z M8,38h32"
  }), props.children);
});
var Yoga_03 =
/*#__PURE__*/
React.forwardRef(function Yoga_03(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.365,13.123c0.892-0.27,1.899-0.098,2.665,0.547c1.204,1.014,1.359,2.813,0.345,4.018c-0.748,0.889-1.924,1.204-2.973,0.902 l0,0c1.501,0.356,2.593,1.801,2.593,3.412v6.227c-0.006,0.736,0.305,1.368,1.086,1.989L36.374,36.2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8,39h32 M21,19v-8.5 C21,9.672,20.328,9,19.5,9S18,9.672,18,10.5v14.714c0,4.562,3.739,6.501,3.739,6.501l13.136,7.084 c0.717,0.414,1.635,0.168,2.049-0.549s0.168-1.635-0.549-2.049 M17,27h-3c-1,0-2,1-2,2v8.5c0,0.828,0.672,1.5,1.5,1.5 s1.5-0.672,1.5-1.5V30h3"
  }), props.children);
});
var Yoga_04 =
/*#__PURE__*/
React.forwardRef(function Yoga_04(props, ref) {
  return React.createElement(Icon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8,39h32 M20.5,18v5.961l-7.533,12.563c-0.456,0.773-0.197,1.778,0.576,2.234s1.778,0.197,2.234-0.576l6.259-10.044 C22.5,27.5,23,27,23.999,27c1.001,0,1.501,0.5,1.953,1.135l6.163,10.064c0.456,0.773,1.461,1.032,2.234,0.576 c0.773-0.456,1.032-1.461,0.576-2.234l-7.424-12.563L27.499,18H35.5c0.828,0,1.5-0.672,1.5-1.5c0-0.828-0.672-1.5-1.5-1.5h-9.841 C26.467,14.463,27,13.544,27,12.5c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,1.044,0.533,1.963,1.342,2.5H12.5 c-0.828,0-1.5,0.672-1.5,1.5c0,0.828,0.672,1.5,1.5,1.5H20.5z"
  }), props.children);
});
export { ActiveServer, Advocate, Agriculture, AirConditioner, Airplane, Alarm, AlchemyDataNews, AlchemyLanguage, AlchemyLanguageAlphabetAExpanded, AlchemyVision, Americas, AmsterdamCanal, AmsterdamFarm, AmsterdamWindmill, Analyze, AnalyzesData, Apartment, Api, AppDeveloper, Apple, Application, Archive, AsiaAustralia, AugmentedReality, Austin, AutomateModularManagement, Automobile, Bag, Bangalore, Bee, BeijingMunicipal, BeijingTower, BerlinBrandenburg, BerlinCathedral, BerlinTower, Bicycle, Blockchain, Build, Building, Bulldozer, Bus, Cafe, Calendar, CalendarDate, CalendarEvent, Camera, Capitol, Care, Cell, ChartBar, ChartBubbleLine, ChartLine, ChartScatterplot, Cherries, ChipCircuit, ChipCredit, ChipDebit, CloudAnalytics, CloudAssets, CloudBuilderProfessionalServices, CloudComputing, CloudDataServices, CloudDownload, CloudEcosystem, CloudGuidelines, CloudManagedServices, CloudOracle, CloudPartners, CloudPlanning, CloudSap, CloudServices, CloudServicesPricing, CloudStorage, CloudStrategy, CloudTutorials, CloudUpload, CloudVmware, Cloudy, CloudyDewy, CloudyHazy, CloudyHumid, CloudyPartial, CloudyWindy, CoatHanger, CognosAnalytics, College, ConceptExpansion, ConceptInsights, Connect, Console, ConsoleWireless, Construct, Conversation, CopenhagenPlanetarium, CopenhagenSnekkja, CreditCard, Crop, CustomerService, DataBackup, DataInsights, DataProcessing, DataStorage, Delete, DeliverInsights, DeliveryTruck, DesignAndDevelopment_01, DesignAndDevelopment_02, Desktop, Devops, Dialogue, Digital, Dining, Dna, DoNot, Docker, Doctor, DocumentConversion, DoorHandle, Download, DownloadAlt, DubaiPalmIslands, DubaiSkyscraper, DublinBrewery, DublinCastle, DuplicateFile, Education, Electric, ElectricCharge, Elevator, Embed, Engine, EnterpriseDesignThinking, EnterpriseDesignThinkingAlt, Envelope, ErlenmeyerFlask, EscalatorDown, EscalatorUp, EuropeAfrica, ExpandHorz, ExpandUser, ExpandVert, Export, ExportAlt, Eye, FaceDissatisfied, FaceNeutral, FaceSatisfied, FaceVeryDissatisfied, FaceVerySatisfied, Factory, Farm, Faucet, Feedback, FileBackup, FileTransfer, FinancialConsultant, FinancialGain, FinancialNews, FireAlarm, FireExtinguisher, Firewall, FlowChart, FlowChartDetail, Fog, Folder, Forklift, FreeTrial, Fuel, Gear, GlobalBusinessServices, GlobalFinanceEuro, GlobalFinanceSterling, GlobalNetwork, GlobalTechnologyServices, Globe, GlobeLocations, Group, Hail, HailHeavy, HailMixed, Handicap, HandicapActive, HardDrive, HardDriveNetwork, HardIceCream, Hazy, Headphones, Heart, HeartHealth, HeatMap, HighFive, HomeFront, HomeGarage, HomeProfile, Hospital, Humid, Hurricane, HybridCloud, HybridCloudServices, IbmIx, IbmZ, Icon, Idea, Ideate, Innovate, Integration, Intelligence, Intercom, IotMunich, Java, Javascript, Justice, KeyUsers, KnowsDarkData, Language, LanguageTranslation, LanguageTranslationAlphabetAExpanded, Language_01, Language_02, Language_03, Language_04, Launch, Lightning, ListBullet, ListCheckbox, Location, Lock, LockAlt, LockedNetwork, LockedNetworkAlt, London, LondonBigBen, LondonExpandedBase, Lungs, MachineLearning_01, MachineLearning_02, MachineLearning_03, MachineLearning_04, MachineLearning_05, MachineLearning_06, MadridCathedral, MadridSkyscrapers, MadridStatue, Magnify, Marketplace, Mas, Maximize, Medical, MedicalCharts, MedicalStaff, Melbourne, Meter, MexicoCityAngelOfIndependence, MexicoCityMuseoSoumaya, Microorganisms, Microscope, MilanDuomoDiMilano, MilanSkyscrapers, Minimize, MobileAdd, MobileChat, MobileDevices, MobilePhone, MortarAndPestle, Moscow, Mqa, Multitask, Munich, NaturalLanguageClassifier, Network, NetworkServices, Networking_01, Networking_02, Networking_03, Networking_04, Networking_05, Nice, NightClear, NycBrooklyn, NycManhattan, NycManhattanAlt, Office, OilPump, OilRig, Overcast, PaperClip, Parliament, PartnerRelationship, Path, Pattern, Perfume, Person_01, Person_02, Person_03, Person_04, Person_05, Person_06, Person_07, Person_08, Person_09, PersonalityInsights, PetriCulture, PillBottle_01, Pills, Podcast, Police, Power, Presentation, Presenter, Price, Printer, PrivateNetwork, PrivateNetworkAlt, PrivateNetworkAlt_01, PrivateNetwork_01, Progress, Puzzle, Question, QuestionAndAnswer, Rainy, RainyHeavy, Rank, Receipt, Recycle, Refinery, Refresh, RelationshipExtraction, Renew, RenewTeam, Repeat, Report, Reset, ResetHybridCloud, ResetSettings, RetrieveAndRank, RichTextFormat, Robot, Robotics, Rome, SaasEnablement, SanFrancisco, SanFranciscoFog, SaoPaulo, SaoPauloExpandedBase, Satellite, SatelliteDish, Scale, Seattle, SecureData, SecureProfile, Security, SecurityShield, ServerRack, Servers, Shop, ShoppingCart, Shower, Singapore, SingleSignOn, Slider, Sneaker, Snow, SoftIceCream, SoftlayerEnablement, Solve, Spaceship, Speech, SpeechAlphabetAExpanded, SpeechToText, Speedometer, StairsPlanView, StationaryBicycle, Steel, SteeringWheel, Stethoscope, Strategy, StrategyDirect, StrategyMove, StrategyPlay, Streamline, Sunny, SunnyHazy, SupportServices, SwipeLeft, SwipeRight, Tags, Target, TargetArea, TelAviv, Telecom, Telephone, Television, TemperatureHigh, TemperatureLow, Tennis, TestTubes, TextToSpeech, Time, TimeLapse, Toggle, TokyoCherryBlossom, TokyoGates, TokyoTemple, TokyoVolcano, ToneAnalyzer, Tools, Tornado, Toronto, Touch, TouchGesture, TouchId, TouchScreen, TouchSwipe, Tractor, TradeoffAnalytics, Train, Transform, Trash, University, Unlock, UnlockAlt, Upload, UploadAlt, UserAnalytics, UserInsights, UserSearch, Vancouver, Video, VideoAlt, VideoChat, VideoPlay, Virus, Vision, VisualInsights, VisualRecognition, Warning, WarningAlt, Washer, WashingtonDc, WashingtonDcCapitol, WashingtonDcMonument, WatsonAvatar, Weather, WebDeveloper, Webcast, Wheat, Wifi, WindPower, Windows, Windy, Wine, WirelessHome, WirelessModem, WreckingBall, Yoga_01, Yoga_02, Yoga_03, Yoga_04 };